var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGerrbi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20.59 39.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11 {\n        stroke-width: 0px;\n      }\n\n      .cls-2, .cls-4 {\n        fill: none;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-12 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-13 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-14 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-15 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-16 {\n        clip-path: url(#clippath-7);\n      }\n\n      .cls-17 {\n        clip-path: url(#clippath-8);\n      }\n\n      .cls-18 {\n        clip-path: url(#clippath-6);\n      }\n\n      .cls-19 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-20 {\n        clip-path: url(#clippath-9);\n      }\n\n      .cls-21 {\n        clip-path: url(#clippath-60);\n      }\n\n      .cls-22 {\n        clip-path: url(#clippath-69);\n      }\n\n      .cls-23 {\n        clip-path: url(#clippath-20);\n      }\n\n      .cls-24 {\n        clip-path: url(#clippath-21);\n      }\n\n      .cls-25 {\n        clip-path: url(#clippath-24);\n      }\n\n      .cls-26 {\n        clip-path: url(#clippath-23);\n      }\n\n      .cls-27 {\n        clip-path: url(#clippath-22);\n      }\n\n      .cls-28 {\n        clip-path: url(#clippath-25);\n      }\n\n      .cls-29 {\n        clip-path: url(#clippath-44);\n      }\n\n      .cls-30 {\n        clip-path: url(#clippath-45);\n      }\n\n      .cls-31 {\n        clip-path: url(#clippath-40);\n      }\n\n      .cls-32 {\n        clip-path: url(#clippath-42);\n      }\n\n      .cls-33 {\n        clip-path: url(#clippath-41);\n      }\n\n      .cls-34 {\n        clip-path: url(#clippath-47);\n      }\n\n      .cls-35 {\n        clip-path: url(#clippath-43);\n      }\n\n      .cls-36 {\n        clip-path: url(#clippath-46);\n      }\n\n      .cls-37 {\n        clip-path: url(#clippath-48);\n      }\n\n      .cls-38 {\n        clip-path: url(#clippath-49);\n      }\n\n      .cls-39 {\n        clip-path: url(#clippath-84);\n      }\n\n      .cls-40 {\n        clip-path: url(#clippath-88);\n      }\n\n      .cls-41 {\n        clip-path: url(#clippath-86);\n      }\n\n      .cls-42 {\n        clip-path: url(#clippath-81);\n      }\n\n      .cls-43 {\n        clip-path: url(#clippath-83);\n      }\n\n      .cls-44 {\n        clip-path: url(#clippath-85);\n      }\n\n      .cls-45 {\n        clip-path: url(#clippath-80);\n      }\n\n      .cls-46 {\n        clip-path: url(#clippath-87);\n      }\n\n      .cls-47 {\n        clip-path: url(#clippath-82);\n      }\n\n      .cls-48 {\n        clip-path: url(#clippath-98);\n      }\n\n      .cls-49 {\n        clip-path: url(#clippath-89);\n      }\n\n      .cls-50 {\n        clip-path: url(#clippath-27);\n      }\n\n      .cls-51 {\n        clip-path: url(#clippath-28);\n      }\n\n      .cls-52 {\n        clip-path: url(#clippath-26);\n      }\n\n      .cls-53 {\n        clip-path: url(#clippath-29);\n      }\n\n      .cls-54 {\n        clip-path: url(#clippath-34);\n      }\n\n      .cls-55 {\n        clip-path: url(#clippath-35);\n      }\n\n      .cls-56 {\n        clip-path: url(#clippath-36);\n      }\n\n      .cls-57 {\n        clip-path: url(#clippath-37);\n      }\n\n      .cls-58 {\n        clip-path: url(#clippath-39);\n      }\n\n      .cls-59 {\n        clip-path: url(#clippath-33);\n      }\n\n      .cls-60 {\n        clip-path: url(#clippath-32);\n      }\n\n      .cls-61 {\n        clip-path: url(#clippath-30);\n      }\n\n      .cls-62 {\n        clip-path: url(#clippath-38);\n      }\n\n      .cls-63 {\n        clip-path: url(#clippath-31);\n      }\n\n      .cls-64 {\n        clip-path: url(#clippath-95);\n      }\n\n      .cls-65 {\n        clip-path: url(#clippath-99);\n      }\n\n      .cls-66 {\n        clip-path: url(#clippath-93);\n      }\n\n      .cls-67 {\n        clip-path: url(#clippath-94);\n      }\n\n      .cls-68 {\n        clip-path: url(#clippath-91);\n      }\n\n      .cls-69 {\n        clip-path: url(#clippath-96);\n      }\n\n      .cls-70 {\n        clip-path: url(#clippath-90);\n      }\n\n      .cls-71 {\n        clip-path: url(#clippath-92);\n      }\n\n      .cls-72 {\n        clip-path: url(#clippath-97);\n      }\n\n      .cls-73 {\n        clip-path: url(#clippath-53);\n      }\n\n      .cls-74 {\n        clip-path: url(#clippath-54);\n      }\n\n      .cls-75 {\n        clip-path: url(#clippath-50);\n      }\n\n      .cls-76 {\n        clip-path: url(#clippath-51);\n      }\n\n      .cls-77 {\n        clip-path: url(#clippath-52);\n      }\n\n      .cls-78 {\n        clip-path: url(#clippath-55);\n      }\n\n      .cls-79 {\n        clip-path: url(#clippath-56);\n      }\n\n      .cls-80 {\n        clip-path: url(#clippath-57);\n      }\n\n      .cls-81 {\n        clip-path: url(#clippath-58);\n      }\n\n      .cls-82 {\n        clip-path: url(#clippath-79);\n      }\n\n      .cls-83 {\n        clip-path: url(#clippath-61);\n      }\n\n      .cls-84 {\n        clip-path: url(#clippath-64);\n      }\n\n      .cls-85 {\n        clip-path: url(#clippath-62);\n      }\n\n      .cls-86 {\n        clip-path: url(#clippath-68);\n      }\n\n      .cls-87 {\n        clip-path: url(#clippath-67);\n      }\n\n      .cls-88 {\n        clip-path: url(#clippath-73);\n      }\n\n      .cls-89 {\n        clip-path: url(#clippath-59);\n      }\n\n      .cls-90 {\n        clip-path: url(#clippath-65);\n      }\n\n      .cls-91 {\n        clip-path: url(#clippath-63);\n      }\n\n      .cls-92 {\n        clip-path: url(#clippath-66);\n      }\n\n      .cls-93 {\n        clip-path: url(#clippath-70);\n      }\n\n      .cls-94 {\n        clip-path: url(#clippath-75);\n      }\n\n      .cls-95 {\n        clip-path: url(#clippath-72);\n      }\n\n      .cls-96 {\n        clip-path: url(#clippath-78);\n      }\n\n      .cls-97 {\n        clip-path: url(#clippath-71);\n      }\n\n      .cls-98 {\n        clip-path: url(#clippath-77);\n      }\n\n      .cls-99 {\n        clip-path: url(#clippath-74);\n      }\n\n      .cls-100 {\n        clip-path: url(#clippath-76);\n      }\n\n      .cls-101 {\n        clip-path: url(#clippath-14);\n      }\n\n      .cls-102 {\n        clip-path: url(#clippath-13);\n      }\n\n      .cls-103 {\n        clip-path: url(#clippath-12);\n      }\n\n      .cls-104 {\n        clip-path: url(#clippath-10);\n      }\n\n      .cls-105 {\n        clip-path: url(#clippath-15);\n      }\n\n      .cls-106 {\n        clip-path: url(#clippath-17);\n      }\n\n      .cls-107 {\n        clip-path: url(#clippath-16);\n      }\n\n      .cls-108 {\n        clip-path: url(#clippath-19);\n      }\n\n      .cls-109 {\n        clip-path: url(#clippath-11);\n      }\n\n      .cls-110 {\n        clip-path: url(#clippath-18);\n      }\n\n      .cls-4 {\n        clip-rule: evenodd;\n      }\n\n      .cls-5 {\n        fill: #ffc928;\n      }\n\n      .cls-5, .cls-6, .cls-7, .cls-11 {\n        fill-rule: evenodd;\n      }\n\n      .cls-6 {\n        fill: #ea2026;\n      }\n\n      .cls-7 {\n        fill: #fff;\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-111 {\n        clip-path: url(#clippath-144);\n      }\n\n      .cls-112 {\n        clip-path: url(#clippath-153);\n      }\n\n      .cls-113 {\n        clip-path: url(#clippath-157);\n      }\n\n      .cls-114 {\n        clip-path: url(#clippath-154);\n      }\n\n      .cls-115 {\n        clip-path: url(#clippath-158);\n      }\n\n      .cls-116 {\n        clip-path: url(#clippath-146);\n      }\n\n      .cls-117 {\n        clip-path: url(#clippath-142);\n      }\n\n      .cls-118 {\n        clip-path: url(#clippath-148);\n      }\n\n      .cls-119 {\n        clip-path: url(#clippath-141);\n      }\n\n      .cls-120 {\n        clip-path: url(#clippath-145);\n      }\n\n      .cls-121 {\n        clip-path: url(#clippath-143);\n      }\n\n      .cls-122 {\n        clip-path: url(#clippath-147);\n      }\n\n      .cls-123 {\n        clip-path: url(#clippath-149);\n      }\n\n      .cls-124 {\n        clip-path: url(#clippath-140);\n      }\n\n      .cls-125 {\n        clip-path: url(#clippath-151);\n      }\n\n      .cls-126 {\n        clip-path: url(#clippath-152);\n      }\n\n      .cls-127 {\n        clip-path: url(#clippath-156);\n      }\n\n      .cls-128 {\n        clip-path: url(#clippath-155);\n      }\n\n      .cls-129 {\n        clip-path: url(#clippath-159);\n      }\n\n      .cls-130 {\n        clip-path: url(#clippath-150);\n      }\n\n      .cls-131 {\n        clip-path: url(#clippath-181);\n      }\n\n      .cls-132 {\n        clip-path: url(#clippath-188);\n      }\n\n      .cls-133 {\n        clip-path: url(#clippath-180);\n      }\n\n      .cls-134 {\n        clip-path: url(#clippath-199);\n      }\n\n      .cls-135 {\n        clip-path: url(#clippath-198);\n      }\n\n      .cls-136 {\n        clip-path: url(#clippath-191);\n      }\n\n      .cls-137 {\n        clip-path: url(#clippath-190);\n      }\n\n      .cls-138 {\n        clip-path: url(#clippath-194);\n      }\n\n      .cls-139 {\n        clip-path: url(#clippath-192);\n      }\n\n      .cls-140 {\n        clip-path: url(#clippath-196);\n      }\n\n      .cls-141 {\n        clip-path: url(#clippath-195);\n      }\n\n      .cls-142 {\n        clip-path: url(#clippath-197);\n      }\n\n      .cls-143 {\n        clip-path: url(#clippath-193);\n      }\n\n      .cls-144 {\n        clip-path: url(#clippath-184);\n      }\n\n      .cls-145 {\n        clip-path: url(#clippath-183);\n      }\n\n      .cls-146 {\n        clip-path: url(#clippath-186);\n      }\n\n      .cls-147 {\n        clip-path: url(#clippath-187);\n      }\n\n      .cls-148 {\n        clip-path: url(#clippath-189);\n      }\n\n      .cls-149 {\n        clip-path: url(#clippath-182);\n      }\n\n      .cls-150 {\n        clip-path: url(#clippath-185);\n      }\n\n      .cls-151 {\n        clip-path: url(#clippath-113);\n      }\n\n      .cls-152 {\n        clip-path: url(#clippath-112);\n      }\n\n      .cls-153 {\n        clip-path: url(#clippath-111);\n      }\n\n      .cls-154 {\n        clip-path: url(#clippath-110);\n      }\n\n      .cls-155 {\n        clip-path: url(#clippath-115);\n      }\n\n      .cls-156 {\n        clip-path: url(#clippath-114);\n      }\n\n      .cls-157 {\n        clip-path: url(#clippath-116);\n      }\n\n      .cls-158 {\n        clip-path: url(#clippath-117);\n      }\n\n      .cls-159 {\n        clip-path: url(#clippath-118);\n      }\n\n      .cls-160 {\n        clip-path: url(#clippath-119);\n      }\n\n      .cls-161 {\n        clip-path: url(#clippath-105);\n      }\n\n      .cls-162 {\n        clip-path: url(#clippath-100);\n      }\n\n      .cls-163 {\n        clip-path: url(#clippath-102);\n      }\n\n      .cls-164 {\n        clip-path: url(#clippath-103);\n      }\n\n      .cls-165 {\n        clip-path: url(#clippath-107);\n      }\n\n      .cls-166 {\n        clip-path: url(#clippath-109);\n      }\n\n      .cls-167 {\n        clip-path: url(#clippath-104);\n      }\n\n      .cls-168 {\n        clip-path: url(#clippath-101);\n      }\n\n      .cls-169 {\n        clip-path: url(#clippath-108);\n      }\n\n      .cls-170 {\n        clip-path: url(#clippath-106);\n      }\n\n      .cls-171 {\n        clip-path: url(#clippath-161);\n      }\n\n      .cls-172 {\n        clip-path: url(#clippath-160);\n      }\n\n      .cls-173 {\n        clip-path: url(#clippath-166);\n      }\n\n      .cls-174 {\n        clip-path: url(#clippath-171);\n      }\n\n      .cls-175 {\n        clip-path: url(#clippath-172);\n      }\n\n      .cls-176 {\n        clip-path: url(#clippath-178);\n      }\n\n      .cls-177 {\n        clip-path: url(#clippath-174);\n      }\n\n      .cls-178 {\n        clip-path: url(#clippath-179);\n      }\n\n      .cls-179 {\n        clip-path: url(#clippath-170);\n      }\n\n      .cls-180 {\n        clip-path: url(#clippath-177);\n      }\n\n      .cls-181 {\n        clip-path: url(#clippath-176);\n      }\n\n      .cls-182 {\n        clip-path: url(#clippath-175);\n      }\n\n      .cls-183 {\n        clip-path: url(#clippath-173);\n      }\n\n      .cls-184 {\n        clip-path: url(#clippath-136);\n      }\n\n      .cls-185 {\n        clip-path: url(#clippath-138);\n      }\n\n      .cls-186 {\n        clip-path: url(#clippath-135);\n      }\n\n      .cls-187 {\n        clip-path: url(#clippath-132);\n      }\n\n      .cls-188 {\n        clip-path: url(#clippath-137);\n      }\n\n      .cls-189 {\n        clip-path: url(#clippath-130);\n      }\n\n      .cls-190 {\n        clip-path: url(#clippath-133);\n      }\n\n      .cls-191 {\n        clip-path: url(#clippath-134);\n      }\n\n      .cls-192 {\n        clip-path: url(#clippath-139);\n      }\n\n      .cls-193 {\n        clip-path: url(#clippath-131);\n      }\n\n      .cls-194 {\n        clip-path: url(#clippath-129);\n      }\n\n      .cls-195 {\n        clip-path: url(#clippath-122);\n      }\n\n      .cls-196 {\n        clip-path: url(#clippath-126);\n      }\n\n      .cls-197 {\n        clip-path: url(#clippath-125);\n      }\n\n      .cls-198 {\n        clip-path: url(#clippath-120);\n      }\n\n      .cls-199 {\n        clip-path: url(#clippath-121);\n      }\n\n      .cls-200 {\n        clip-path: url(#clippath-123);\n      }\n\n      .cls-201 {\n        clip-path: url(#clippath-124);\n      }\n\n      .cls-202 {\n        clip-path: url(#clippath-127);\n      }\n\n      .cls-203 {\n        clip-path: url(#clippath-128);\n      }\n\n      .cls-204 {\n        clip-path: url(#clippath-164);\n      }\n\n      .cls-205 {\n        clip-path: url(#clippath-165);\n      }\n\n      .cls-206 {\n        clip-path: url(#clippath-167);\n      }\n\n      .cls-207 {\n        clip-path: url(#clippath-162);\n      }\n\n      .cls-208 {\n        clip-path: url(#clippath-163);\n      }\n\n      .cls-209 {\n        clip-path: url(#clippath-168);\n      }\n\n      .cls-210 {\n        clip-path: url(#clippath-169);\n      }\n\n      .cls-211 {\n        clip-path: url(#clippath-226);\n      }\n\n      .cls-212 {\n        clip-path: url(#clippath-227);\n      }\n\n      .cls-213 {\n        clip-path: url(#clippath-225);\n      }\n\n      .cls-214 {\n        clip-path: url(#clippath-220);\n      }\n\n      .cls-215 {\n        clip-path: url(#clippath-228);\n      }\n\n      .cls-216 {\n        clip-path: url(#clippath-229);\n      }\n\n      .cls-217 {\n        clip-path: url(#clippath-222);\n      }\n\n      .cls-218 {\n        clip-path: url(#clippath-221);\n      }\n\n      .cls-219 {\n        clip-path: url(#clippath-224);\n      }\n\n      .cls-220 {\n        clip-path: url(#clippath-223);\n      }\n\n      .cls-221 {\n        clip-path: url(#clippath-218);\n      }\n\n      .cls-222 {\n        clip-path: url(#clippath-219);\n      }\n\n      .cls-223 {\n        clip-path: url(#clippath-213);\n      }\n\n      .cls-224 {\n        clip-path: url(#clippath-217);\n      }\n\n      .cls-225 {\n        clip-path: url(#clippath-216);\n      }\n\n      .cls-226 {\n        clip-path: url(#clippath-214);\n      }\n\n      .cls-227 {\n        clip-path: url(#clippath-215);\n      }\n\n      .cls-228 {\n        clip-path: url(#clippath-210);\n      }\n\n      .cls-229 {\n        clip-path: url(#clippath-212);\n      }\n\n      .cls-230 {\n        clip-path: url(#clippath-211);\n      }\n\n      .cls-231 {\n        clip-path: url(#clippath-209);\n      }\n\n      .cls-232 {\n        clip-path: url(#clippath-201);\n      }\n\n      .cls-233 {\n        clip-path: url(#clippath-208);\n      }\n\n      .cls-234 {\n        clip-path: url(#clippath-206);\n      }\n\n      .cls-235 {\n        clip-path: url(#clippath-205);\n      }\n\n      .cls-236 {\n        clip-path: url(#clippath-204);\n      }\n\n      .cls-237 {\n        clip-path: url(#clippath-207);\n      }\n\n      .cls-238 {\n        clip-path: url(#clippath-200);\n      }\n\n      .cls-239 {\n        clip-path: url(#clippath-230);\n      }\n\n      .cls-240 {\n        clip-path: url(#clippath-202);\n      }\n\n      .cls-241 {\n        clip-path: url(#clippath-203);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m9.2,3.32c.06-.38.18-.61.49-.83.1-.04.21-.14.32-.14v.97h-.81m1.39,0v-.97c.2.06.37.17.53.31.06.1.12.19.19.29.02.12.06.24.09.37h-.81Zm-1.31.48c-.03-.12-.08-.24-.08-.36.3,0,.61,0,.92,0,0-.37,0-.74,0-1.1.1-.03.26-.03.36,0v1.1c.3,0,.61,0,.92,0-.03.12-.06.24-.08.36h-2.04Zm.92.65c-.29-.06-.48-.16-.71-.34-.05-.07-.1-.14-.14-.2h1.9c-.18.25-.39.41-.69.5-.12,0-.24.02-.36.04ZM3.97,14.16c-.23-.09-.24-.28,0-.36h12.69c.2.06.22.3,0,.35-4.23,0-8.46,0-12.68.02Zm-.03-2.07s-.09-.06-.13-.1c-.05-.13,0-.19.1-.25h12.8c.18.06.12.29-.04.33-4.25,0-8.48,0-12.72.02Zm.02-.47c-.02-.06-.03-.11-.04-.15.08.02.16.03.24.06.16,0,.32-.03.46-.11.08-.06.16-.16.22-.24h.02c.32.34.71.41,1.15.31.1-.05.19-.1.3-.15.11-.11.28-.28.32-.45.1.12.19.24.29.36.17.12.37.23.58.27.21,0,.41,0,.6-.08.15-.09.28-.22.38-.36.36.42.88.55,1.4.34.08-.06.16-.12.25-.18.06-.08.11-.16.18-.24.09.32.47.45.75.53h.29c.23-.04.45-.15.63-.3.04-.05.08-.1.13-.15.12.17.23.28.41.38.09.02.18.04.27.06h.3c.11-.04.23-.07.35-.11.22-.15.38-.3.52-.53.06.1.11.19.17.3.39.39.91.42,1.39.19.08-.07.16-.14.24-.2.04.05.08.11.12.16.14.1.25.16.42.19.09,0,.18-.02.28-.02.03-.02.07-.02.11-.03-.02.05-.03.1-.04.15H3.95Zm10.84-.19c-.33-.11-.58-.21-.7-.55h.12c0,.11.15.23.21.3.08.04.16.08.24.12.44.08.78-.02,1-.41,0-.05.02-.1.04-.14.05,0,.11,0,.16.02,0,.11.02.19.06.29.33.48.93.28,1.13-.21,0,.22-.26.41-.43.51-.05,0-.1.02-.15.04-.11,0-.23-.02-.34-.02-.08-.06-.15-.11-.23-.15-.05-.1-.1-.19-.14-.28,0,0-.02,0-.02,0-.13.27-.41.39-.69.47-.1,0-.19,0-.28,0Zm-9.02-.53s-.06-.02-.08-.03c.02-.06.04-.12.06-.18-.15-.03-.41-.09-.45-.26.11-.18.2-.19.39-.22,0-.04,0-.08,0-.11-.02-.02-.05-.05-.06-.07.08,0,.17,0,.25.03v.28c.06.19.13.32.29.44-.09.09-.28.12-.4.13Zm8.97,0c-.11-.02-.23-.06-.32-.13.14-.11.2-.24.28-.39,0-.11,0-.21,0-.32.1-.02.16-.05.28-.03q-.06.06-.08.16c.18.04.27.06.37.23-.05.19-.26.22-.42.27,0,.09.02.12.06.17-.06,0-.12.02-.18.04Zm-7.41,0c-.12-.05-.22-.12-.33-.19,0-.05.05-.1.08-.13.02-.07.05-.15.08-.21,0-.11,0-.21.02-.32.06,0,.11,0,.17,0-.02.06-.02.11-.03.18.21.02.29.06.42.23-.04.18-.22.22-.37.25v.11s.05.04.07.06c-.04,0-.07.02-.11.02Zm5.85,0s-.02-.02-.02-.03c.02-.02.04-.04.06-.06,0-.04,0-.08,0-.11-.1-.03-.19-.06-.28-.08-.04-.06-.08-.11-.11-.16.04-.05.08-.1.12-.14.11-.05.2-.1.32-.1,0-.04,0-.08,0-.12-.02-.02-.03-.05-.04-.06.06,0,.13.02.2.02-.03.18-.03.31.04.48.03.06.06.11.11.17-.1.12-.27.16-.41.19Zm-3.74-.02s.03-.05.06-.07c0-.04,0-.08,0-.11-.19-.04-.31-.08-.41-.24.1-.15.22-.24.41-.24,0-.05,0-.16-.06-.16v-.02c.07,0,.15.02.22.03-.04.29.03.47.24.69-.1.03-.19.07-.28.11-.06,0-.12,0-.18.02Zm1.54,0c-.1-.05-.19-.09-.28-.13.11-.12.18-.23.24-.37v-.32c.07,0,.15-.02.22-.02-.06.06-.06.09-.05.18.19.02.32.07.38.26-.09.15-.23.17-.39.22v.11s.03.03.06.06c-.06,0-.11,0-.17.02Zm-7.21-.08s-.06-.06-.08-.08c.15-.15.19-.34.19-.55-.02-.07-.04-.15-.06-.22.09-.06.2.02.24.1-.05.02-.09.03-.13.05,0,.02,0,.03,0,.05.03.02.07.04.11.06.05.07.11.15.16.23-.05.07-.19.14-.28.16-.04.08,0,.11.03.19-.06,0-.13,0-.19.02Zm12.9,0s-.03-.02-.04-.02c.02-.03.03-.06.06-.09,0-.12-.21-.2-.3-.25.05-.08.1-.15.15-.23.06-.02.12-.05.12-.12-.04-.02-.08-.03-.12-.05,0-.08.18-.15.24-.1-.02.06-.04.13-.06.2,0,.27.03.33.19.56,0,.1-.16.08-.23.09Zm-13.31-.02s0-.09,0-.13c.09-.04.17-.12.24-.19.07-.32.02-.52-.32-.62-.2,0-.32.07-.43.25-.04,0-.08,0-.12.02,0-.2.21-.31.36-.38.08,0,.16,0,.25,0,.41.13.62.66.23.96-.07.03-.14.06-.2.1Zm13.86,0c-.07-.04-.28-.11-.29-.2-.21-.21-.11-.56.08-.75.06-.04.13-.07.19-.11.08,0,.16,0,.25,0,.05.02.11.03.16.05.1.1.23.19.25.34-.05,0-.09-.02-.13-.02-.11-.14-.17-.22-.35-.25-.23,0-.36.11-.44.31,0,.28.03.35.28.5,0,.04,0,.08,0,.13Zm-10.79,0c-.22-.09-.34-.19-.44-.41,0-.26,0-.4.21-.58.32-.16.56-.11.79.18.06.17.06.36,0,.53-.05.05-.1.11-.15.16-.14.08-.27.1-.42.11Zm3.77,0c-.11-.06-.21-.11-.31-.17-.05-.08-.09-.16-.13-.24,0-.06,0-.13,0-.19.06-.34.28-.49.62-.49.15.02.24.12.36.21.02.05.05.11.08.16,0,.1,0,.19,0,.29-.11.32-.31.39-.62.42Zm3.77,0c-.11-.06-.2-.11-.3-.16-.05-.09-.1-.18-.14-.26,0-.24.02-.34.17-.53.15-.11.26-.14.44-.14.31.05.46.3.46.6-.06.36-.28.45-.63.49Zm-1.82-.1c-.24-.11-.29-.33-.06-.5.11,0,.18-.02.28.05.02.03.04.06.06.1,0,.15,0,.25-.13.33-.05,0-.1.02-.15.02Zm3.64-.02c-.22-.06-.24-.25-.15-.43.04-.03.08-.06.13-.08.16,0,.23.03.31.17,0,.19-.02.26-.19.33-.03,0-.06,0-.09,0Zm1.48-.11c-.06-.04-.11-.07-.16-.11-.07-.15-.06-.24,0-.38.12-.12.19-.09.36-.11.09.06.15.11.18.21,0,.19,0,.23-.15.36-.07,0-.15.02-.21.02Zm.66-.58c-.12-.2-.24-.29-.47-.36h-.23c-.14.05-.24.11-.35.19,0-.25.19-.49.41-.56.02.07.05.15.07.22.03,0,.06.02.1.02.14-.06.24-.13.4-.16.15,0,.34-.02.49.04v.02c-.11.06-.22.11-.32.18-.06.06-.21.18-.14.28.05,0,.11.02.16.04-.04.02-.08.06-.11.09Zm-15.32,0s-.06-.06-.08-.08c.05-.02.1-.03.15-.04.13-.2-.47-.45-.47-.48.23-.06.5-.08.73.02.09.05.16.11.26.07.02-.07.05-.15.08-.22.18.04.3.24.38.38,0,.05,0,.11,0,.16-.06-.04-.11-.08-.16-.11-.22-.07-.41-.08-.62.02-.11.07-.16.15-.24.26-.02,0-.03,0-.04.02Zm3.29-.03s-.08-.06-.12-.1c-.11-.13-.23-.25-.14-.44.09.07.22.23.35.19-.06-.21-.11-.41-.02-.62.11.03.23.06.35.11.19.12.27.22.32.43.03,0,.07-.02.11-.02.05-.07.1-.14.15-.2.11.13.13.32.09.49-.08-.05-.16-.1-.24-.15-.36-.07-.59-.03-.81.29-.02,0-.03,0-.04.02Zm8.73,0c-.15-.3-.47-.38-.79-.32-.09.06-.18.11-.26.17-.11-.11,0-.41.08-.49.07.12.11.22.26.23,0-.35.4-.45.65-.53.08,0,.07.29.07.35-.02.08-.05.17-.06.26.03,0,.06,0,.1.02.03-.02.22-.23.26-.19,0,.08,0,.17,0,.26-.08.11-.19.2-.3.26Zm-4.86-.11c-.04-.12-.11-.3-.05-.42.04.04.08.09.13.14.03,0,.06,0,.11,0,.02-.27.11-.46.34-.58.24.19.25.28.32.58.11,0,.16-.06.23-.15,0,.14,0,.28-.04.41-.07-.06-.15-.11-.22-.16-.07-.02-.14-.05-.2-.06-.28,0-.42.05-.62.24Zm5.01-.45c.32-.49.83-.78,1.34-1.03.02-.07-.02-.19-.04-.27,0-.09,0-.17,0-.25.1-.49.32-.97.49-1.44.02-.16.04-.32.06-.47,0-.2-.02-.41-.02-.61,0-.06.02-.13.04-.19-.03-.08-.06-.16-.08-.24-.08-.08-.25-.31-.17-.41.38.57.39,1.21.29,1.86-.21.59-.69,1.46-.36,2.11-.21,0-.48.2-.64.29-.15.12-.56.37-.62.54h-.04s-.02-.06-.03-.08h-.02c-.06.06-.12.11-.18.18Zm-9-.02c-.11-.07-.18-.27-.22-.08h-.03c-.26-.28-.84-.83-1.25-.83.02-.15.06-.28.09-.42,0-.59-.29-1.13-.47-1.69-.02-.11-.04-.2-.06-.3,0-.49-.02-1.19.36-1.56,0,.02.02.04.03.06-.05.12-.11.26-.2.35-.02.04-.05.08-.06.13,0,.08,0,.17.02.26-.04.35-.02.7.02,1.05.11.41.3.81.44,1.21.02.1.04.19.06.29,0,.1-.02.2-.02.31-.02.08-.06.15,0,.23.45.17.83.49,1.17.83.04.06.08.11.13.17Zm4.09,0c-.16-.4-.37-.75-.7-1.02-.06-.04-.19-.16-.27-.16,0-.1.19-.26.24-.34.11-.2.23-.41.34-.61.07-.22.15-.43.22-.64.08-.48.15-.96.08-1.45-.06-.2-.12-.37-.23-.55-.11-.13-.23-.25-.34-.37-.19-.11-.36-.22-.54-.32-.16-.06-.32-.11-.47-.16-.15-.03-.3-.06-.45-.08-.19,0-.37,0-.56,0-.49.05-.87.15-1.3.39-.38.27-.57.51-.76.93-.03.11-.06.21-.08.32,0,.19,0,.37,0,.56.02.11.03.23.05.36.18.72.5,1.23,1.05,1.73.23.16.47.32.72.44-.03.05-.06.1-.08.15-.04.11-.08.22-.11.33-.02.11-.02.23-.03.35-.05-.1-.2-.18-.29-.23-.1-.03-.19-.06-.28-.08,0-.04.16-.16.19-.23,0-.08,0-.16,0-.24-.07-.19-.12-.26-.32-.32-.06,0-.11,0-.15,0,0-.08.02-.16.02-.24-.09-.27-.19-.34-.48-.36.09-.26,0-.42-.2-.57-.05-.02-.1-.03-.15-.04.17-.27.04-.66-.31-.66v-.03c.18-.18.11-.46-.05-.62-.05-.02-.1-.05-.15-.07.15-.07.19-.15.28-.29,0-.11-.02-.45-.19-.45v-.02s.08-.02.13-.02c.25-.11.32-.3.27-.57-.05-.06-.1-.12-.14-.18.02-.02.03-.03.05-.04.15.1.28.11.46.1.2-.1.24-.27.27-.49.02,0,.03-.02.06-.02.06.03.11.06.17.1.21.05.39,0,.52-.18.05-.12.07-.15.2-.15.02.02.05.06.07.09.17.11.41.12.57-.03.02-.04.05-.08.08-.12h.16c.07.11.13.15.25.19.21,0,.34-.02.46-.19.04,0,.08,0,.12.02,0,.02,0,.06.02.09.15.29.53.36.74.08h.03c.06.3.15.51.36.75.07.06.15.11.22.18.15.07.32.14.49.18-.12.06-.21.16-.24.29,0,.18.02.32.18.43v.03c-.14.14-.18.21-.18.42.02.11.11.19.19.27-.19.17-.26.34-.14.58.04.04.09.09.14.14-.23.15-.25.43-.1.63.03.02.06.06.1.09-.15.15-.19.22-.19.44.05.11.11.19.19.28-.28.24-.26.61.11.75-.05.03-.09.07-.13.11-.07.12-.14.22-.18.36Zm.83,0c-.04-.19-.15-.35-.31-.45.11-.06.23-.16.28-.28,0-.07,0-.14,0-.2-.04-.12-.09-.21-.19-.29.04-.05.09-.1.14-.15.08-.21.04-.36-.08-.53-.02-.02-.04-.03-.06-.04.04-.05.09-.1.14-.15.04-.13.05-.24.02-.38-.06-.06-.11-.13-.16-.19.06-.07.14-.14.18-.23,0-.07,0-.14,0-.2-.04-.12-.09-.21-.19-.29.05-.06.1-.11.15-.15.06-.21.03-.36-.1-.53-.02-.02-.03-.02-.05-.03.07-.05.14-.15.18-.22,0-.23,0-.36-.19-.5,0,0-.02-.02-.02-.02.19-.04.38-.11.54-.21.09-.1.19-.19.28-.28.05-.11.11-.21.16-.32.02-.11.03-.21.07-.3.1.05.17.16.29.19.27,0,.41-.08.49-.35.04,0,.08-.02.12-.02.11.18.28.19.49.18.09-.05.17-.12.23-.19.05,0,.1,0,.15,0,.06.11.13.16.24.23.08,0,.16,0,.24,0,.1-.04.19-.09.24-.17.04,0,.08,0,.13,0,.04.06.08.14.12.21.17.13.36.16.55.06.02-.02.03-.04.05-.06.03,0,.06,0,.11.02,0,.27.07.41.32.49.08,0,.16,0,.24,0,.05-.03.1-.06.15-.1.02,0,.03.02.06.03-.05.06-.1.13-.14.19,0,.03-.02.06-.02.1,0,.35.16.4.43.49-.16.08-.19.22-.22.39.03.2.15.26.29.36-.24.13-.32.26-.29.54.03.06.07.11.11.18-.36,0-.5.38-.32.66-.26.06-.36.18-.4.44.02.06.03.11.06.18-.31,0-.49.16-.49.47,0,.04.02.08.02.12-.18,0-.3,0-.41.16-.02.05-.05.1-.07.15,0,.18.03.36.2.44v.02c-.22.06-.42.12-.56.31-.02-.22-.06-.45-.14-.66-.03-.06-.06-.12-.09-.18.41-.19.77-.45,1.09-.79.14-.21.28-.41.42-.62.15-.36.26-.74.31-1.12v-.45c-.02-.19-.06-.47-.18-.62-.02-.04-.03-.08-.05-.12-.33-.47-.66-.66-1.17-.88-.16-.04-.32-.07-.48-.11-.39-.03-.79-.04-1.17.04-.13.03-.26.06-.38.11-.53.21-.9.48-1.2.97-.05.14-.1.28-.14.42,0,.23,0,.45,0,.68.06.52.16.98.37,1.46.15.29.39.56.53.83-.46.23-.79.71-.94,1.18h-.02Zm-1.09,0c-.27-.42-.62-.95-1.08-1.17v-.04c.31-.28.53-.63.71-1.01.07-.24.15-.48.22-.71.02-.19.04-.37.06-.55,0-.28,0-.54-.08-.8-.06-.15-.14-.3-.23-.44-.07-.08-.15-.16-.22-.23-.12-.09-.24-.17-.36-.25-.11-.11-.36-.16-.5-.2-.17-.03-.34-.06-.5-.08-.46,0-.85.06-1.28.23-.19,0-.29.08-.39.24-.32.27-.5.54-.61.96-.03.22-.02.45-.02.68.03.22.1.45.16.66.19.45.43.78.78,1.13.16.11.32.23.49.34.14.06.28.12.43.19-.08.15-.16.31-.24.47-.03.14-.1.44-.19.53,0-.32.02-.61.23-.88,0-.04,0-.09-.03-.12-.14-.07-.28-.15-.41-.21-.45-.27-.75-.66-1.05-1.08-.02-.04-.03-.08-.05-.12-.12-.15-.17-.45-.23-.64-.02-.14-.05-.28-.06-.41v-.4c0-.07.02-.14.02-.2.15-.55.42-.91.92-1.19.2-.08.41-.15.62-.23.16-.02.33-.05.5-.06.64,0,1.16.09,1.71.41.08.06.16.11.24.17.08.08.16.17.24.26.14.26.23.45.28.75v.5c-.06.63-.23,1.18-.52,1.74-.14.18-.28.36-.41.55,0,.03,0,.06,0,.1.19.06.41.29.56.44.12.17.23.35.32.53-.02.05-.05.1-.06.15Zm1.35,0c-.02-.06-.05-.11-.07-.15.11-.18.21-.39.35-.55.09-.09.18-.18.28-.26.1-.05.28-.13.28-.25-.15-.19-.28-.38-.42-.57-.09-.19-.18-.38-.27-.57-.21-.58-.29-1.23-.22-1.85.03-.11.07-.22.11-.32.07-.11.15-.23.22-.33.24-.24.51-.4.83-.55.19-.06.39-.11.59-.16.13-.02.26-.03.4-.04.3,0,.59,0,.88.08.17.06.35.12.53.19.09.06.18.11.28.17.12.11.24.24.36.36.06.12.14.24.21.37.11.45.15.81.06,1.26-.11.44-.28.84-.55,1.22-.11.11-.22.23-.32.34-.27.23-.57.41-.88.57-.05.12.06.24.11.34.02.1.05.19.08.3,0,.11,0,.22,0,.33-.02-.03-.05-.06-.06-.08-.05-.15-.1-.3-.14-.45-.03-.08-.06-.16-.09-.24-.19-.26-.13-.19.13-.32.19-.12.37-.24.57-.36.09-.09.18-.18.28-.26.06-.08.13-.15.2-.23.11-.19.21-.38.32-.57.11-.3.18-.6.23-.91v-.4c-.06-.48-.27-.83-.63-1.13-.07-.11-.13-.19-.27-.24-.04,0-.08,0-.12,0-.25-.16-.61-.19-.89-.23-.26,0-.52,0-.78.06-.17.04-.33.09-.49.14-.16.11-.32.21-.47.32-.2.2-.33.41-.45.66-.03.11-.06.21-.08.32,0,.17,0,.34,0,.52.02.16.03.32.05.49.11.53.31,1,.62,1.43.11.11.21.23.32.35,0,.02,0,.03,0,.05-.48.32-.78.71-1.08,1.17Zm-8.05-.1c-.07-.05-.13-.12-.19-.19-.06-.23-.02-.53.1-.73,0-.05-.02-.1-.02-.14-.28-.07-.52-.19-.76-.34-.14-.13-.28-.26-.41-.38-.15-.2-.32-.4-.4-.64-.04-.14-.08-.27-.12-.4-.03-.27-.03-.53.04-.79.08-.2.19-.37.3-.56.19-.19.39-.37.62-.52.13-.06.27-.11.41-.16.27-.05.53-.08.81-.08.24.02.55.03.79.11-.04.06-.07.14-.11.21-.19-.02-.37-.05-.55-.07h-.45c-.62.08-1.11.29-1.45.84-.03.06-.06.12-.09.19-.03.12-.06.24-.08.36,0,.32.05.61.16.92.08.17.2.33.31.49.28.32.58.49.96.68.09.02.18.05.28.08,0,.02,0,.06,0,.09-.12.32-.14.58-.14.93,0,.03.02.06.02.1Zm14.75-.02c.11-.32-.02-.74-.12-1.05,0-.1.28-.14.36-.16.07-.04.15-.07.23-.11.11-.08.23-.15.35-.23.12-.13.24-.26.36-.38.07-.13.15-.26.23-.39.05-.18.11-.36.16-.53,0-.14,0-.28,0-.41-.03-.14-.06-.28-.09-.41-.16-.33-.4-.58-.72-.76-.15-.06-.29-.11-.44-.16-.12-.02-.23-.04-.35-.06h-.47c-.19.02-.36.05-.54.07-.04-.07-.07-.15-.11-.22.52-.07.97-.12,1.49-.04.37.07.69.28.96.53.08.1.16.2.25.31.05.11.11.21.16.32.02.09.05.18.08.27,0,.14.02.28.02.41-.04.37-.18.71-.37,1.03-.1.11-.19.23-.29.35-.15.13-.33.28-.5.39-.18.06-.36.15-.55.2,0,.04-.02.08-.02.13.1.31.26.73-.1.91Zm-15.04-.04s-.06-.02-.1-.02c.02-.04.06-.07.09-.11.02.04.03.08.06.12h-.05Zm3.18,0c-.34-.37-.75-.72-1.22-.92,0-.02-.02-.02-.02-.03.02-.08.03-.15.05-.23,0-.36-.11-.79-.28-1.1,0-.02-.02-.05-.02-.07.05.05.1.1.15.15.06.02.12.03.19.06-.02.06-.05.11-.07.17v.21c.08.16.16.23.32.29.05,0,.1,0,.15,0-.02.03-.03.07-.04.11,0,.06,0,.14,0,.21.04.06.08.13.13.19.06.02.13.05.19.08h.15c0,.07-.02.15-.02.24.06.21.18.32.41.36-.02.09-.05.18-.06.27Zm8.97,0c-.02-.09-.04-.18-.06-.27.06-.02.12-.03.19-.05.03-.02.06-.04.1-.06,0-.05.02-.05.05-.07.02-.06.04-.11.06-.17,0-.08-.02-.16-.02-.24.06,0,.13,0,.2,0,.22-.11.28-.24.28-.48-.02-.04-.02-.08-.03-.11.19,0,.3-.06.42-.2.02-.06.03-.13.06-.19-.02-.07-.03-.14-.04-.2-.02-.03-.03-.06-.04-.09.15-.03.24-.11.33-.22-.14.39-.31.76-.31,1.18.02.08.04.17.06.26-.46.19-.94.53-1.26.92Zm3.14,0s.03-.08.06-.12c.02.03.05.06.08.1-.05,0-.1.02-.14.02Zm-16.11-.25c-.11-.11-.39-.15-.54-.15,0-.08-.02-.15-.02-.23,0-.02-.12-.27-.11-.31.06,0,.12,0,.19,0,0,.04-.02.09-.02.14.06.31.25.38.54.38,0,.06-.02.11-.02.18h-.02Zm16.94,0c0-.06,0-.12,0-.18.06,0,.12,0,.19,0,.19-.08.25-.12.33-.31,0-.07,0-.15,0-.22.06,0,.13,0,.2.02-.07.19-.13.32-.14.53-.19.03-.38.08-.57.15Zm-.78-.28c-.03-.12-.06-.24-.1-.36.36-.1.68-.31.97-.53.25-.28.46-.58.62-.92.05-.19.11-.38.13-.57,0-.14,0-.28,0-.41-.06-.32-.21-.62-.41-.88-.14-.13-.27-.25-.4-.37-.13-.07-.25-.15-.37-.21-.11-.04-.23-.08-.33-.11-.16-.02-.32-.05-.47-.06-.24,0-.49.02-.73.02.05-.06.1-.11.15-.16.11,0,.13,0,.22.06.03,0,.07.02.11.04h.19c.2-.06.26-.27.46-.06.06.02.13.04.19.06.06,0,.13-.02.2-.02.07-.05.11-.05.19-.06.05.06.1.11.15.18.07.02.15.05.22.08.07,0,.15-.02.22-.02.03.27.07.41.33.51h.24c-.16.27-.11.49.16.66v.02c-.19.12-.24.4-.1.58.03.02.1.07.1.11-.1.1-.17.15-.2.3,0,.06,0,.12,0,.19.02.05.05.1.08.15-.24,0-.48.35-.33.57-.23,0-.32.03-.45.22-.03.1-.03.2-.03.31-.31-.12-.61.19-.53.49-.22,0-.26,0-.44.12-.02.02-.03.05-.05.07Zm-13.69-1.84v-.02h.02v.02h-.02Zm0-.02v-.03h0v.03h0Zm-.02-.04c-.05-.14-.1-.27-.14-.4,0-.04,0-.08,0-.12.08.03.16.06.25.11-.09.15-.11.23-.11.41Zm12.05,0c0-.16-.02-.28-.11-.41.09-.02.18-.06.25-.11,0,.15-.09.36-.15.52Zm-12.25-1.09c0-.08.02-.16.03-.24.06.03.12.07.19.11-.08,0-.16.08-.22.13Zm12.44,0c-.05-.07-.11-.09-.18-.13.06-.04.11-.07.17-.11,0,.05.02.22,0,.24Zm-9.56-.46c-.45-.05-.91-.12-1.35-.2.02-.06.05-.11.07-.17.38.06.76.13,1.14.2.78.06,1.63-.06,2.37-.3.02.04.03.08.06.12-.11.03-.23.07-.34.11-.44.09-.89.17-1.34.21-.2,0-.41.02-.61.02Zm6.3,0c-.63-.07-1.27-.14-1.87-.35,0-.05.03-.08.05-.12.35.11.72.2,1.09.26.19.02.38.03.58.06.34,0,.68,0,1.01-.06.28-.06.55-.11.83-.16.02.06.05.11.08.17-.58.1-1.17.19-1.76.2Zm-6.21-.26c-.25-.03-.5-.06-.75-.1-.19-.04-.36-.08-.54-.11.03-.06.06-.11.11-.16h.11c.12.25.42.31.62.11.02,0,.06-.02.09-.02.08.25.58.26.64,0h.06s.03.06.06.1c.22.16.49.08.6-.15.09,0,.15.08.24.12.06,0,.11,0,.18,0,.13-.05.24-.12.28-.26.05-.02.11-.02.16-.03.06.06.12.14.19.21-.13.03-.26.07-.39.11-.34.05-.68.11-1.01.16-.22,0-.44,0-.65.02Zm6.12,0c-.3-.03-.59-.06-.88-.1-.26-.06-.52-.13-.77-.19.06-.07.12-.15.19-.21.06,0,.11.02.17.03,0,.11.14.21.23.25.06,0,.11,0,.18,0,.08-.03.15-.06.22-.13h.06c.11.19.19.24.43.24.05-.03.11-.06.16-.08.02-.04.05-.08.08-.11.02,0,.03,0,.06,0,0,.07.13.15.19.19.24,0,.3,0,.45-.19.02,0,.05,0,.08,0,.11.11.2.14.36.14.11-.04.21-.14.26-.23.03,0,.07,0,.11,0,.03.06.07.11.11.17-.42.07-.85.16-1.28.2-.14,0-.28,0-.41,0Zm-8.87-.23s0-.05.02-.06c.03.02.06.03.1.05-.04,0-.08,0-.11.02Zm-.19-.38s-.05-.02-.06-.02c.05-.04.11-.07.16-.11,0,.03-.02.07-.02.11-.02,0-.05,0-.07,0Zm12.35,0s-.02-.02-.03-.02c0-.03,0-.06,0-.1.06.03.11.06.17.1-.05,0-.09.02-.13.02ZM4.03,13.69c.21-.25.43-.5.65-.75-.23-.25-.45-.49-.66-.74.04,0,.08,0,.13,0,.17.19.52.51.64.75-.21.23-.42.46-.62.7-.05,0-.09.02-.13.02Zm3.91-.61c-.1-.13-.12-.19.02-.28.15,0,.16.06.16.2-.06.06-.11.06-.18.07Zm-2.56,0c-.07-.07-.09-.11-.07-.22.1-.06.15-.08.23,0,0,.15,0,.19-.16.21Zm1.05.08s-.1-.08-.14-.12v-.19s.05-.06.07-.09c.13-.04.47-.08.59,0,.02.02.04.06.06.09,0,.19.02.2-.11.3-.16,0-.32,0-.48.02Zm1.48.02c-.15-.11-.16-.14-.16-.32.05-.15.16-.17.31-.17.08.02.14.09.16.17,0,.15-.02.24-.14.3-.06,0-.11,0-.17.02Zm-2.57,0s-.06-.04-.09-.06c-.11-.14-.08-.19-.03-.35.14-.08.23-.12.37-.02.02.04.04.08.06.12v.12s-.06.09-.1.14c-.07,0-.15.02-.22.04Zm1.05.08c-.06-.04-.11-.07-.15-.11-.11-.24-.1-.43.16-.54.19,0,.46-.04.63.06.02.04.06.09.09.14,0,.06,0,.11.02.17-.02.13-.09.23-.22.27-.18,0-.36,0-.53.02Zm-.06.1c-.07-.05-.15-.09-.21-.13-.15-.3-.11-.62.24-.71h.62c.29.07.28.31.28.56-.04.13-.13.23-.27.27-.23,0-.45,0-.66.02Zm-.02.11c-.07-.04-.15-.07-.21-.11-.05-.07-.1-.14-.15-.2,0-.3-.05-.47.18-.67.06-.02.13-.05.19-.07.41,0,.91-.12,1.05.36,0,.13,0,.26,0,.4-.05.06-.1.13-.14.19-.06.02-.11.05-.16.08-.25,0-.5.02-.75.02Zm-2.02.22c.21-.24.42-.49.64-.72v-.03c-.22-.24-.44-.49-.65-.73h5.38c-.32.22-.81.49-1.08.75.35.23.7.47,1.05.71-1.78,0-3.57,0-5.35.02Zm1.23-2.26c-.11-.03-.21-.06-.31-.1-.07-.05-.15-.1-.22-.15v-.02h-.02c-.06-.08-.11-.15-.16-.23-.06.15-.14.27-.24.37-.4.27-.95-.03-1.07-.45.03.06.07.12.11.19.04.04.08.09.13.14.18.11.31.16.52.16.08-.04.16-.08.25-.11.13-.13.18-.28.22-.45.05,0,.11-.02.16-.02,0,.38.49.58.82.58.26-.05.45-.12.61-.33.02-.05.05-.09.07-.13.03,0,.07,0,.11,0-.1.3-.41.46-.7.53-.1,0-.19,0-.28,0Zm2.01,0c-.11-.03-.21-.06-.31-.1-.15-.1-.46-.28-.46-.49.02,0,.05-.02.08-.02,0,.09.17.26.23.32.06.03.11.06.18.11.47.15.95.05,1.09-.46.06,0,.13-.02.2-.02.12.22.28.37.49.49.13.02.26.04.4.06.32-.05.47-.22.64-.47.04,0,.09.02.14.03-.28.71-1.35.67-1.71.04h-.1c-.06.09-.11.18-.15.28-.24.18-.42.19-.72.23Zm3.58,0c-.33-.05-.62-.23-.75-.54.04-.02.09-.02.14-.03.23.41.62.58,1.07.39.2-.11.36-.28.46-.49.06,0,.14.02.21.02,0,.35.39.48.65.54.15,0,.31-.02.45-.08.19-.11.28-.25.41-.42.03,0,.06,0,.1.02-.06.12-.16.24-.24.34-.25.16-.45.24-.75.24-.2-.04-.4-.11-.54-.25-.03-.04-.06-.08-.08-.12-.06-.19-.12-.15-.21-.02-.06.06-.13.13-.19.19-.18.1-.33.16-.52.2-.06,0-.13,0-.19,0Zm-6.78-.24s.02-.03.02-.05v.04s-.02,0-.02,0Zm-.51-.08s-.21-.21-.17-.25c.02,0,.04.02.06.04.03.06.06.14.11.21Zm12.63,2.59c-.22-.25-.44-.5-.65-.75.19-.23.4-.45.6-.66.02-.03.03-.06.06-.08h.11s0,.02,0,.03c-.22.23-.44.48-.65.72.19.21.49.49.65.74h-.11Zm-6.17,0c-.36-.25-.71-.49-1.07-.74.36-.25.72-.49,1.09-.74.35.24.7.48,1.06.72,0,0,0,.02.02.03-.36.23-.73.48-1.09.72Zm-6.38-.04c-.16-.23-.32-.47-.49-.71.15-.23.32-.45.48-.67h.03c.19.22.4.44.6.66,0,.05-.58.66-.62.71Zm12.76-.02c-.19-.22-.4-.47-.61-.68.19-.23.4-.45.6-.68h.03c.15.22.32.44.48.66,0,.08-.42.6-.5.7Zm-.42-2.45s-.02-.03-.02-.05c0,.02,0,.03.02.05Zm.52-.08c.05-.08.08-.21.17-.25-.03.09-.11.19-.17.25Zm-6.92,2.59c-.36-.25-.71-.49-1.06-.74.36-.25.71-.5,1.08-.75h.24c-.36.24-.73.49-1.09.75.36.24.71.49,1.07.74h-.24Zm.68,0s.05-.05.07-.07c.32-.22.65-.44.97-.65,0-.02-.02-.03-.02-.05-.36-.24-.71-.48-1.05-.71.08,0,.16,0,.24,0,.35.24.7.48,1.05.72v.03c-.35.23-.7.47-1.04.7-.08,0-.15,0-.23.02Zm2.13-.61c.1-.13.12-.19-.02-.28-.15,0-.16.06-.16.2.06.06.11.06.18.07Zm2.56,0c.07-.07.09-.11.07-.22-.1-.06-.15-.08-.23,0,0,.15,0,.19.16.21Zm-1.05.08s.1-.08.14-.12v-.19s-.05-.06-.07-.09c-.13-.04-.47-.08-.59,0-.02.02-.04.06-.06.09,0,.19-.02.2.11.3.16,0,.32,0,.48.02Zm-1.48.02c.15-.11.16-.14.16-.32-.05-.15-.16-.17-.31-.17-.08.02-.14.09-.16.17,0,.15.02.24.14.3.06,0,.11,0,.17.02Zm2.57,0s.06-.04.09-.06c.11-.14.08-.19.03-.35-.14-.08-.23-.12-.37-.02-.02.04-.04.08-.06.12v.12s.06.09.1.14c.07,0,.15.02.22.04Zm-1.05.08c.06-.04.11-.07.15-.11.11-.24.1-.43-.16-.54-.19,0-.46-.04-.63.06-.02.04-.06.09-.09.14,0,.06,0,.11-.02.17.02.13.09.23.22.27.18,0,.36,0,.53.02Zm.06.1c.07-.05.15-.09.21-.13.15-.3.11-.62-.24-.71h-.62c-.29.07-.28.31-.28.56.04.13.13.23.27.27.23,0,.45,0,.66.02Zm.02.11c.07-.04.15-.07.21-.11.05-.07.1-.14.15-.2,0-.3.05-.47-.18-.67-.06-.02-.13-.05-.19-.07-.41,0-.91-.12-1.05.36,0,.13,0,.26,0,.4.05.06.1.13.14.19.06.02.11.05.16.08.25,0,.5.02.75.02Zm2.02.22c-.21-.24-.42-.49-.64-.72v-.03c.22-.24.44-.49.65-.73h-5.38c.32.22.81.49,1.08.75-.35.23-.7.47-1.05.71,1.78,0,3.57,0,5.35.02ZM9.96,2.25c.04-.13.08-.25.12-.37.02-.15.03-.28.06-.42-.23,0-.42.02-.64.09-.09.04-.18.08-.27.13.02-.09.04-.18.06-.27v-.27c0-.06-.07-.2-.05-.25.29.12.58.19.89.22,0-.23-.07-.65-.21-.83,0-.02-.02-.05-.02-.07.16.08.35.07.53.07.08-.02.16-.05.25-.06-.04.08-.08.17-.11.26-.06.21-.11.41-.13.62.32,0,.62-.09.9-.23-.02.09-.05.19-.06.28,0,.18.02.34.06.52-.31-.15-.55-.22-.89-.22.02.28.11.53.2.79-.06-.02-.12-.03-.18-.04-.18,0-.35,0-.52.04Zm-7.35,6.42c-.07-.07-.14-.14-.24-.19h-.23v-.13c-.04-.28-.27-.43-.55-.36,0-.1-.02-.19-.02-.28-.03-.05-.06-.1-.09-.14-.05-.03-.1-.06-.15-.1-.07,0-.15,0-.21,0v-.3c-.1-.17-.16-.23-.34-.27.02-.08.05-.15.08-.23,0-.2-.06-.3-.2-.44.22-.19.24-.49,0-.68.18-.12.26-.25.26-.47,0-.07-.06-.15-.1-.21h.24c.15-.06.25-.16.31-.32,0-.06,0-.11,0-.17.06-.06.17-.02.24,0,.17-.02.26-.13.36-.26.1.02.19.05.3.08.06,0,.13-.02.19-.02.12-.07.19-.18.34-.11.16.16.41.17.59.02.11,0,.15,0,.19.1.02.02.06.05.09.07-.41-.02-.84-.05-1.25.06-.28.09-.48.21-.72.37-.13.12-.26.25-.39.38-.07.11-.14.21-.2.32-.03.06-.06.13-.08.2-.03.13-.06.26-.08.4v.29c.11.72.48,1.28,1.08,1.72.21.12.43.23.66.3-.04.12-.07.24-.11.36Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.65,
    y1: 6.93,
    x2: 19.9,
    y2: 7.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cc9028"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c9962a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m10.21,10.77c-.11-.06-.21-.11-.31-.17-.05-.08-.09-.16-.13-.24,0-.06,0-.13,0-.19.06-.34.28-.49.62-.49.15.02.24.12.36.21.02.05.05.11.08.16,0,.1,0,.19,0,.29-.11.32-.31.39-.62.42"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 9.55,
    y: 9.48,
    width: 1.48,
    height: 1.49,
    transform: "translate(-3.93 7.36) rotate(-33.43)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 8.86,
    y: 8.8,
    width: 2.86,
    height: 2.86,
    transform: "translate(-3.93 7.36) rotate(-33.43)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m13.97,10.77c-.11-.06-.2-.11-.3-.16-.05-.09-.1-.18-.14-.26,0-.24.02-.34.17-.53.15-.11.26-.14.44-.14.31.05.46.3.46.6-.06.36-.28.45-.63.49"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.33,
    y: 9.48,
    width: 1.49,
    height: 1.49,
    transform: "translate(-3.3 9.38) rotate(-33.23)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 12.64,
    y: 8.8,
    width: 2.86,
    height: 2.86,
    transform: "translate(-3.3 9.38) rotate(-33.23)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m16.45,4.34s-.02-.02-.03-.02c0-.03,0-.06,0-.1.06.03.11.06.17.1-.05,0-.09.02-.13.02"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 16.39,
    y: 4.19,
    width: 0.21,
    height: 0.18,
    transform: "translate(-.28 7.3) rotate(-24.76)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 16.32,
    y: 4.11,
    width: 0.34,
    height: 0.34,
    transform: "translate(-.28 7.3) rotate(-24.75)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m12.94,4.74s.05-.03.07-.04c.04-.02.07-.04.12-.08,0-.02,0-.04,0-.06.01-.04.01-.07,0-.11,0,0,0-.02,0-.03-.03-.07-.07-.11-.13-.16h-.01s0,0,0,0c-.18,0-.26-.02-.33.16,0,.05,0,.08,0,.12,0,.01,0,.02,0,.04.02.04.04.07.07.1h0s0,0,0,0c.02.01.04.03.06.04h0s0,0,0,0c.02,0,.03.02.05.03.02,0,.03,0,.04,0,.02,0,.03,0,.05,0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 12.56,
    y: 4.15,
    width: 0.68,
    height: 0.68,
    transform: "translate(-.35 7.81) rotate(-33.25)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 12.24,
    y: 3.84,
    width: 1.31,
    height: 1.31,
    transform: "translate(-.35 7.81) rotate(-33.25)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m13.63,4.76l.02-.02h.05s.05-.05.06-.07h.01c.06-.11.07-.2.04-.27-.02-.04-.04-.08-.08-.12-.07-.03-.13-.04-.18-.03,0,0-.02,0-.03,0-.02.01-.05.03-.07.04-.02.01-.04.03-.05.05h0s0,0,0,0c-.09.12-.07.28.08.38h.03s.03.02.04.02h.04s.04,0,.04,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-14"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.21,
    y: 4.14,
    width: 0.73,
    height: 0.72,
    transform: "translate(-.19 8.39) rotate(-34.1)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-15"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 12.88,
    y: 3.81,
    width: 1.4,
    height: 1.4,
    transform: "translate(-.19 8.39) rotate(-34.12)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m14.32,4.7h.02s0,0,0,0c.21-.1.23-.27.11-.42h0s0-.01,0-.01c-.01-.02-.03-.03-.05-.05-.03,0-.05,0-.07,0-.13-.03-.2.03-.28.17,0,.1.02.16.05.2.03.05.08.09.16.11.02,0,.03,0,.05,0h.03Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-17"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.94,
    y: 4.08,
    width: 0.73,
    height: 0.73,
    transform: "translate(-.1 8.54) rotate(-33.15)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-18"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.6,
    y: 3.74,
    width: 1.4,
    height: 1.4,
    transform: "translate(-.1 8.54) rotate(-33.14)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m14.75,8.83c.2-.1.28-.2.23-.44-.11-.16-.28-.23-.46-.11-.14.2-.15.33.03.51.07,0,.14.02.2.04"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-20"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 14.24,
    y: 8.03,
    width: 0.92,
    height: 0.92,
    transform: "translate(-2.24 9.67) rotate(-33.98)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.82,
    y: 7.61,
    width: 1.78,
    height: 1.78,
    transform: "translate(-2.24 9.67) rotate(-33.99)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m15.21,8.24c.14-.03.2-.13.26-.24,0-.2-.05-.28-.23-.36-.27,0-.4.15-.34.42.04.13.2.17.32.19"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-23"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 14.72,
    y: 7.51,
    width: 0.86,
    height: 0.86,
    transform: "translate(-1.86 9.74) rotate(-33.7)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-24"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 14.32,
    y: 7.11,
    width: 1.65,
    height: 1.65,
    transform: "translate(-1.86 9.73) rotate(-33.68)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m15.65,7.64c.06-.04.12-.07.18-.11.13-.19.06-.44-.17-.5-.16,0-.23.04-.33.17,0,.19-.02.32.18.41.05,0,.1.02.15.02"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-26"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 15.19,
    y: 6.9,
    width: 0.89,
    height: 0.87,
    transform: "translate(-1.4 10.16) rotate(-34.57)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-27"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 14.78,
    y: 6.48,
    width: 1.7,
    height: 1.7,
    transform: "translate(-1.4 10.17) rotate(-34.58)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-28"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m15.99,6.95c.16-.11.24-.19.2-.4-.09-.18-.2-.21-.4-.19-.24.11-.24.41-.04.55.08,0,.16.02.23.03"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-29"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 15.45,
    y: 6.21,
    width: 0.89,
    height: 0.87,
    transform: "translate(-1.05 9.74) rotate(-33.03)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-30"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 15.05,
    y: 5.8,
    width: 1.68,
    height: 1.68,
    transform: "translate(-1.05 9.74) rotate(-33.02)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m16.26,6.23c.14-.08.18-.09.24-.24,0-.18-.06-.28-.22-.36h-.18c-.15.1-.2.18-.2.36.06.19.18.22.36.24"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-32"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 15.78,
    y: 5.52,
    width: 0.83,
    height: 0.83,
    transform: "translate(-.63 9.73) rotate(-32.82)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-33"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 15.4,
    y: 5.14,
    width: 1.58,
    height: 1.58,
    transform: "translate(-.63 9.73) rotate(-32.83)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-34"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m16.24,5.43c.06,0,.16-.08.21-.11.14-.21.04-.41-.16-.49-.17,0-.24.02-.35.17,0,.09,0,.18,0,.27.04.04.08.08.12.13.06,0,.11.02.17.04"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-35"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 15.82,
    y: 4.69,
    width: 0.88,
    height: 0.87,
    transform: "translate(-.06 10.06) rotate(-34.3)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-36"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 15.42,
    y: 4.29,
    width: 1.69,
    height: 1.68,
    transform: "translate(-.06 10.06) rotate(-34.3)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m16.07,4.64c.15-.09.22-.16.22-.36-.1-.24-.18-.23-.42-.23-.24.14-.21.41-.02.56.07,0,.15.02.22.02"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-38"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 15.53,
    y: 3.92,
    width: 0.87,
    height: 0.85,
    transform: "translate(.17 9.27) rotate(-32.54)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-39"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 15.14,
    y: 3.52,
    width: 1.64,
    height: 1.64,
    transform: "translate(.17 9.26) rotate(-32.52)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m15.47,3.96s.1-.06.15-.1c.12-.2.09-.4-.13-.5h-.19c-.08.04-.15.12-.19.21,0,.28.09.36.36.39"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-41"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 14.99,
    y: 3.24,
    width: 0.86,
    height: 0.85,
    transform: "translate(.56 9.17) rotate(-33.68)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-42"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 14.6,
    y: 2.84,
    width: 1.64,
    height: 1.64,
    transform: "translate(.56 9.17) rotate(-33.68)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-43"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m14.62,3.57c.21-.09.29-.17.26-.41-.08-.17-.27-.26-.45-.17-.24.24-.14.53.19.58"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-44"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 14.06,
    y: 2.76,
    width: 0.97,
    height: 0.95,
    transform: "translate(.67 8.67) rotate(-33.91)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-45"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.62,
    y: 2.31,
    width: 1.85,
    height: 1.85,
    transform: "translate(.67 8.67) rotate(-33.92)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-46"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m13.75,3.4c.15-.07.24-.17.24-.36-.02-.06-.06-.11-.09-.17-.15-.09-.28-.11-.43,0-.06.13-.11.24-.05.37.11.12.18.12.33.15"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-47"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.23,
    y: 2.64,
    width: 0.88,
    height: 0.88,
    transform: "translate(.54 7.97) rotate(-33.14)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-48"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 12.82,
    y: 2.23,
    width: 1.69,
    height: 1.69,
    transform: "translate(.54 7.97) rotate(-33.13)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-49"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m12.86,3.36c.11-.06.17-.11.22-.22,0-.3-.1-.38-.38-.38-.03.02-.07.04-.11.06-.11.22-.13.32.05.49.08,0,.15.02.23.04"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-50"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 12.34,
    y: 2.63,
    width: 0.85,
    height: 0.85,
    transform: "translate(.46 7.63) rotate(-33.86)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-51"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 11.95,
    y: 2.24,
    width: 1.63,
    height: 1.63,
    transform: "translate(.46 7.63) rotate(-33.87)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-52"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m11.96,3.53c.17-.08.24-.16.24-.36-.06-.19-.25-.31-.45-.21-.18.11-.19.33-.06.49.05.02.1.05.15.07.04,0,.08,0,.12,0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-53"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 11.43,
    y: 2.73,
    width: 0.9,
    height: 0.91,
    transform: "translate(.21 7.08) rotate(-33.47)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-54"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 11.01,
    y: 2.32,
    width: 1.75,
    height: 1.75,
    transform: "translate(.21 7.08) rotate(-33.45)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-55"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m12.23,10.67s.02-.01.03-.02h.05c.06-.05.09-.09.11-.14.03-.05.04-.12.02-.18v-.02s-.02-.02-.03-.04c0,0-.01-.02-.02-.02,0-.01-.02-.02-.02-.04-.04-.03-.08-.04-.11-.05-.05-.02-.1-.02-.14,0h-.02s-.02.02-.03.03c-.07.05-.12.14-.12.26.04.11.08.16.16.19.02.01.04.02.06.03h.03s.02,0,.03,0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-56"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 11.84,
    y: 10.06,
    width: 0.72,
    height: 0.72,
    transform: "translate(-3.72 8.41) rotate(-33.3)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-57"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 11.51,
    y: 9.73,
    width: 1.38,
    height: 1.38,
    transform: "translate(-3.72 8.42) rotate(-33.33)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-58"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m15.87,10.66c.16-.04.22-.15.21-.27,0-.02,0-.04,0-.07-.02-.03-.03-.05-.05-.07,0,0-.01-.02-.02-.03,0,0-.02-.01-.02-.01-.05-.04-.12-.06-.22-.06-.02,0-.03.02-.04.02-.02,0-.04.02-.07.03,0,0,0,.01-.01.02h0s-.03.08-.04.12c-.02.06-.01.12.01.17.03.07.09.12.18.14,0,0,.02,0,.02,0,.02,0,.03,0,.05,0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-59"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 15.49,
    y: 10.05,
    width: 0.7,
    height: 0.71,
    transform: "translate(-3.11 10.65) rotate(-34.03)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-60"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 15.16,
    y: 9.72,
    width: 1.36,
    height: 1.36,
    transform: "translate(-3.11 10.65) rotate(-34.03)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-61"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m17.43,10.55s.03-.01.04-.02h.02c.07-.06.11-.11.13-.16.02-.05.03-.1.02-.16v-.04s-.03-.08-.05-.11h0s-.02-.03-.03-.04c-.03-.02-.05-.04-.09-.07-.06,0-.11,0-.15,0h-.09s-.05.04-.07.06c-.01.01-.03.02-.04.04,0,.01,0,.02-.01.03-.04.07-.04.16-.03.28.01.02.02.03.03.05,0,0,0,.02.01.03.05.03.11.06.16.11.02,0,.05,0,.07,0,.02,0,.05,0,.07,0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-62"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 16.94,
    y: 9.85,
    width: 0.82,
    height: 0.82,
    transform: "translate(-2.79 11.14) rotate(-33.08)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-63"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 16.57,
    y: 9.47,
    width: 1.58,
    height: 1.57,
    transform: "translate(-2.79 11.14) rotate(-33.08)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-64"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m18.4,9.18c.24-.1.32-.36.13-.55-.24-.1-.37-.06-.49.18,0,.17.03.24.17.35.06,0,.13.02.19.02"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-65"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 17.92,
    y: 8.39,
    width: 0.92,
    height: 0.91,
    transform: "translate(-1.85 11.47) rotate(-33.07)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-66"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 17.5,
    y: 7.97,
    width: 1.76,
    height: 1.76,
    transform: "translate(-1.85 11.47) rotate(-33.07)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-67"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m18.89,8.67c.22-.09.26-.15.26-.4-.05-.11-.11-.16-.23-.21-.27,0-.36.13-.36.38.03.15.18.22.32.23"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-68"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 18.45,
    y: 7.95,
    width: 0.82,
    height: 0.83,
    transform: "translate(-1.46 11.95) rotate(-33.91)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-69"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 18.07,
    y: 7.57,
    width: 1.59,
    height: 1.59,
    transform: "translate(-1.46 11.95) rotate(-33.91)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-70"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m19.41,8.16c.13-.05.23-.1.28-.22,0-.22-.03-.28-.21-.39-.29,0-.37.1-.37.38.06.14.14.19.3.23"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-71"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 18.99,
    y: 7.44,
    width: 0.82,
    height: 0.83,
    transform: "translate(-1.08 12.17) rotate(-33.92)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-72"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 18.61,
    y: 7.06,
    width: 1.59,
    height: 1.59,
    transform: "translate(-1.08 12.16) rotate(-33.91)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-73"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m19.94,7.58c.43-.21.11-.79-.31-.52-.02.05-.05.1-.07.15,0,.2.03.26.2.36.06,0,.12,0,.18,0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-74"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 19.41,
    y: 6.63,
    width: 1.11,
    height: 1.11,
    transform: "translate(-.68 12.09) rotate(-33.16)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-75"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 18.9,
    y: 6.12,
    width: 2.13,
    height: 2.13,
    transform: "translate(-.68 12.09) rotate(-33.16)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-76"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m20.18,6.91s.07-.03.11-.05c.17-.17.19-.32.02-.5-.18-.07-.26-.07-.41.04-.06.12-.09.24-.03.37.04.03.08.06.11.1.07,0,.14.02.2.04"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-77"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 19.69,
    y: 6.15,
    width: 0.9,
    height: 0.89,
    transform: "translate(-.31 12.15) rotate(-33.32)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-78"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 19.29,
    y: 5.74,
    width: 1.71,
    height: 1.71,
    transform: "translate(-.31 12.15) rotate(-33.32)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-79"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m20.18,6.19s.08-.03.12-.05c.19-.15.21-.43-.04-.55h-.23s-.06.05-.09.07c-.11.19-.09.35.08.49.06,0,.11.02.16.04"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-80"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 19.72,
    y: 5.45,
    width: 0.91,
    height: 0.88,
    transform: "translate(.11 12.17) rotate(-33.66)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-81"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 19.31,
    y: 5.04,
    width: 1.72,
    height: 1.72,
    transform: "translate(.11 12.17) rotate(-33.66)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-82"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m20.15,5.43s.1-.06.14-.08c.2-.32-.07-.65-.41-.45-.02.04-.06.08-.09.13,0,.07,0,.15,0,.23.13.16.16.15.36.17"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-83"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 19.64,
    y: 4.57,
    width: 0.99,
    height: 1,
    transform: "translate(.57 12.01) rotate(-33.66)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-84"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 19.18,
    y: 4.11,
    width: 1.91,
    height: 1.91,
    transform: "translate(.57 12.01) rotate(-33.66)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-85"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m19.7,4.76c.27-.13.31-.4.06-.58-.29-.07-.47.11-.41.41.11.14.18.15.35.17"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-86"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 19.16,
    y: 3.96,
    width: 0.96,
    height: 0.94,
    transform: "translate(.81 11.55) rotate(-33.41)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-87"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 18.73,
    y: 3.52,
    width: 1.83,
    height: 1.83,
    transform: "translate(.81 11.55) rotate(-33.41)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-88"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m19.09,4.26c.22-.15.19-.11.21-.36-.08-.21-.23-.28-.45-.2-.15.15-.19.32-.06.49.03.02.06.04.1.06.06,0,.13,0,.19.02"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-89"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 18.54,
    y: 3.49,
    width: 0.89,
    height: 0.89,
    transform: "translate(.97 11.11) rotate(-33.41)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-90"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 18.14,
    y: 3.09,
    width: 1.7,
    height: 1.7,
    transform: "translate(.97 11.11) rotate(-33.41)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-91"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m16.71,4.22c.19-.1.26-.15.26-.38-.08-.22-.31-.3-.5-.15-.02.04-.05.08-.08.13,0,.17,0,.24.12.36.07.02.14.03.2.05"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-92"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 16.24,
    y: 3.43,
    width: 0.86,
    height: 0.89,
    transform: "translate(.68 9.97) rotate(-33.94)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-93"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 15.83,
    y: 3.03,
    width: 1.69,
    height: 1.69,
    transform: "translate(.68 9.97) rotate(-33.94)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-94"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m17.53,4.09s.07-.03.11-.05c.16-.16.16-.36-.02-.52-.23-.1-.41.02-.45.24,0,.11.04.18.11.26.04.02.08.03.11.06.05,0,.1,0,.15,0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-95"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 17.04,
    y: 3.31,
    width: 0.89,
    height: 0.9,
    transform: "translate(.82 10.24) rotate(-33.39)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-96"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 16.62,
    y: 2.9,
    width: 1.72,
    height: 1.72,
    transform: "translate(.82 10.24) rotate(-33.39)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-97"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m18.28,4.09c.15-.03.24-.11.28-.25,0-.34-.31-.48-.56-.23-.02.11-.06.2,0,.32.08.11.15.13.28.16"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-98"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 17.79,
    y: 3.25,
    width: 0.92,
    height: 0.95,
    transform: "translate(.95 10.63) rotate(-33.3)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-99"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 17.35,
    y: 2.83,
    width: 1.8,
    height: 1.8,
    transform: "translate(.95 10.63) rotate(-33.31)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-100"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m9.2,3.32c.06-.38.18-.61.49-.83.1-.04.21-.14.32-.14v.97h-.81"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-101"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 8.99,
    y: 2.21,
    width: 1.24,
    height: 1.26,
    transform: "translate(.27 6.48) rotate(-37.76)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-102"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 8.38,
    y: 1.61,
    width: 2.46,
    height: 2.46,
    transform: "translate(.27 6.48) rotate(-37.75)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-103"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m10.59,3.32v-.97c.2.06.37.17.53.31.06.1.12.19.19.29.02.12.06.24.09.37h-.81"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-104"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 10.38,
    y: 2.21,
    width: 1.24,
    height: 1.26,
    transform: "translate(.56 7.33) rotate(-37.76)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-105"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 9.77,
    y: 1.61,
    width: 2.46,
    height: 2.46,
    transform: "translate(.56 7.33) rotate(-37.75)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-106"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m9.28,3.8c-.03-.12-.08-.24-.08-.36.3,0,.61,0,.92,0,0-.37,0-.74,0-1.1.1-.03.26-.03.36,0v1.1c.3,0,.61,0,.92,0-.03.12-.06.24-.08.36h-2.04"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-107"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 8.99,
    y: 1.92,
    width: 2.62,
    height: 2.27,
    transform: "translate(-.36 4.4) rotate(-23.7)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-108"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 8.16,
    y: 0.95,
    width: 4.29,
    height: 4.2,
    transform: "translate(-.36 4.4) rotate(-23.7)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-109"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m10.21,4.45c-.29-.06-.48-.16-.71-.34-.05-.07-.1-.14-.14-.2h1.9c-.18.25-.39.41-.69.5-.12,0-.24.02-.36.04"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-110"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 9.32,
    y: 3.74,
    width: 1.97,
    height: 0.88,
    transform: "translate(-.59 1.93) rotate(-10.43)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-111"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 9.17,
    y: 3.39,
    width: 2.28,
    height: 1.58,
    transform: "translate(-.59 1.93) rotate(-10.43)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-112"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m7.65,4.74c-.24-.12-.26-.32-.05-.49.18,0,.26-.02.33.16,0,.18-.02.24-.18.32-.04,0-.07,0-.11,0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-113"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.3,
    y: 4.13,
    width: 0.73,
    height: 0.72,
    transform: "translate(-1.21 4.94) rotate(-33.24)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-114"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 6.97,
    y: 3.8,
    width: 1.39,
    height: 1.39,
    transform: "translate(-1.21 4.94) rotate(-33.25)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-115"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m6.96,4.76s-.1-.06-.15-.09c-.15-.23,0-.41.25-.41.21.11.24.35.04.48-.05,0-.1.02-.15.02"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-116"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 6.59,
    y: 4.12,
    width: 0.8,
    height: 0.77,
    transform: "translate(-1.33 4.67) rotate(-33.97)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-117"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 6.23,
    y: 3.75,
    width: 1.52,
    height: 1.52,
    transform: "translate(-1.33 4.67) rotate(-33.97)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-118"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m6.28,4.7c-.2-.1-.27-.24-.12-.44.21-.11.3-.06.41.12,0,.23-.09.27-.28.32"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-119"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5.9,
    y: 4.05,
    width: 0.76,
    height: 0.76,
    transform: "translate(-1.4 4.19) rotate(-33.38)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-120"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5.56,
    y: 3.7,
    width: 1.45,
    height: 1.45,
    transform: "translate(-1.4 4.19) rotate(-33.39)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-121"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m5.84,8.83c-.2-.1-.28-.2-.23-.44.11-.16.28-.23.46-.11.14.2.15.33-.03.51-.07,0-.14.02-.2.04"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-122"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5.43,
    y: 8.03,
    width: 0.92,
    height: 0.92,
    transform: "translate(-3.74 4.74) rotate(-33.99)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-123"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5,
    y: 7.61,
    width: 1.78,
    height: 1.78,
    transform: "translate(-3.74 4.74) rotate(-33.99)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-124"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m5.38,8.24c-.14-.03-.2-.13-.26-.24,0-.2.05-.28.23-.36.27,0,.4.15.34.42-.04.13-.2.17-.32.19"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-125"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5.01,
    y: 7.51,
    width: 0.86,
    height: 0.86,
    transform: "translate(-3.49 4.35) rotate(-33.68)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-126"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 4.61,
    y: 7.11,
    width: 1.65,
    height: 1.65,
    transform: "translate(-3.49 4.35) rotate(-33.68)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-127"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m4.94,7.64c-.06-.04-.12-.07-.18-.11-.13-.19-.06-.44.17-.5.16,0,.23.04.33.17,0,.19.02.32-.18.41-.05,0-.1.02-.15.02"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-128"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 4.52,
    y: 6.9,
    width: 0.89,
    height: 0.87,
    transform: "translate(-3.28 4.11) rotate(-34.57)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-129"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 4.11,
    y: 6.48,
    width: 1.7,
    height: 1.7,
    transform: "translate(-3.28 4.11) rotate(-34.58)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-130"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m4.6,6.95c-.16-.11-.24-.19-.2-.4.09-.18.2-.21.4-.19.24.11.24.41.04.55-.08,0-.16.02-.23.03"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-131"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 4.25,
    y: 6.21,
    width: 0.89,
    height: 0.87,
    transform: "translate(-2.86 3.63) rotate(-33.03)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-132"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3.85,
    y: 5.8,
    width: 1.69,
    height: 1.68,
    transform: "translate(-2.86 3.63) rotate(-33.02)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-133"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m4.33,6.23c-.14-.08-.18-.09-.24-.24,0-.18.06-.28.22-.36h.18c.15.1.2.18.2.36-.06.19-.18.22-.36.24"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-134"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3.98,
    y: 5.52,
    width: 0.83,
    height: 0.83,
    transform: "translate(-2.52 3.33) rotate(-32.85)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-135"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3.6,
    y: 5.14,
    width: 1.58,
    height: 1.58,
    transform: "translate(-2.52 3.33) rotate(-32.83)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-136"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m4.36,5.43c-.06,0-.16-.08-.21-.11-.14-.21-.04-.41.16-.49.17,0,.24.02.35.17,0,.09,0,.18,0,.27-.04.04-.08.08-.12.13-.06,0-.11.02-.17.04"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-137"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3.89,
    y: 4.69,
    width: 0.88,
    height: 0.87,
    transform: "translate(-2.14 3.33) rotate(-34.3)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-138"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3.49,
    y: 4.29,
    width: 1.69,
    height: 1.68,
    transform: "translate(-2.14 3.33) rotate(-34.3)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-139"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m4.52,4.64c-.15-.09-.22-.16-.22-.36.1-.24.18-.23.42-.23.24.14.21.41.02.56-.07,0-.15.02-.22.02"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-140"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 4.19,
    y: 3.92,
    width: 0.87,
    height: 0.85,
    transform: "translate(-1.61 3.17) rotate(-32.54)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-141"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3.81,
    y: 3.52,
    width: 1.64,
    height: 1.64,
    transform: "translate(-1.61 3.17) rotate(-32.52)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-142"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m5.12,3.96s-.1-.06-.15-.1c-.12-.2-.09-.4.13-.5h.19c.08.04.15.12.19.21,0,.28-.09.36-.36.39"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-143"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 4.74,
    y: 3.24,
    width: 0.86,
    height: 0.85,
    transform: "translate(-1.16 3.48) rotate(-33.68)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-144"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 4.35,
    y: 2.84,
    width: 1.64,
    height: 1.64,
    transform: "translate(-1.16 3.48) rotate(-33.68)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-145"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m5.98,3.57c-.21-.09-.29-.17-.26-.41.08-.17.27-.26.45-.17.24.24.14.53-.19.58"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-146"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5.56,
    y: 2.76,
    width: 0.97,
    height: 0.95,
    transform: "translate(-.78 3.92) rotate(-33.91)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-147"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5.12,
    y: 2.31,
    width: 1.85,
    height: 1.85,
    transform: "translate(-.78 3.92) rotate(-33.92)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-148"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m6.84,3.4c-.15-.07-.24-.17-.24-.36.02-.06.06-.11.09-.17.15-.09.28-.11.43,0,.06.13.11.24.05.37-.11.12-.18.12-.33.15"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-149"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 6.48,
    y: 2.64,
    width: 0.88,
    height: 0.88,
    transform: "translate(-.56 4.29) rotate(-33.14)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-150"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 6.08,
    y: 2.23,
    width: 1.69,
    height: 1.69,
    transform: "translate(-.56 4.28) rotate(-33.13)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-151"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m7.73,3.36c-.11-.06-.17-.11-.22-.22,0-.3.1-.38.38-.38.03.02.07.04.11.06.11.22.13.32-.05.49-.08,0-.15.02-.23.04"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-152"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.4,
    y: 2.63,
    width: 0.85,
    height: 0.85,
    transform: "translate(-.38 4.88) rotate(-33.86)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-153"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.01,
    y: 2.24,
    width: 1.63,
    height: 1.63,
    transform: "translate(-.38 4.88) rotate(-33.87)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-154"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m8.63,3.53c-.17-.08-.24-.16-.24-.36.06-.19.25-.31.45-.21.18.11.19.33.06.49-.05.02-.1.05-.15.07-.04,0-.08,0-.12,0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-155"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 8.26,
    y: 2.73,
    width: 0.9,
    height: 0.91,
    transform: "translate(-.32 5.33) rotate(-33.45)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-156"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.84,
    y: 2.32,
    width: 1.75,
    height: 1.75,
    transform: "translate(-.32 5.33) rotate(-33.45)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-157"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m10.25,5.23c-.2-.1-.27-.18-.24-.42.2-.28.45-.24.58.06,0,.24-.12.33-.34.36"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-158"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 9.84,
    y: 4.42,
    width: 0.89,
    height: 0.92,
    transform: "translate(-.98 6.54) rotate(-33.76)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-159"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 9.42,
    y: 4.01,
    width: 1.74,
    height: 1.74,
    transform: "translate(-.98 6.54) rotate(-33.76)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-160"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m10.27,5.95c-.07-.04-.15-.08-.22-.12-.12-.31.03-.52.36-.48.19.13.22.32.09.51-.08.02-.16.06-.23.09"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-161"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 9.81,
    y: 5.17,
    width: 0.94,
    height: 0.93,
    transform: "translate(-1.39 6.74) rotate(-34.12)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-162"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 9.38,
    y: 4.73,
    width: 1.8,
    height: 1.8,
    transform: "translate(-1.39 6.74) rotate(-34.12)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-163"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m10.25,6.66c-.06-.04-.13-.08-.19-.12-.11-.15-.06-.32.06-.44.26-.13.47.02.47.3-.02.05-.05.1-.06.15-.09.05-.17.09-.28.11"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-164"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 9.82,
    y: 5.86,
    width: 0.91,
    height: 0.93,
    transform: "translate(-1.78 6.7) rotate(-33.41)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-165"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 9.39,
    y: 5.44,
    width: 1.77,
    height: 1.77,
    transform: "translate(-1.78 6.7) rotate(-33.41)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-166"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m10.21,7.37c-.06-.06-.15-.11-.19-.19v-.22s.05-.06.07-.1c.24-.15.41-.11.51.16,0,.28-.15.32-.39.35"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-167"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 9.88,
    y: 6.61,
    width: 0.85,
    height: 0.87,
    transform: "translate(-2.17 6.81) rotate(-33.3)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-168"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 9.48,
    y: 6.22,
    width: 1.65,
    height: 1.65,
    transform: "translate(-2.17 6.81) rotate(-33.3)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-169"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m10.27,8.1c-.07-.04-.15-.08-.22-.12-.02-.03-.03-.06-.04-.08,0-.19,0-.31.18-.4.21,0,.23-.02.37.13.04.17.03.32-.13.43-.06,0-.11.02-.16.04"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-170"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 9.88,
    y: 7.37,
    width: 0.84,
    height: 0.85,
    transform: "translate(-2.6 7.12) rotate(-34.12)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-171"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 9.49,
    y: 6.98,
    width: 1.63,
    height: 1.63,
    transform: "translate(-2.6 7.12) rotate(-34.12)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-172"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m10.29,8.81c-.08-.04-.15-.08-.23-.12-.06-.09-.05-.15-.06-.25.1-.19.22-.28.45-.21.03.04.07.08.11.12.03.15.03.21-.03.36-.07.04-.15.09-.24.11"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-173"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 9.87,
    y: 8.05,
    width: 0.86,
    height: 0.88,
    transform: "translate(-2.98 7.23) rotate(-34.07)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-174"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 9.46,
    y: 7.65,
    width: 1.67,
    height: 1.67,
    transform: "translate(-2.98 7.23) rotate(-34.09)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-175"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m8.37,10.67c-.18-.08-.3-.24-.16-.42.19-.19.45-.06.45.2-.06.15-.12.19-.28.22"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-176"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.95,
    y: 9.95,
    width: 0.83,
    height: 0.84,
    transform: "translate(-4.32 6.3) rotate(-33.33)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-177"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.56,
    y: 9.57,
    width: 1.59,
    height: 1.59,
    transform: "translate(-4.32 6.3) rotate(-33.33)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-178"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m4.72,10.66c-.23-.06-.26-.26-.15-.44.13-.08.22-.1.36-.02.14.23.06.44-.21.45"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-179"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 4.36,
    y: 10,
    width: 0.8,
    height: 0.78,
    transform: "translate(-4.98 4.41) rotate(-33.84)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-180"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 4,
    y: 9.63,
    width: 1.53,
    height: 1.53,
    transform: "translate(-4.98 4.41) rotate(-33.85)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-181"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m3.16,10.55c-.22-.11-.28-.29-.15-.5.03-.03.07-.06.11-.08h.24c.16.11.18.21.15.41-.09.14-.19.16-.36.18"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-182"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2.78,
    y: 9.84,
    width: 0.87,
    height: 0.85,
    transform: "translate(-5.04 3.36) rotate(-32.72)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-183"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2.39,
    y: 9.44,
    width: 1.65,
    height: 1.65,
    transform: "translate(-5.04 3.36) rotate(-32.72)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-184"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m2.19,9.18c-.24-.1-.32-.36-.13-.55.24-.1.37-.06.49.18,0,.17-.03.24-.17.35-.06,0-.13.02-.19.02"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-185"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1.75,
    y: 8.39,
    width: 0.92,
    height: 0.91,
    transform: "translate(-4.47 2.64) rotate(-33.07)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-186"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1.33,
    y: 7.97,
    width: 1.76,
    height: 1.76,
    transform: "translate(-4.47 2.64) rotate(-33.07)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-187"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1.7,8.67c-.22-.09-.26-.15-.26-.4.05-.11.11-.16.23-.21.27,0,.36.13.36.38-.03.15-.18.22-.32.23"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-188"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1.32,
    y: 7.95,
    width: 0.82,
    height: 0.83,
    transform: "translate(-4.38 2.39) rotate(-33.91)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-189"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.93,
    y: 7.57,
    width: 1.59,
    height: 1.59,
    transform: "translate(-4.38 2.39) rotate(-33.91)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-190"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1.18,8.16c-.13-.05-.23-.1-.28-.22,0-.22.03-.28.21-.39.29,0,.37.1.37.38-.06.14-.14.19-.3.23"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-191"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.78,
    y: 7.44,
    width: 0.82,
    height: 0.83,
    transform: "translate(-4.18 2) rotate(-33.91)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-192"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.39,
    y: 7.06,
    width: 1.59,
    height: 1.59,
    transform: "translate(-4.18 2) rotate(-33.91)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-193"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m.65,7.58c-.43-.21-.11-.79.31-.52.02.05.05.1.07.15,0,.2-.03.26-.2.36-.06,0-.12,0-.18,0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-194"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.07,
    y: 6.63,
    width: 1.11,
    height: 1.11,
    transform: "translate(-3.83 1.51) rotate(-33.16)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-195"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -0.44,
    y: 6.12,
    width: 2.13,
    height: 2.13,
    transform: "translate(-3.83 1.51) rotate(-33.16)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-196"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m.41,6.91s-.07-.03-.11-.05c-.17-.17-.19-.32-.02-.5.18-.07.26-.07.41.04.06.12.09.24.03.37-.04.03-.08.06-.11.1-.07,0-.14.02-.2.04"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-197"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0,
    y: 6.15,
    width: 0.9,
    height: 0.89,
    transform: "translate(-3.55 1.33) rotate(-33.34)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-198"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -0.41,
    y: 5.74,
    width: 1.71,
    height: 1.71,
    transform: "translate(-3.55 1.33) rotate(-33.32)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-199"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m.41,6.19s-.08-.03-.12-.05c-.19-.15-.21-.43.04-.55h.23s.06.05.09.07c.11.19.09.35-.08.49-.06,0-.11.02-.16.04"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-200"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -0.03,
    y: 5.45,
    width: 0.91,
    height: 0.88,
    transform: "translate(-3.2 1.22) rotate(-33.67)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-201"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -0.44,
    y: 5.04,
    width: 1.72,
    height: 1.72,
    transform: "translate(-3.2 1.22) rotate(-33.66)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-202"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m.44,5.43s-.1-.06-.14-.08c-.2-.32.07-.65.41-.45.02.04.06.08.09.13,0,.07,0,.15,0,.23-.13.16-.16.15-.36.17"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-203"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -0.04,
    y: 4.57,
    width: 0.99,
    height: 1,
    transform: "translate(-2.73 1.1) rotate(-33.66)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-204"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -0.5,
    y: 4.11,
    width: 1.91,
    height: 1.91,
    transform: "translate(-2.73 1.1) rotate(-33.66)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-205"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m.89,4.76c-.27-.13-.31-.4-.06-.58.29-.07.47.11.41.41-.11.14-.18.15-.35.17"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-206"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.47,
    y: 3.96,
    width: 0.96,
    height: 0.94,
    transform: "translate(-2.28 1.25) rotate(-33.41)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-207"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.03,
    y: 3.52,
    width: 1.83,
    height: 1.83,
    transform: "translate(-2.28 1.25) rotate(-33.41)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-208"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1.5,4.26c-.22-.15-.19-.11-.21-.36.08-.21.23-.28.45-.2.15.15.19.32.06.49-.03.02-.06.04-.1.06-.06,0-.13,0-.19.02"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-209"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1.16,
    y: 3.49,
    width: 0.89,
    height: 0.89,
    transform: "translate(-1.9 1.53) rotate(-33.42)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-210"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.75,
    y: 3.09,
    width: 1.7,
    height: 1.7,
    transform: "translate(-1.9 1.53) rotate(-33.41)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-211"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m3.89,4.22c-.19-.1-.26-.15-.26-.38.08-.22.31-.3.5-.15.02.04.05.08.08.13,0,.17,0,.24-.12.36-.07.02-.14.03-.2.05"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-212"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3.49,
    y: 3.43,
    width: 0.86,
    height: 0.89,
    transform: "translate(-1.5 2.85) rotate(-33.94)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-213"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3.07,
    y: 3.03,
    width: 1.69,
    height: 1.69,
    transform: "translate(-1.5 2.85) rotate(-33.94)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-214"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m3.06,4.09s-.07-.03-.11-.05c-.16-.16-.16-.36.02-.52.23-.1.41.02.45.24,0,.11-.04.18-.11.26-.04.02-.08.03-.11.06-.05,0-.1,0-.15,0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-215"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2.66,
    y: 3.31,
    width: 0.89,
    height: 0.9,
    transform: "translate(-1.56 2.33) rotate(-33.39)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-216"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2.25,
    y: 2.9,
    width: 1.72,
    height: 1.72,
    transform: "translate(-1.56 2.33) rotate(-33.39)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-217"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m2.31,4.09c-.15-.03-.24-.11-.28-.25,0-.34.31-.48.56-.23.02.11.06.2,0,.32-.08.11-.15.13-.28.16"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-218"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1.88,
    y: 3.25,
    width: 0.92,
    height: 0.95,
    transform: "translate(-1.66 1.9) rotate(-33.3)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-219"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1.44,
    y: 2.83,
    width: 1.8,
    height: 1.8,
    transform: "translate(-1.66 1.9) rotate(-33.31)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-220"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m8.37,4.64c-.15-.07-.22-.15-.22-.32.08-.16.25-.25.41-.13.04.04.06.09.07.15,0,.21-.09.24-.27.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-221"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 8.03,
    y: 3.98,
    width: 0.72,
    height: 0.74,
    transform: "translate(-1.01 5.39) rotate(-33.69)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-222"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.69,
    y: 3.65,
    width: 1.4,
    height: 1.41,
    transform: "translate(-1.01 5.38) rotate(-33.68)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-223"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m12.23,4.64s.04-.02.05-.03c.06-.02.1-.06.15-.12.01-.05.02-.09.02-.13,0-.01,0-.03,0-.04,0,0,0-.01-.01-.02-.02-.08-.08-.13-.16-.15-.03-.01-.06-.02-.1-.01,0,0-.02,0-.03,0,0,0-.01,0-.02,0-.03,0-.06.02-.09.05-.04.04-.06.09-.07.15v.02s0,.05,0,.07c.02.08.05.12.12.16.03.02.06.04.09.05.01,0,.02,0,.03,0h.02Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-224"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 11.86,
    y: 4.04,
    width: 0.69,
    height: 0.69,
    transform: "translate(-.39 7.5) rotate(-33.66)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-225"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 11.54,
    y: 3.72,
    width: 1.32,
    height: 1.32,
    transform: "translate(-.39 7.5) rotate(-33.66)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-226"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m6.44,10.77c-.22-.09-.34-.19-.44-.41,0-.26,0-.4.21-.58.32-.16.56-.11.79.18.06.17.06.36,0,.53-.05.05-.1.11-.15.16-.14.08-.27.1-.42.11"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-227"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5.77,
    y: 9.42,
    width: 1.53,
    height: 1.55,
    transform: "translate(-4.55 5.31) rotate(-33.57)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-228"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5.06,
    y: 8.72,
    width: 2.96,
    height: 2.96,
    transform: "translate(-4.55 5.31) rotate(-33.57)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-229"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m10.12,17.33c-.14-.06-.22-.11-.28-.25v-.17c.15-.31.54-.33.64.02,0,.26-.1.37-.36.4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 10.41,
    y1: 16.79,
    x2: 9.87,
    y2: 17.14,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-230"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m12.41,17.49c.79,0,1.43.66,1.43,1.46,0,.49-.24.93-.6,1.19-.03-.04-.06-.08-.08-.11-.07-.02-.1-.08-.11-.14.06-.04.11-.12.16-.19,0-.06,0-.13,0-.19.1-.17.17-.32.06-.5.06-.2-.02-.33-.18-.41-.02-.19-.06-.23-.21-.3-.08-.14-.18-.25-.34-.14h-.06c-.14-.07-.22-.09-.36.02-.21,0-.28,0-.39.19,0,.03,0,.06,0,.1-.24.1-.25.24-.2.49-.08.17-.02.33.17.41.02.03.04.06.06.1.03.11.06.21.1.32.06.12.13.24.2.37-.06,0-.14,0-.2.03-.03.02-.05.05-.07.07-.47-.24-.8-.74-.8-1.31,0-.81.64-1.46,1.43-1.46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 13.61,
    y1: 18.14,
    x2: 11.2,
    y2: 19.63,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m20.39,5.49c.03-.07.07-.14.12-.2v-.25c-.05-.25-.23-.35-.48-.38.05-.1.03-.24.03-.35-.03-.05-.05-.09-.07-.14-.17-.17-.29-.17-.52-.17-.05-.24-.08-.37-.31-.48-.19-.03-.31-.02-.48.08-.12-.19-.24-.26-.46-.29-.13.05-.21.06-.31.14-.02.02-.03.04-.05.07-.04,0-.19-.14-.23-.16-.27-.06-.47,0-.61.24-.08-.03-.16-.12-.26-.15h-.22c-.26.1-.3.21-.37.47-.06-.02-.11-.04-.15-.05-.07-.04-.13-.08-.19-.11.05-.35-.2-.57-.53-.57-.09.04-.18.08-.26.12,0-.06-.02-.13-.03-.19-.05-.07-.1-.15-.14-.22-.21-.13-.4-.13-.62,0-.04.06-.08.11-.13.17-.04-.19-.08-.27-.24-.39-.19-.1-.32-.04-.51.03-.06.06-.11.13-.15.2-.11-.18-.19-.26-.39-.33-.3,0-.47.13-.55.41-.05-.06-.1-.11-.14-.16-.18-.09-.6-.11-.65.14h-.03c-.12-.29-.31-.48-.57-.67-.02,0-.04-.02-.05-.02-.11-.21-.21-.43-.23-.66.19.03.36.09.54.15.08.04.16.09.24.14.06-.05.11-.09.17-.13-.03-.07-.07-.15-.1-.21-.03-.16-.04-.3-.04-.46.04-.11.09-.21.14-.31-.05-.06-.09-.12-.13-.16-.12,0-.33.13-.45.19-.13.03-.26.07-.39.1.06-.29.14-.53.3-.77,0-.08-.08-.12-.12-.18-.07.02-.14.05-.22.08-.07.02-.14.03-.2.05-.09,0-.18,0-.27,0-.11-.04-.23-.08-.33-.12-.04.04-.08.08-.12.13v.04c.17.22.24.5.29.77-.17-.02-.35-.08-.52-.13-.1-.06-.19-.11-.29-.15-.05.04-.1.09-.15.13.1.17.14.39.14.58-.05.14-.1.28-.14.43.05.04.1.08.15.13.27-.15.49-.25.8-.3,0,.09-.03.19-.04.28-.06.13-.1.25-.15.38-.08.03-.15.07-.22.11-.14.12-.43.39-.43.59h-.04c-.15-.3-.63-.26-.79.02-.07-.14-.11-.26-.24-.35-.28-.11-.58-.02-.69.27-.12-.16-.18-.22-.37-.29-.23,0-.36.07-.49.26-.03.05-.05.12-.07.18-.03-.05-.06-.09-.09-.13-.05-.04-.1-.07-.14-.1-.41-.1-.63.1-.67.48-.12-.08-.24-.12-.39-.12-.27.06-.32.18-.41.42,0,.05,0,.09,0,.15-.06.03-.13.07-.18.11-.06,0-.11.03-.16.05-.02-.07-.03-.13-.04-.19-.17-.24-.26-.28-.55-.28-.05.02-.1.04-.15.07-.09.1-.11.09-.18-.03-.14-.13-.23-.16-.43-.16-.05,0-.09.03-.13.04-.08.05-.15.1-.22.15-.03-.08-.12-.12-.17-.16-.28-.09-.49,0-.64.24-.09-.05-.18-.09-.27-.11-.06,0-.12,0-.17.02-.2.1-.24.13-.33.34-.01.05-.01.1-.02.15-.3-.03-.52.07-.6.37,0,.1,0,.2.04.29-.07,0-.13.02-.19.03-.29.18-.28.28-.28.6.03.05.07.11.11.18-.04.04-.08.08-.12.12-.03.04-.05.08-.07.13-.03.19-.04.41.15.53-.04.06-.08.12-.11.17-.07.26,0,.54.28.63-.09.32,0,.6.32.71.07.12.12.3.2.41.19.14.27.44.27.66.03.04.06.08.09.12.14.02.28.06.42.09.07.03.14.07.23.11.06.04.13.09.2.14,0,.06,0,.13,0,.19.14.08.27.15.41.22-.02,0-.03,0-.05.02-.13.19-.06.22.12.37v.19h.24c.05.28.15.37.42.45v.26c.06,0,.12-.02.17-.02.06.1.12.19.18.3.11.11.21.22.21.38-.04.05-.08.1-.11.15-.01.14-.03.31.12.39-.18.24-.36.49-.54.74,0,.16.48.73.52.78,0,0,0,.02,0,.04-.11.14-.09.18-.09.37H.15v.22h0v3.37s.01,0,.02,0v4.89h-.02v5.56h.02c0,2.51,0,5.02,0,7.53.03.2.11.5.3.81.35.57.87.81,1.03.89.37.17.65.19,3,.19h.29c.95-.04,1.73,0,2.31.05.52.05.93.1,1.4.32.4.19.66.4.75.48.06.05.28.24.5.55.21.3.32.54.33.58.04.09.07.2.07.2,0,0,0,.01,0,.01h.22s.02-.09.04-.15c.03-.08.06-.14.08-.18.13-.24.31-.48.31-.48.16-.2.23-.31.36-.43.15-.14.28-.24.37-.3.01,0,.17-.12.34-.21.41-.22.86-.32.94-.34.7-.15,1.67-.13,2.93-.11.59.01,1.17,0,1.76,0,.42,0,.67.01,1.02-.07.27-.06.73-.17,1.14-.53.54-.48.67-1.12.71-1.37,0-7.08,0-14.16,0-21.24h0v-.22h-3.48c0-.09,0-.17,0-.25-.04-.05-.08-.1-.11-.15.17-.24.34-.49.52-.73v-.06c-.18-.24-.35-.48-.52-.72v-.03c.18-.09.15-.42-.01-.53.02-.07.04-.14.07-.21.1-.12.27-.3.32-.46.06,0,.12,0,.19,0v-.26c.23-.08.38-.19.41-.45h.25c0-.06-.02-.11-.03-.15.07-.09.15-.17.22-.24,0-.02-.07-.19-.12-.19.13-.09.26-.17.4-.22,0-.06,0-.13,0-.19.02,0,.03-.02.06-.02.23-.2.49-.27.79-.31.03-.04.06-.08.09-.13,0-.07,0-.14.02-.21.05-.13.11-.26.16-.38.17-.12.19-.31.29-.48.05-.03.09-.05.15-.07.05-.06.1-.11.16-.17.08-.17.04-.3,0-.47.16-.05.27-.19.31-.34,0-.23-.02-.26-.14-.45.04-.06.09-.12.14-.18.07-.25.02-.44-.18-.59Zm-8.48,2.28c-.08-.1-.14-.2-.21-.28-.07-.14-.14-.28-.21-.41-.23-.65-.42-1.39-.17-2.06.13.04.26.08.4.12.47.09.96.17,1.43.21.24,0,.49,0,.74,0,.38-.05.75-.11,1.12-.17.02.12.04.23.07.34,0,.31-.03.61-.11.89-.07.18-.14.36-.22.54-.09.12-.18.25-.26.39-.27.3-.62.55-.98.73-.09.03-.18.06-.26.09,0,.05-.07.15-.05.21.17.26.27.5.34.81-.05.08-.1.17-.14.26-.03.14-.03.31.04.44h-.25c-.1.04-.19.08-.28.13.03.03.07.06.11.09-.07.04-.13.08-.18.12-.07.07-.15.17-.24.19-.06-.23-.12-.27-.31-.39h-.22c-.18.07-.3.18-.3.41h-.04s-.1-.06-.14-.08c-.07-.11-.15-.18-.26-.24.03-.03.06-.06.1-.09-.12-.1-.31-.19-.47-.12,0-.47.5-.97.78-1.28.15-.11.29-.21.44-.31,0-.06.02-.12.04-.18-.11-.11-.22-.23-.32-.33Zm-6.39-2.26c0-.08,0-.28.08-.34.36.05.73.11,1.1.17.25,0,.5,0,.76,0,.47-.04.96-.13,1.42-.21.13-.04.26-.08.4-.12.02.09.05.18.08.28.06.6-.03,1.25-.26,1.79-.15.28-.32.54-.52.79-.07.07-.14.14-.22.21,0,.09.02.12.04.19.52.26.91.83,1.16,1.32.02.09.04.18.07.27-.17-.08-.34.03-.48.11.02.04.1.08.08.12-.1.05-.2.12-.25.22-.05.03-.1.05-.15.08-.05-.21-.09-.29-.27-.4-.2,0-.37-.02-.5.15-.04.09-.07.14-.07.23-.11-.05-.18-.12-.25-.21-.06-.04-.12-.07-.16-.11.02-.03.05-.05.08-.08-.15-.1-.29-.16-.49-.11,0-.11.02-.23.04-.34-.03-.09-.06-.18-.08-.27-.21-.28.1-.68.25-.92-.02-.08-.03-.14-.04-.21-.39-.13-.75-.35-1.06-.62-.09-.11-.19-.21-.28-.32-.06-.09-.11-.18-.16-.26-.06-.12-.12-.23-.16-.35-.06-.22-.12-.44-.17-.66v-.43Zm-2.23,3.53c-.1.04-.11.07-.14.19h-.02c-.15-.32,0-.74.11-1.05,0-.1,0-.15-.09-.2-.25-.06-.49-.15-.71-.28-.08-.06-.16-.12-.24-.17-.32-.32-.52-.62-.64-1.05-.06-.37-.04-.67.12-1,.07-.1.14-.19.22-.29.11-.09.22-.17.35-.25.08-.04.16-.08.25-.11.29-.06.55-.1.86-.1.16.03.32.05.49.08-.02.05-.05.11-.06.17-.03.13-.06.26-.08.4,0,.17,0,.35,0,.53,0,.13.03.27.05.41.15.48.37.97.48,1.46v.31c-.07.21-.15.31-.02.48.54.14.89.49,1.26.87,0,.17.04.28.13.41-.08,0-.24.08-.27.15.03.02.06.06.1.09-.1.07-.17.13-.24.23-.03-.07-.06-.14-.1-.21-.31-.26-.59-.14-.74.2-.06-.03-.1-.11-.13-.16,0-.06.02-.13.04-.19-.11-.11-.21-.2-.37-.2-.08-.37-.24-.59-.61-.73Zm13.82,5.27c1.04,0,2.06,0,3.1.02,0,.25,0,.51,0,.77,0,.41,0,.71,0,.77,0,.54,0,5.07,0,12.2v7.58c-.05.19-.12.4-.21.58-.04.06-.08.13-.12.18-.06.07-.13.14-.19.2-.12.12-.25.22-.37.33-.32.18-.62.29-.98.36-.48,0-.95,0-1.42,0-.04,0-.07,0-.11,0-1.06,0-2.11,0-3.17,0-.84.06-1.59.29-2.23.75-.04.03-.08.07-.12.1-.14.11-.28.22-.41.35h0s-.08.09-.11.14c-.07.07-.13.15-.18.22-.07.13-.14.26-.22.39-.02.03-.04.07-.06.11,0,0,0,0,0,0-.04-.09-.08-.18-.13-.27-.05-.11-.12-.2-.18-.28,0-.02-.03-.04-.04-.05-.07-.09-.14-.17-.22-.25-.3-.34-.68-.62-1.09-.83-.34-.13-.69-.25-1.05-.32-.2-.03-.4-.05-.61-.07-1.03,0-2.04,0-3.06,0h-.09c-.53,0-1.05,0-1.56,0-.19-.03-.41-.1-.6-.16-.13-.07-.26-.13-.38-.2-.12-.1-.24-.22-.37-.3-.02-.02-.04-.04-.05-.07-.05-.05-.1-.1-.14-.16-.17-.23-.27-.5-.33-.79,0-.02,0-.05,0-.09v-7.46c0-1.84,0-3.67,0-5.51,0-1.11,0-2.23,0-3.35,0-1.12,0-2.23,0-3.35v-1.55h16.71Zm1.78-7.42c-.15.24-.32.44-.5.65-.18.1-.35.21-.52.32-.18.06-.38.09-.52.2,0,.06,0,.12,0,.17.08.3.23.7.11,1.01h-.03c-.03-.06-.04-.11-.06-.16-.02-.02-.05-.03-.07-.03-.31.09-.61.37-.61.73-.16,0-.36.08-.38.25.04.12,0,.21-.09.3-.17-.39-.55-.46-.8-.12,0,.05-.03.09-.05.13-.05-.1-.14-.17-.22-.22v-.03s.06-.05.1-.08c-.09-.06-.18-.1-.27-.15.03-.06.05-.11.08-.16,0-.09.03-.18.05-.26.34-.39.75-.73,1.25-.85.03-.06.11-.18.04-.24-.02-.08-.05-.16-.06-.24,0-.16,0-.32.02-.48.15-.42.29-.84.44-1.25.02-.16.04-.31.06-.46,0-.38-.03-.74-.14-1.1.39-.1.8-.09,1.2-.02.36.11.62.25.87.54.04.05.08.12.12.18.17.47.15.91-.04,1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m3.97,14.14c-.23-.09-.23-.27,0-.36h12.66c.2.06.22.3,0,.35-4.22,0-8.44,0-12.65.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m3.94,12.08s-.09-.06-.13-.1c-.05-.13,0-.19.1-.25h12.77c.18.06.12.29-.04.33-4.24,0-8.47,0-12.69.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m3.96,11.61c-.02-.06-.03-.11-.04-.15.08.02.16.03.24.06.16,0,.32-.03.46-.11.08-.06.16-.16.22-.24h.02c.32.34.71.41,1.15.31.1-.05.19-.1.3-.15.11-.11.27-.28.32-.44.1.12.19.24.29.36.17.12.37.23.58.27.21,0,.4,0,.6-.08.15-.09.28-.22.38-.36.36.42.87.55,1.4.34.08-.06.16-.12.25-.18.06-.08.11-.16.18-.24.09.32.47.44.75.53h.29c.23-.04.45-.15.63-.3.04-.05.08-.1.13-.15.12.17.23.27.41.38.09.02.18.04.27.06h.3c.11-.04.23-.07.35-.11.22-.15.38-.3.52-.53.06.1.11.19.17.3.39.39.91.42,1.38.19.08-.07.16-.14.24-.2.04.05.08.11.12.16.14.1.25.16.42.19.09,0,.18-.02.27-.02.03-.02.07-.02.11-.03-.02.05-.03.1-.04.15H3.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m14.78,11.41c-.33-.11-.58-.21-.7-.55h.12c0,.11.15.23.21.3.08.04.16.08.24.12.44.08.78-.02,1-.4,0-.05.02-.1.04-.14.05,0,.11,0,.16.02,0,.11.02.19.06.29.33.48.93.27,1.12-.21,0,.22-.26.4-.43.51-.05,0-.1.02-.15.04-.11,0-.23-.02-.34-.02-.08-.06-.15-.11-.23-.15-.05-.1-.1-.19-.14-.28,0,0-.02,0-.02,0-.13.27-.41.39-.69.47-.1,0-.19,0-.28,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m5.55,11.16c-.1-.03-.21-.07-.3-.13-.15-.15-.15-.18-.19-.36.02-.05.06-.1.09-.14.03.03.07.06.11.11.07.05.15.1.23.15-.04.03-.07.06-.11.1.19.1.31.15.53.15.05,0,.1-.02.15-.02-.15.12-.35.14-.53.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m14.81,11.16c-.11-.03-.23-.09-.32-.15.03,0,.06.02.11.02.23,0,.42,0,.61-.15-.04-.03-.07-.06-.11-.09.12-.05.23-.14.31-.23h.03s.06.08.09.12c0,.26-.24.4-.47.47-.08,0-.16,0-.24.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m7.5,11.15c-.1-.05-.19-.1-.27-.14.22.05.36,0,.52-.12,0-.03-.08-.08-.11-.1.05-.04.1-.07.15-.11.05-.08.11-.19.22-.19,0,.11.09.19.16.25,0,.21-.19.28-.35.37-.11,0-.21.02-.32.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m9.28,11.15c-.09-.04-.17-.07-.25-.11-.11-.07-.32-.22-.32-.36.03-.07.06-.14.11-.2.13.02.19.14.28.23.05.03.11.06.13.11-.03.02-.06.05-.1.07.15.11.25.15.44.15.06-.02.13-.02.2-.03-.06.03-.12.07-.18.11-.1,0-.21.02-.32.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m11.1,11.15c-.1-.03-.2-.1-.28-.15.11,0,.22.02.33.03.11-.02.2-.07.29-.13v-.02s-.06-.06-.1-.08c.11-.06.19-.15.28-.25.05-.02.1-.05.15-.06.03.06.06.14.11.21,0,.11-.21.3-.29.36-.07.02-.14.05-.2.08-.1,0-.19.02-.28.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m12.83,11.15c-.15-.06-.43-.19-.43-.39.09-.07.15-.15.19-.26.11,0,.15.11.21.19.05.03.1.06.15.11-.04.03-.07.06-.11.1.16.12.31.13.5.15-.06.02-.13.06-.19.09-.11,0-.21.02-.32.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m4.18,11.12c-.09-.04-.16-.1-.22-.18.07-.04.15-.08.22-.11,0-.04,0-.07-.04-.11,0-.08.17-.18.24-.18.04.08.11.14.17.2,0,.14-.05.25-.14.34-.08,0-.16.02-.23.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m16.25,11.12s-.1-.06-.14-.08c-.03-.1-.06-.19-.09-.28.07-.06.15-.14.19-.22.07.05.15.1.23.15-.02.04-.04.09-.06.14.07.04.15.08.23.12,0,.13-.3.17-.38.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m5.78,10.89s-.06-.02-.08-.03c.02-.06.04-.12.06-.18-.15-.03-.4-.09-.44-.26.11-.18.2-.19.39-.22,0-.04,0-.08,0-.11-.02-.02-.05-.05-.06-.07.08,0,.17,0,.25.03v.28c.06.19.13.32.29.44-.09.09-.27.12-.4.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m14.73,10.89c-.11-.02-.23-.06-.32-.13.14-.11.2-.24.27-.39,0-.11,0-.21,0-.32.1-.02.16-.05.27-.03q-.06.06-.08.16c.18.04.27.06.37.23-.05.19-.26.22-.42.27,0,.09.02.12.06.17-.06,0-.12.02-.18.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m7.34,10.88c-.12-.05-.22-.12-.33-.19,0-.05.05-.1.08-.13.02-.07.05-.15.08-.21,0-.11,0-.21.02-.32.06,0,.11,0,.17,0-.02.06-.02.11-.03.18.21.02.29.06.42.23-.04.18-.22.22-.37.25v.11s.05.04.07.06c-.04,0-.07.02-.11.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m13.17,10.88s-.02-.02-.02-.03c.02-.02.04-.04.06-.06,0-.04,0-.08,0-.11-.1-.03-.19-.06-.27-.08-.04-.06-.08-.11-.11-.16.04-.05.08-.1.12-.14.11-.05.2-.1.32-.1,0-.04,0-.08,0-.12-.02-.02-.03-.05-.04-.06.06,0,.13.02.2.02-.03.18-.03.31.04.48.03.06.06.11.11.17-.1.12-.27.16-.4.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m9.44,10.86s.03-.05.06-.07c0-.04,0-.08,0-.11-.19-.04-.31-.08-.41-.24.1-.15.22-.23.41-.23,0-.05,0-.16-.06-.16v-.02c.07,0,.15.02.22.03-.04.29.03.47.23.69-.1.03-.19.07-.27.11-.06,0-.12,0-.18.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m10.98,10.86c-.1-.05-.19-.09-.28-.13.11-.12.18-.23.23-.37v-.32c.07,0,.15-.02.22-.02-.06.06-.06.09-.05.18.19.02.32.07.38.26-.09.15-.23.17-.39.22v.11s.03.03.06.06c-.06,0-.11,0-.17.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m3.78,10.78s-.06-.06-.08-.08c.15-.15.19-.34.19-.55-.02-.07-.04-.15-.06-.22.09-.06.2.02.24.1-.05.02-.09.03-.13.05,0,.02,0,.03,0,.05.03.02.07.04.11.06.05.07.11.15.16.23-.05.07-.19.14-.27.16-.04.08,0,.11.03.19-.06,0-.13,0-.19.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m16.65,10.78s-.03-.02-.04-.02c.02-.03.03-.06.06-.09,0-.12-.21-.2-.3-.25.05-.08.1-.15.15-.23.06-.02.12-.05.12-.12-.04-.02-.08-.03-.12-.05,0-.08.18-.15.23-.1-.02.06-.04.13-.06.2,0,.27.03.33.19.56,0,.1-.16.08-.23.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m3.38,10.77s0-.09,0-.13c.09-.04.17-.12.24-.19.07-.32.02-.52-.32-.61-.2,0-.32.07-.43.25-.04,0-.08,0-.12.02,0-.2.21-.31.36-.38.08,0,.16,0,.25,0,.4.13.62.66.23.96-.07.03-.14.06-.2.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m17.2,10.77c-.07-.04-.28-.11-.29-.2-.21-.21-.11-.56.08-.74.06-.04.13-.07.19-.11.08,0,.16,0,.25,0,.05.02.11.03.16.05.1.1.23.19.25.34-.05,0-.09-.02-.13-.02-.11-.14-.17-.22-.35-.25-.23,0-.36.11-.44.31,0,.27.03.35.27.5,0,.04,0,.08,0,.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m6.44,10.76c-.22-.09-.34-.19-.44-.4,0-.26,0-.4.21-.58.32-.16.56-.11.79.18.06.17.06.36,0,.53-.05.05-.1.11-.15.16-.14.08-.27.1-.42.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m10.2,10.76c-.11-.06-.21-.11-.31-.17-.05-.08-.09-.16-.13-.23,0-.06,0-.13,0-.19.06-.34.27-.49.61-.49.15.02.24.12.36.21.02.05.05.11.08.16,0,.1,0,.19,0,.29-.11.32-.31.39-.61.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m13.96,10.76c-.11-.06-.2-.11-.3-.16-.05-.09-.1-.18-.14-.26,0-.24.02-.34.17-.53.15-.11.26-.14.44-.14.31.05.46.3.46.6-.06.36-.28.45-.63.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m8.36,10.66c-.18-.08-.3-.24-.16-.42.19-.19.44-.06.44.2-.06.15-.12.19-.28.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m12.15,10.66c-.24-.11-.29-.33-.06-.5.11,0,.18-.02.27.05.02.03.04.06.06.1,0,.15,0,.25-.13.33-.05,0-.1.02-.15.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m4.73,10.65c-.23-.06-.26-.26-.15-.44.13-.08.22-.1.36-.02.14.23.06.44-.21.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m15.78,10.65c-.22-.06-.24-.25-.15-.43.04-.03.08-.06.13-.08.16,0,.23.03.31.17,0,.19-.02.26-.19.33-.03,0-.06,0-.09,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m6.49,10.64c-.09-.03-.18-.07-.25-.13-.19-.24-.14-.61.19-.7.28,0,.36.04.49.28,0,.15.02.27-.07.39-.04.03-.08.06-.12.11-.08.02-.16.03-.24.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m10.25,10.64c-.27-.11-.36-.2-.36-.51.11-.3.45-.45.71-.19.02.05.06.1.09.15,0,.09,0,.19,0,.28-.02.02-.02.05-.03.07-.06.04-.11.09-.15.14-.08.02-.16.03-.24.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m14.01,10.64s-.09-.03-.13-.05c-.23-.19-.28-.32-.17-.6.14-.18.24-.18.45-.18.09.02.16.09.23.15.11.23.08.49-.15.61-.08.02-.16.03-.23.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m3.17,10.54c-.22-.11-.28-.29-.15-.5.03-.03.07-.06.11-.08h.24c.16.11.18.21.15.4-.09.14-.19.16-.36.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m17.26,10.54c-.06-.04-.11-.07-.16-.11-.07-.15-.06-.23,0-.38.12-.12.19-.09.36-.11.09.06.15.11.18.21,0,.19,0,.23-.15.36-.07,0-.15.02-.21.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m6.53,10.53c-.13-.02-.21-.09-.28-.19,0-.25,0-.3.21-.42h.15c.25.12.28.4.06.57-.05,0-.1.02-.14.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m10.28,10.53c-.11,0-.23-.12-.28-.2v-.22c.12-.15.16-.19.36-.19.19.06.24.26.19.44-.08.1-.16.13-.28.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m14.05,10.53s-.06-.02-.08-.02c-.27-.16-.28-.44,0-.59.26,0,.37.1.37.36-.05.15-.15.21-.3.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m17.92,9.96c-.12-.2-.24-.29-.47-.36h-.23c-.14.05-.23.11-.35.19,0-.25.19-.49.41-.56.02.07.05.15.07.22.03,0,.06.02.1.02.14-.06.24-.13.4-.16.15,0,.34-.02.49.04v.02c-.11.06-.22.11-.32.18-.06.06-.21.18-.14.28.05,0,.11.02.16.04-.04.02-.08.06-.11.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m2.64,9.95s-.06-.06-.08-.08c.05-.02.1-.03.15-.04.13-.2-.47-.45-.47-.48.23-.06.5-.08.73.02.09.05.16.11.26.07.02-.07.05-.15.08-.22.18.04.3.23.38.38,0,.05,0,.11,0,.16-.06-.04-.11-.08-.16-.11-.22-.07-.4-.08-.61.02-.11.07-.16.15-.24.26-.02,0-.03,0-.04.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m5.92,9.92s-.08-.06-.12-.1c-.11-.13-.23-.25-.14-.44.09.07.22.23.35.19-.06-.21-.11-.41-.02-.61.11.03.23.06.35.11.19.12.27.22.32.43.03,0,.07-.02.11-.02.05-.07.1-.14.15-.2.11.13.13.32.09.49-.08-.05-.16-.1-.24-.15-.36-.07-.59-.03-.81.29-.02,0-.03,0-.04.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m14.63,9.92c-.15-.3-.47-.38-.78-.32-.09.06-.18.11-.26.17-.11-.11,0-.41.08-.49.07.12.11.22.26.23,0-.35.4-.44.65-.53.08,0,.07.29.07.35-.02.08-.05.17-.06.26.03,0,.06,0,.1.02.03-.02.22-.23.26-.19,0,.08,0,.17,0,.26-.08.11-.19.2-.3.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m9.78,9.81c-.04-.12-.11-.3-.05-.42.04.04.08.09.13.14.03,0,.06,0,.11,0,.02-.27.11-.46.34-.57.24.19.25.28.32.57.11,0,.16-.06.23-.15,0,.14,0,.28-.04.4-.07-.06-.15-.11-.22-.16-.07-.02-.14-.05-.2-.06-.27,0-.42.05-.61.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m14.78,9.37c.32-.49.83-.78,1.33-1.03.02-.07-.02-.19-.04-.27,0-.09,0-.17,0-.25.1-.49.32-.97.49-1.44.02-.16.04-.32.06-.47,0-.2-.02-.4-.02-.61,0-.06.02-.13.04-.19-.03-.08-.06-.16-.08-.23-.08-.08-.25-.31-.17-.41.38.57.39,1.2.29,1.86-.21.59-.69,1.46-.36,2.1-.21,0-.48.2-.64.29-.15.12-.56.37-.61.54h-.04s-.02-.06-.03-.08h-.02c-.06.06-.12.11-.18.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m5.79,9.35c-.11-.07-.18-.27-.22-.08h-.03c-.26-.27-.84-.83-1.25-.83.02-.15.06-.28.09-.42,0-.59-.29-1.13-.47-1.68-.02-.11-.04-.2-.06-.3,0-.49-.02-1.19.36-1.56,0,.02.02.04.03.06-.05.12-.11.26-.2.35-.02.04-.05.08-.06.13,0,.08,0,.17.02.26-.04.35-.02.7.02,1.05.11.4.3.81.44,1.2.02.1.04.19.06.29,0,.1-.02.2-.02.31-.02.08-.06.15,0,.23.45.17.83.49,1.17.82.04.06.08.11.13.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m9.88,9.35c-.16-.4-.37-.74-.7-1.02-.06-.04-.19-.16-.27-.16,0-.1.19-.26.24-.34.11-.2.23-.4.34-.61.07-.22.15-.43.22-.64.08-.48.15-.96.08-1.45-.06-.2-.12-.37-.23-.55-.11-.13-.23-.25-.34-.37-.19-.11-.36-.22-.54-.32-.16-.06-.32-.11-.47-.16-.15-.03-.3-.06-.44-.08-.19,0-.37,0-.56,0-.49.05-.87.15-1.29.39-.38.27-.57.51-.76.93-.03.11-.06.21-.08.32,0,.19,0,.37,0,.56.02.11.03.23.05.36.18.72.5,1.23,1.05,1.73.23.16.47.32.72.44-.03.05-.06.1-.08.15-.04.11-.08.22-.11.33-.02.11-.02.23-.03.35-.05-.1-.2-.18-.29-.23-.1-.03-.19-.06-.28-.08,0-.04.16-.16.19-.23,0-.08,0-.16,0-.23-.07-.19-.12-.26-.32-.32-.06,0-.11,0-.15,0,0-.08.02-.16.02-.23-.09-.27-.19-.34-.48-.36.09-.26,0-.42-.2-.57-.05-.02-.1-.03-.15-.04.17-.27.04-.66-.31-.66v-.03c.18-.18.11-.46-.05-.61-.05-.02-.1-.05-.15-.07.15-.07.19-.15.27-.29,0-.11-.02-.45-.19-.45v-.02s.08-.02.13-.02c.25-.11.32-.3.27-.57-.05-.06-.1-.12-.14-.18.02-.02.03-.03.05-.04.15.1.27.11.46.1.2-.1.24-.27.27-.49.02,0,.03-.02.06-.02.06.03.11.06.17.1.21.05.39,0,.52-.18.05-.12.07-.15.2-.15.02.02.05.06.07.09.17.11.41.12.57-.03.02-.04.05-.08.08-.12h.16c.07.11.13.15.25.19.21,0,.34-.02.46-.19.04,0,.08,0,.12.02,0,.02,0,.06.02.09.15.29.53.36.74.08h.03c.06.3.15.51.36.74.07.06.15.11.22.18.15.07.32.14.49.18-.12.06-.21.16-.24.29,0,.18.02.32.18.43v.03c-.14.14-.18.21-.18.42.02.11.11.19.19.27-.19.17-.26.34-.14.58.04.04.09.09.14.14-.23.15-.25.43-.1.63.03.02.06.06.1.09-.15.15-.19.22-.19.44.05.11.11.19.19.28-.28.23-.26.61.11.74-.05.03-.09.07-.13.11-.07.12-.14.22-.18.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m10.71,9.35c-.04-.19-.15-.35-.31-.45.11-.06.23-.16.28-.27,0-.07,0-.14,0-.2-.04-.12-.09-.21-.19-.29.04-.05.09-.1.14-.15.08-.21.04-.36-.08-.53-.02-.02-.04-.03-.06-.04.04-.05.09-.1.14-.15.04-.13.05-.24.02-.38-.06-.06-.11-.13-.16-.19.06-.07.14-.14.18-.23,0-.07,0-.14,0-.2-.04-.12-.09-.21-.19-.29.05-.06.1-.11.15-.15.06-.21.03-.36-.1-.53-.02-.02-.03-.02-.05-.03.07-.05.14-.15.18-.22,0-.23,0-.36-.19-.5,0,0-.02-.02-.02-.02.19-.04.38-.11.54-.21.09-.1.19-.19.28-.27.05-.11.11-.21.16-.32.02-.11.03-.21.07-.3.1.05.17.16.29.19.27,0,.4-.08.49-.35.04,0,.08-.02.12-.02.11.18.27.19.49.18.09-.05.17-.12.23-.19.05,0,.1,0,.15,0,.06.11.13.16.23.23.08,0,.16,0,.24,0,.1-.04.19-.09.24-.17.04,0,.08,0,.13,0,.04.06.08.14.12.21.17.13.36.16.55.06.02-.02.03-.04.05-.06.03,0,.06,0,.11.02,0,.27.07.41.32.49.08,0,.16,0,.24,0,.05-.03.1-.06.15-.1.02,0,.03.02.06.03-.05.06-.1.13-.14.19,0,.03-.02.06-.02.1,0,.35.16.4.43.49-.16.08-.19.22-.22.39.03.2.15.26.29.36-.24.13-.32.26-.29.54.03.06.07.11.11.18-.36,0-.5.38-.32.66-.26.06-.36.18-.4.44.02.06.03.11.06.18-.31,0-.49.16-.49.47,0,.04.02.08.02.12-.18,0-.3,0-.41.16-.02.05-.05.1-.07.15,0,.18.03.36.2.44v.02c-.22.06-.42.12-.56.31-.02-.22-.06-.45-.14-.65-.03-.06-.06-.12-.09-.18.41-.19.77-.44,1.08-.78.14-.21.28-.41.42-.61.15-.36.26-.74.31-1.12v-.45c-.02-.19-.06-.47-.18-.61-.02-.04-.03-.08-.05-.12-.33-.47-.65-.66-1.16-.88-.16-.04-.32-.07-.48-.11-.39-.03-.78-.04-1.16.04-.13.03-.26.06-.38.11-.53.21-.9.48-1.2.97-.05.14-.1.27-.14.42,0,.23,0,.45,0,.68.06.52.16.98.37,1.46.15.29.39.56.53.83-.46.23-.78.7-.94,1.18h-.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m9.62,9.34c-.27-.42-.61-.95-1.08-1.17v-.04c.31-.28.53-.63.71-1.01.07-.24.15-.48.22-.71.02-.19.04-.37.06-.55,0-.27,0-.54-.08-.8-.06-.15-.14-.3-.23-.44-.07-.08-.15-.16-.22-.23-.12-.09-.24-.17-.36-.25-.11-.11-.36-.16-.5-.2-.17-.03-.34-.06-.5-.08-.46,0-.85.06-1.28.23-.19,0-.29.08-.39.24-.32.27-.5.54-.61.95-.03.22-.02.45-.02.68.03.22.1.45.16.66.19.44.43.78.78,1.12.16.11.32.23.49.34.14.06.28.12.43.19-.08.15-.16.31-.23.47-.03.14-.1.44-.19.53,0-.32.02-.61.23-.87,0-.04,0-.09-.03-.12-.14-.07-.27-.15-.41-.21-.45-.27-.74-.65-1.04-1.08-.02-.04-.03-.08-.05-.12-.12-.15-.17-.44-.23-.64-.02-.14-.05-.28-.06-.41v-.4c0-.07.02-.14.02-.2.15-.55.42-.91.92-1.19.2-.08.41-.15.62-.23.16-.02.33-.05.5-.06.64,0,1.16.09,1.71.41.08.06.16.11.24.17.08.08.16.17.24.26.14.26.23.45.28.74v.5c-.06.63-.23,1.18-.52,1.74-.14.18-.28.36-.4.55,0,.03,0,.06,0,.1.19.06.41.29.56.44.12.17.23.35.32.53-.02.05-.05.1-.06.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m10.97,9.34c-.02-.06-.05-.11-.07-.15.11-.18.21-.39.35-.55.09-.09.18-.18.27-.26.1-.05.28-.13.28-.25-.15-.19-.28-.38-.42-.57-.09-.19-.18-.38-.27-.57-.21-.58-.29-1.23-.22-1.84.03-.11.07-.22.11-.32.07-.11.15-.23.22-.33.24-.24.51-.4.82-.55.19-.06.39-.11.59-.16.13-.02.26-.03.4-.04.3,0,.59,0,.88.08.17.06.35.12.53.19.09.06.18.11.27.17.12.11.24.23.36.36.06.12.14.24.21.37.11.44.15.81.06,1.26-.11.44-.28.84-.55,1.21-.11.11-.22.23-.32.34-.27.23-.57.41-.88.57-.05.12.06.23.11.34.02.1.05.19.08.3,0,.11,0,.22,0,.33-.02-.03-.05-.06-.06-.08-.05-.15-.1-.3-.14-.44-.03-.08-.06-.16-.09-.24-.19-.26-.13-.19.13-.32.19-.12.37-.24.57-.36.09-.09.18-.18.27-.26.06-.08.13-.15.2-.23.11-.19.21-.38.32-.57.11-.3.18-.6.23-.91v-.4c-.06-.48-.27-.83-.63-1.13-.07-.11-.13-.19-.27-.23-.04,0-.08,0-.12,0-.25-.16-.61-.19-.89-.23-.26,0-.52,0-.78.06-.17.04-.33.09-.49.14-.16.11-.32.21-.47.32-.2.2-.33.4-.45.65-.03.11-.06.21-.08.32,0,.17,0,.34,0,.52.02.16.03.32.05.49.11.53.31.99.61,1.43.11.11.21.23.32.35,0,.02,0,.03,0,.05-.48.32-.78.7-1.08,1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m2.93,9.25c-.07-.05-.13-.12-.19-.19-.06-.23-.02-.53.1-.73,0-.05-.02-.1-.02-.14-.27-.07-.52-.19-.76-.34-.14-.13-.28-.26-.41-.38-.15-.2-.32-.4-.4-.64-.04-.14-.08-.27-.12-.4-.03-.27-.03-.53.04-.78.08-.2.19-.37.3-.56.19-.19.39-.37.61-.52.13-.06.27-.11.4-.16.27-.05.53-.08.81-.08.24.02.55.03.78.11-.04.06-.07.14-.11.21-.19-.02-.37-.05-.55-.07h-.45c-.62.08-1.11.29-1.45.84-.03.06-.06.12-.09.19-.03.12-.06.24-.08.36,0,.32.05.61.16.91.08.17.2.33.31.49.27.32.58.49.95.68.09.02.18.05.27.08,0,.02,0,.06,0,.09-.12.32-.14.58-.14.93,0,.03.02.06.02.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m17.65,9.23c.11-.32-.02-.74-.12-1.05,0-.1.27-.14.36-.16.07-.04.15-.07.23-.11.11-.08.23-.15.35-.23.12-.13.24-.26.36-.38.07-.13.15-.26.23-.39.05-.18.11-.36.16-.53,0-.14,0-.27,0-.41-.03-.14-.06-.27-.09-.41-.16-.33-.4-.58-.72-.76-.15-.06-.29-.11-.44-.16-.12-.02-.23-.04-.35-.06h-.47c-.19.02-.36.05-.54.07-.04-.07-.07-.15-.11-.22.52-.07.97-.12,1.49-.04.37.07.69.28.96.53.08.1.16.2.25.31.05.11.11.21.16.32.02.09.05.18.08.27,0,.14.02.27.02.41-.04.37-.18.7-.37,1.03-.1.11-.19.23-.29.35-.15.13-.33.28-.5.39-.18.06-.36.15-.55.2,0,.04-.02.08-.02.13.1.31.26.73-.1.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m2.64,9.19s-.06-.02-.1-.02c.02-.04.06-.07.09-.11.02.04.03.08.06.12h-.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m5.82,9.19c-.34-.37-.74-.72-1.22-.91,0-.02-.02-.02-.02-.03.02-.08.03-.15.05-.23,0-.36-.11-.79-.28-1.1,0-.02-.02-.05-.02-.07.05.05.1.1.15.15.06.02.12.03.19.06-.02.06-.05.11-.07.17v.21c.08.16.16.23.32.29.05,0,.1,0,.15,0-.02.03-.03.07-.04.11,0,.06,0,.14,0,.21.04.06.08.13.13.19.06.02.13.05.19.08h.15c0,.07-.02.15-.02.23.06.21.18.32.4.36-.02.09-.05.18-.06.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m14.77,9.19c-.02-.09-.04-.18-.06-.27.06-.02.12-.03.19-.05.03-.02.06-.04.1-.06,0-.05.02-.05.05-.07.02-.06.04-.11.06-.17,0-.08-.02-.16-.02-.24.06,0,.13,0,.2,0,.22-.11.27-.24.27-.48-.02-.04-.02-.08-.03-.11.19,0,.3-.06.42-.2.02-.06.03-.13.06-.19-.02-.07-.03-.14-.04-.2-.02-.03-.03-.06-.04-.09.15-.03.24-.11.33-.22-.14.39-.31.76-.31,1.18.02.08.04.17.06.26-.46.19-.94.53-1.25.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m17.9,9.19s.03-.08.06-.12c.02.03.05.06.08.1-.05,0-.1.02-.14.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m2.2,9.17c-.24-.1-.32-.36-.13-.55.24-.1.37-.06.49.18,0,.17-.03.24-.17.35-.06,0-.13.02-.19.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m18.27,9.17c-.25-.12-.32-.31-.15-.53.18-.11.28-.09.44.04.07.23.06.34-.14.47-.06,0-.11.02-.16.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m1.83,8.94c-.11-.11-.39-.15-.54-.15,0-.08-.02-.15-.02-.23,0-.02-.12-.27-.11-.31.06,0,.12,0,.19,0,0,.04-.02.09-.02.14.06.31.25.38.54.38,0,.06-.02.11-.02.18h-.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m18.74,8.94c0-.06,0-.12,0-.18.06,0,.12,0,.19,0,.19-.08.25-.12.33-.31,0-.07,0-.15,0-.22.06,0,.13,0,.2.02-.07.19-.13.32-.14.53-.19.03-.38.08-.57.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m5.84,8.82c-.2-.1-.28-.2-.23-.44.11-.16.27-.23.46-.11.14.2.15.33-.03.51-.07,0-.14.02-.2.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m14.65,8.82c-.19-.07-.33-.28-.2-.49.15-.15.32-.16.49-.02.02.05.04.11.06.16,0,.17-.06.23-.18.32-.06,0-.11.02-.17.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m10.28,8.8c-.08-.04-.15-.08-.23-.12-.06-.09-.05-.15-.06-.25.1-.19.22-.28.44-.21.03.04.07.08.11.12.03.15.03.21-.03.36-.07.04-.15.09-.24.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m1.71,8.67c-.22-.09-.26-.15-.26-.4.05-.11.11-.16.23-.21.27,0,.36.13.36.38-.03.15-.18.22-.32.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m18.81,8.67c-.11-.06-.2-.09-.26-.21,0-.21.02-.31.23-.4.13,0,.18.02.29.09.02.04.04.08.06.12,0,.24-.06.37-.32.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m2.62,8.66c-.07-.07-.14-.14-.23-.19h-.23v-.13c-.04-.28-.27-.43-.55-.36,0-.1-.02-.19-.02-.28-.03-.05-.06-.1-.09-.14-.05-.03-.1-.06-.15-.1-.07,0-.15,0-.21,0v-.3c-.1-.17-.16-.23-.34-.27.02-.08.05-.15.08-.23,0-.2-.06-.3-.2-.44.22-.19.23-.49,0-.68.18-.12.26-.25.26-.47,0-.07-.06-.15-.1-.21h.23c.15-.06.25-.16.31-.32,0-.06,0-.11,0-.17.06-.06.17-.02.24,0,.17-.02.26-.13.36-.26.1.02.19.05.3.08.06,0,.13-.02.19-.02.12-.07.19-.18.34-.11.16.16.41.17.59.02.11,0,.15,0,.19.1.02.02.06.05.09.07-.41-.02-.84-.05-1.25.06-.28.09-.48.21-.72.37-.13.12-.26.25-.39.38-.07.11-.14.21-.2.32-.03.06-.06.13-.08.2-.03.13-.06.26-.08.4v.29c.11.72.48,1.28,1.08,1.71.21.12.43.23.66.3-.04.12-.07.24-.11.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m17.96,8.66c-.03-.12-.06-.24-.1-.36.36-.1.68-.31.97-.53.25-.28.46-.58.62-.91.05-.19.11-.38.13-.57,0-.14,0-.27,0-.4-.06-.32-.21-.61-.4-.88-.14-.13-.27-.25-.4-.37-.13-.07-.25-.15-.37-.21-.11-.04-.23-.08-.33-.11-.16-.02-.32-.05-.47-.06-.24,0-.49.02-.73.02.05-.06.1-.11.15-.16.11,0,.13,0,.22.06.03,0,.07.02.11.04h.19c.2-.06.26-.27.46-.06.06.02.13.04.19.06.06,0,.13-.02.2-.02.07-.05.11-.05.19-.06.05.06.1.11.15.18.07.02.15.05.22.08.07,0,.15-.02.22-.02.03.27.07.4.33.51h.23c-.16.27-.11.49.16.66v.02c-.19.12-.23.4-.1.58.03.02.1.07.1.11-.1.1-.17.15-.2.3,0,.06,0,.12,0,.19.02.05.05.1.08.15-.24,0-.48.35-.33.57-.23,0-.32.03-.44.22-.03.1-.03.2-.03.31-.31-.12-.61.19-.53.49-.22,0-.26,0-.44.12-.02.02-.03.05-.05.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m5.39,8.24c-.14-.03-.2-.13-.26-.24,0-.2.05-.27.23-.36.27,0,.4.15.34.42-.04.13-.2.17-.32.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m15.12,8.24c-.22-.11-.32-.24-.2-.49.1-.1.16-.12.31-.12.18.07.23.17.23.36-.06.17-.18.22-.34.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m1.19,8.16c-.13-.05-.23-.1-.28-.22,0-.22.03-.28.21-.39.29,0,.37.1.37.38-.06.14-.14.19-.3.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m19.3,8.14c-.08-.04-.15-.1-.2-.17,0-.2-.02-.35.2-.42.19,0,.3.02.36.21,0,.07,0,.15,0,.22-.09.14-.2.15-.36.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m10.26,8.09c-.07-.04-.15-.08-.22-.12-.02-.03-.03-.06-.04-.08,0-.19,0-.31.18-.4.21,0,.23-.02.37.13.04.17.03.32-.13.43-.06,0-.11.02-.16.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m4.94,7.63c-.06-.04-.12-.07-.18-.11-.13-.19-.06-.44.17-.5.16,0,.23.04.33.17,0,.19.02.32-.18.41-.05,0-.1.02-.15.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m15.54,7.63c-.06-.03-.11-.06-.17-.1-.13-.21-.09-.44.17-.51.27,0,.34.13.34.39-.06.16-.19.2-.34.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m.67,7.57c-.43-.21-.11-.79.31-.52.02.05.05.1.07.15,0,.2-.03.26-.2.36-.06,0-.12,0-.18,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m19.75,7.57c-.21-.15-.19-.13-.21-.36.09-.19.16-.23.37-.23.19.06.23.26.19.43-.12.15-.17.15-.36.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m10.2,7.36c-.06-.06-.15-.11-.19-.19v-.22s.05-.06.07-.1c.24-.15.4-.11.51.16,0,.28-.15.32-.39.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m4.6,6.94c-.16-.11-.23-.19-.2-.4.09-.18.2-.21.4-.19.23.11.23.4.04.55-.08,0-.16.02-.23.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m15.82,6.94c-.21-.08-.27-.3-.16-.49.03-.03.07-.06.11-.09h.25s.06.05.09.07c.08.11.11.27.03.39-.04.03-.08.06-.12.1-.07,0-.14.02-.2.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m.42,6.9s-.07-.03-.11-.05c-.17-.17-.19-.32-.02-.5.18-.07.26-.07.41.04.06.12.09.24.03.37-.04.03-.08.06-.11.1-.07,0-.14.02-.2.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m20.05,6.9c-.23-.11-.32-.31-.15-.53.22-.15.41-.07.5.15,0,.06,0,.13,0,.19-.05.05-.1.1-.15.15-.06,0-.13.02-.19.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m4.31,6.82v-.02h.02v.02h-.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m16.27,6.82v-.02h.02v.02h-.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m4.3,6.8v-.03h0v.03h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m16.29,6.8v-.03h.02v.03h-.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m4.28,6.76c-.05-.14-.1-.27-.14-.4,0-.04,0-.08,0-.12.08.03.16.06.25.11-.09.15-.11.23-.11.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m16.3,6.76c0-.16-.02-.28-.11-.41.09-.02.18-.06.25-.11,0,.15-.09.36-.15.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m10.25,6.66c-.06-.04-.13-.08-.19-.12-.11-.15-.06-.32.06-.44.26-.13.47.02.47.3-.02.05-.05.1-.06.15-.09.05-.17.09-.28.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m4.34,6.23c-.14-.08-.18-.09-.23-.24,0-.18.06-.28.22-.36h.18c.15.1.2.18.2.36-.06.19-.18.22-.36.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m16.1,6.23c-.22-.11-.29-.32-.14-.52.04-.03.08-.06.13-.08.19,0,.29.02.37.2,0,.11.02.23-.07.32-.04.02-.08.04-.12.06-.06,0-.11,0-.17.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m.42,6.19s-.08-.03-.12-.05c-.19-.15-.21-.43.04-.55h.23s.06.05.09.07c.11.19.09.35-.08.49-.06,0-.11.02-.16.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m20.11,6.19c-.23-.07-.37-.3-.21-.51.03-.03.07-.06.11-.09.14,0,.23-.02.33.06.02.05.05.1.08.15,0,.24-.08.32-.32.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m10.26,5.95c-.07-.04-.15-.08-.22-.12-.12-.31.03-.52.36-.48.19.13.22.32.09.51-.08.02-.16.06-.23.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m4.08,5.67c0-.08.02-.16.03-.24.06.03.12.07.19.11-.08,0-.16.08-.22.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m16.49,5.67c-.05-.07-.11-.09-.18-.13.06-.04.11-.07.17-.11,0,.05.02.22,0,.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m.46,5.43s-.1-.06-.14-.08c-.2-.32.07-.65.41-.44.02.04.06.08.09.13,0,.07,0,.15,0,.23-.13.16-.16.15-.36.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m4.36,5.43c-.06,0-.16-.08-.21-.11-.14-.21-.04-.4.16-.49.17,0,.24.02.35.17,0,.09,0,.18,0,.27-.04.04-.08.08-.12.13-.06,0-.11.02-.17.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m16.18,5.43c-.06-.02-.11-.05-.16-.06-.2-.2-.12-.43.11-.54h.14c.23.09.3.36.11.54-.07.02-.14.04-.2.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m19.97,5.43c-.16-.1-.22-.16-.22-.36.06-.15.09-.17.23-.23.24,0,.37.09.37.35-.05.13-.1.17-.2.23-.06,0-.12,0-.18,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m10.25,5.23c-.2-.1-.27-.18-.24-.42.2-.27.45-.24.58.06,0,.24-.12.33-.34.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m6.95,5.21c-.44-.05-.91-.12-1.35-.2.02-.06.05-.11.07-.17.38.06.76.13,1.14.2.78.06,1.63-.06,2.36-.3.02.04.03.08.06.12-.11.03-.23.07-.34.11-.44.09-.89.17-1.33.21-.2,0-.4.02-.61.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m13.24,5.21c-.63-.07-1.27-.14-1.87-.35,0-.05.03-.08.05-.12.35.11.72.2,1.08.26.19.02.38.03.57.06.34,0,.68,0,1.01-.06.27-.06.55-.11.82-.16.02.06.05.11.08.17-.58.1-1.16.19-1.75.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m7.05,4.95c-.25-.03-.5-.06-.74-.1-.19-.04-.36-.08-.54-.11.03-.06.06-.11.11-.16h.11c.12.25.42.31.62.11.02,0,.06-.02.09-.02.08.25.57.26.64,0h.06s.03.06.06.1c.22.16.49.08.6-.15.09,0,.15.08.23.12.06,0,.11,0,.18,0,.13-.05.24-.12.28-.26.05-.02.11-.02.16-.03.06.06.12.14.19.21-.13.03-.26.07-.39.11-.34.05-.68.11-1.01.16-.22,0-.44,0-.65.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m13.15,4.95c-.3-.03-.59-.06-.88-.1-.26-.06-.52-.13-.77-.19.06-.07.12-.15.19-.21.06,0,.11.02.17.03,0,.11.14.21.23.25.06,0,.11,0,.18,0,.08-.03.15-.06.22-.13h.06c.11.19.19.24.43.24.05-.03.11-.06.16-.08.02-.04.05-.08.08-.11.02,0,.03,0,.06,0,0,.07.13.15.19.19.24,0,.3,0,.44-.19.02,0,.05,0,.08,0,.11.11.2.14.36.14.11-.04.21-.14.26-.23.03,0,.07,0,.11,0,.03.06.07.11.11.17-.42.07-.85.16-1.28.2-.14,0-.28,0-.4,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m.91,4.76c-.27-.13-.31-.4-.06-.58.29-.07.47.11.4.41-.11.14-.18.15-.35.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m6.97,4.76s-.1-.06-.15-.09c-.15-.23,0-.41.25-.41.21.11.23.35.04.48-.05,0-.1.02-.15.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m13.54,4.76c-.37-.15-.16-.64.18-.47.15.15.12.33-.03.44-.05,0-.1.02-.15.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m19.54,4.76c-.18-.11-.23-.15-.23-.37.02-.06.06-.11.09-.15.26-.17.51-.02.51.28-.06.19-.19.23-.36.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m7.65,4.74c-.24-.12-.26-.32-.05-.49.18,0,.26-.02.33.16,0,.18-.02.24-.18.32-.04,0-.07,0-.11,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m12.83,4.74c-.08-.04-.15-.08-.19-.17,0-.27.08-.32.34-.32.06.06.1.09.13.16,0,.06,0,.13,0,.2-.1.09-.16.11-.27.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m4.3,4.72s0-.05.02-.06c.03.02.06.03.1.05-.04,0-.08,0-.11.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m16.18,4.72v-.02s.06-.03.09-.04c0,.02.02.04.03.06h-.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m6.28,4.7c-.2-.1-.27-.24-.12-.44.21-.11.3-.06.4.12,0,.23-.09.27-.28.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m14.23,4.7c-.17-.05-.2-.16-.2-.32.09-.18.15-.17.35-.17.19.16.19.36-.05.48-.03,0-.06,0-.1,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m4.52,4.64c-.15-.09-.22-.16-.22-.36.1-.23.18-.23.42-.23.23.14.21.41.02.56-.07,0-.15.02-.22.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m8.36,4.64c-.15-.07-.22-.15-.22-.32.08-.16.25-.25.41-.13.04.04.06.09.07.15,0,.21-.09.24-.27.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m12.16,4.64c-.27-.12-.3-.37-.03-.5.22,0,.35.11.28.36-.07.09-.14.13-.25.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m15.9,4.64c-.15-.09-.22-.15-.22-.34.06-.23.21-.27.42-.24.15.1.2.23.15.41-.07.15-.2.15-.36.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m10.2,4.45c-.29-.06-.48-.16-.71-.34-.05-.07-.1-.14-.14-.2h1.9c-.18.25-.39.4-.69.5-.12,0-.24.02-.36.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m4.1,4.34s-.05-.02-.06-.02c.05-.04.11-.07.16-.11,0,.03-.02.07-.02.11-.02,0-.05,0-.07,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m16.42,4.34s-.02-.02-.03-.02c0-.03,0-.06,0-.1.06.03.11.06.17.1-.05,0-.09.02-.13.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m1.52,4.26c-.22-.15-.19-.11-.21-.36.08-.21.23-.27.44-.2.15.15.19.32.06.49-.03.02-.06.04-.1.06-.06,0-.13,0-.19.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m7.34,4.26c-.17-.17-.33-.21-.56-.1-.04.02-.07.05-.11.07-.02-.03-.03-.06-.04-.08.47-.15.98-.19,1.46-.05-.02.03-.05.06-.07.11-.04-.02-.07-.05-.11-.07-.16-.06-.3-.06-.45.02-.04.03-.08.06-.12.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m13.23,4.26c-.07-.06-.15-.11-.21-.16-.07,0-.15,0-.21,0-.05.02-.1.03-.14.05-.04.02-.07.05-.11.07-.02-.04-.05-.07-.06-.11.46-.15.99-.1,1.46.06-.02.02-.03.05-.05.08-.08-.05-.16-.1-.24-.15h-.19c-.06.02-.11.06-.17.09-.03.02-.06.05-.08.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m18.92,4.26c-.28-.14-.31-.44,0-.59.19,0,.32.02.37.23,0,.2-.03.26-.2.36-.06,0-.11,0-.16,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m3.89,4.22c-.19-.1-.26-.15-.26-.38.08-.22.31-.3.5-.15.02.04.05.08.08.13,0,.17,0,.23-.12.36-.07.02-.14.03-.2.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m16.63,4.22c-.16,0-.27-.19-.27-.34.09-.27.34-.36.55-.15.06.14.06.27-.04.4-.07.03-.15.07-.23.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m2.32,4.1c-.15-.03-.23-.11-.28-.25,0-.34.31-.48.56-.23.02.11.06.2,0,.32-.08.11-.15.13-.28.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m3.07,4.1s-.07-.03-.11-.05c-.16-.16-.16-.36.02-.52.23-.1.41.02.45.24,0,.11-.04.18-.11.26-.04.02-.08.03-.11.06-.05,0-.1,0-.15,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m17.39,4.1c-.19-.05-.26-.21-.23-.4.11-.18.18-.23.4-.19.09.06.16.11.19.23,0,.27-.11.33-.35.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m18.23,4.1c-.32-.07-.38-.38-.13-.57.19-.06.35-.02.43.17,0,.17,0,.23-.12.36-.06.02-.12.03-.18.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m5.13,3.97s-.1-.06-.15-.1c-.12-.2-.09-.4.13-.5h.19c.08.04.15.12.19.21,0,.28-.09.36-.36.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m15.32,3.97c-.06-.04-.11-.07-.17-.11-.1-.15-.07-.32.05-.44.09-.06.18-.05.28-.05.09.04.15.11.19.21,0,.16,0,.28-.16.36-.06,0-.13.02-.19.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m9.28,3.81c-.03-.12-.08-.24-.08-.36.3,0,.61,0,.91,0,0-.37,0-.74,0-1.1.1-.03.26-.03.36,0v1.1c.3,0,.61,0,.91,0-.03.12-.06.24-.08.36h-2.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m5.98,3.57c-.21-.09-.29-.17-.26-.4.08-.17.27-.26.44-.17.24.24.14.53-.19.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m14.55,3.57c-.06,0-.16-.08-.21-.11-.07-.18-.09-.29.06-.44.1-.05.14-.06.25-.06.25.08.31.41.07.57-.06,0-.11.02-.17.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m8.63,3.53c-.17-.08-.24-.16-.24-.36.06-.19.25-.31.44-.21.18.11.19.33.06.49-.05.02-.1.05-.15.07-.04,0-.08,0-.12,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m11.84,3.53c-.19-.09-.28-.22-.22-.43.08-.12.16-.18.32-.18.22.05.26.23.23.43-.06.07-.14.13-.22.17-.04,0-.08,0-.12,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m6.84,3.4c-.15-.07-.23-.17-.23-.36.02-.06.06-.11.09-.17.15-.09.28-.11.43,0,.06.13.11.23.05.37-.11.12-.18.12-.33.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m13.6,3.4c-.2-.1-.29-.28-.17-.49.14-.14.27-.15.44-.05.02.04.05.08.08.12,0,.08-.02.17-.02.26-.04.03-.08.07-.11.11-.08,0-.15.02-.23.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m7.73,3.36c-.11-.06-.17-.11-.22-.22,0-.3.1-.38.38-.38.03.02.07.04.11.06.11.22.13.32-.05.49-.08,0-.15.02-.23.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m12.71,3.36c-.07-.06-.14-.11-.2-.17-.07-.22.02-.35.19-.43.23,0,.25.02.37.21,0,.18-.02.23-.14.35-.08,0-.15.02-.23.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m9.2,3.33c.06-.38.18-.61.49-.83.1-.04.21-.14.32-.14v.97h-.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m10.59,3.33v-.97c.2.06.37.17.53.31.06.1.12.19.19.29.02.12.06.24.09.37h-.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m9.96,2.25c.04-.13.08-.25.12-.37.02-.15.03-.28.06-.42-.23,0-.42.02-.64.09-.09.04-.18.08-.27.13.02-.09.04-.18.06-.27v-.27c0-.06-.07-.2-.05-.25.29.12.57.19.89.22,0-.23-.07-.65-.21-.82,0-.02-.02-.05-.02-.07.16.08.35.07.53.07.08-.02.16-.05.25-.06-.04.08-.08.17-.11.26-.06.21-.11.41-.13.62.32,0,.61-.09.9-.23-.02.09-.05.19-.06.28,0,.18.02.34.06.52-.31-.15-.55-.22-.89-.22.02.28.11.53.2.79-.06-.02-.12-.03-.18-.04-.18,0-.35,0-.52.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m20.18,15.42c0-.34,0-.68,0-1.01,0,0,0,0,0,0v-.1H.4v10.13c0,.13,0,.25,0,.38v3.97h0v6.8c.07.4.23.75.53,1.04.13.08.25.2.36.3.12.06.25.13.38.19.19.06.4.13.6.16,1.57,0,3.14.02,4.71.02.2.02.4.04.61.06.36.07.7.19,1.04.32.72.36,1.33.94,1.66,1.67.1-.17.19-.34.29-.51.09-.12.19-.24.28-.36.75-.78,1.68-1.12,2.76-1.2,1.57,0,3.14-.02,4.71-.02.36-.07.65-.18.97-.36.19-.17.4-.33.57-.53.16-.23.28-.54.32-.82v-13.03c0-2.23,0-4.46,0-6.69,0,0,0,0,0,0v-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m13.09,33.93c-.23-.13-.26-.28-.13-.52.19-.13.51,0,.72.06,0,0,0,.02,0,.02-.04.02-.08.03-.12.06-.1.1-.18.2-.23.33-.07.03-.16.03-.24.04m.93-.98c-.09-.06-.17-.11-.25-.16.13,0,.26-.02.39-.02-.02.06-.07.15-.14.18Zm1.27-1.12c.06-.16.13-.32.19-.47.03.11.06.23.11.34-.11.04-.2.08-.3.13Zm1.08,1.47c.04-.44-.04-.89.03-1.33.35,0,.46.1.65.38,0,.05.02.1.04.15v.21c-.1.36-.36.49-.72.59Zm-1.08.02c-.12-.02-.28-.04-.4-.1.15-.18.17-.57.19-.79.18-.08.36-.15.55-.23,0,.14,0,.28,0,.43-.04.11-.07.23-.11.34-.06.11-.13.23-.19.34-.02,0-.05,0-.06,0Zm-2.17-.95c-.36-.2-.73-.37-1.12-.51-.14-.04-.27-.08-.4-.11-.23-.03-.46-.09-.69-.11-.21,0-.42,0-.62.02v-.09c.06-.05.13-.1.19-.15.08-.03.17-.06.26-.08.02-.05.06-.1.09-.15-.11-.04-.2-.07-.3-.11-.04-.04-.08-.08-.11-.12,0-.32.24-.36.53-.38.03-.08.06-.16.11-.24-.12,0-.26,0-.37-.02,0-.07,0-.15.03-.22.32-.22.56-.42.61-.82-.06-.06-.15-.04-.22-.05-.08.17-.17.25-.32.36-.07.03-.15.07-.21.11-.19.05-.36.1-.54.16-1,.16-2.39.15-2.98,1.14-.12.3-.12.6.09.85.05.03.1.07.15.11-.15,0-.32.15-.44.23-.14.06-.36.19-.51.1-.06-.1-.05-.15-.06-.26.15-.19.27-.39.2-.63,0-.15.02-.31.02-.45,0-.08-.06-.18-.03-.26.06.06.17-.02.24-.02,0-.14-.03-.35-.17-.39-.02-.18-.07-.24-.27-.24-.03.02-.06.03-.09.05,0-.02,0-.03,0-.04.22-.7.44-1.38.66-2.07.1.04.19.09.3.14.27.05.5.11.76-.02.05-.03.11-.06.16-.1,0,.05-.11.17-.14.21-.27,0-.44.22-.32.49-.02.13-.14.23-.23.29-.08.02-.16.03-.24.06-.15,0-.31,0-.45-.04-.06.02-.11.06-.16.09,0,.26.19.37.38.48.09.02.18.03.27.06.02.02.03.05.06.07.06-.02.13-.03.2-.04.15,0,.3,0,.45,0,.13.03.26.07.4.11,0-.04,0-.08,0-.11.16-.02.24-.04.36-.15.02-.16.03-.32.05-.49.02-.06.06-.13.09-.19.11-.11.22-.28.37-.32.84.29,1.73.32,2.61.38.05.25.23.49.38.69.3.36.64.65,1,.93.42.2.85.4,1.2.71.07.18.07.38.07.57h-.05c-.02-.25-.11-.41-.35-.5h-.35c-.39.11-.61.39-.61.79,0,.05.07.26.06.27Zm-2.18-8.09c-.08-.09-.16-.17-.24-.25,0-.04.02-.07.04-.1,0-.17-.08-.25-.24-.25-.07.04-.14.08-.2.12,0-.02-.02-.04-.02-.06h.1c.02-.07.06-.14.06-.21.29.06.59.14.89.21-.07.18-.28.39-.39.54Zm.43-.91c-.33-.13-.71-.19-1.06-.26,0-.06,0-.13,0-.19-.06-.02-.11-.03-.17-.05.15-.36.08-.71-.08-1.03-.06-.08-.13-.16-.19-.23h-.02c-.02-.09-.03-.17-.04-.25.15.02.4.15.54.21.06,0,.11,0,.18,0-.02.02-.04.03-.06.05.02,0,.05.02.08.04,0,.18.11.4.17.57.06.11.14.21.21.32.1.08.2.16.31.24.17.03,0,.36.16.44,0,.05-.02.11-.02.16Zm-6.57,9.16c-.07-.12-.14-.23-.2-.35h.18c0,.11.02.23.02.35Zm4.96,3.18c-.09-.09-.2-.02-.29-.07-.05.05-.13.03-.19.03-.11-.13-.18-.3-.15-.47.11-.18.24-.52.53-.4.09-.06.12-.07.23-.06.04.02.09.05.14.08.05-.03.11-.06.16-.08.08,0,.17,0,.26,0,.04-.04.17-.14.17-.2-.17-.06-.32-.14-.46-.23-.05-.06-.1-.13-.14-.19-.02-.15-.06-.27,0-.41h-.17c-.18.15-.4.33-.64.37-.05.03-.09.06-.13.11-.06.02-.11.06-.15.09.02.07.12.11.19.11,0,.06.02.13.04.2-.18.18-.1.28-.1.51-.04.03-.08.06-.11.11-.03.13-.17.31-.33.27-.02-.02-.05-.03-.07-.04-.06.02-.13.05-.19.08-.15.02-.29.02-.44,0-.04-.02-.08-.03-.11-.04-.02.06-.03.13-.04.2-.05,0-.09.02-.13.03-.04-.02-.07-.05-.11-.06-.06,0-.11,0-.17.02-.02-.02-.02-.02-.03-.03-.02,0-.03.02-.05.03h-.16c-.06-.09-.11-.18-.15-.27v-.21c.12-.19.17-.32.36-.41.05,0,.1.02.15.02.08-.06.11-.08.22-.08.05.04.11.08.16.12.08-.08.16-.15.24-.23,0-.06-.32.03-.36.04-.23,0-.5-.03-.73-.02-.09.3-.13.6-.13.91-.07,0-.15.02-.21.03-.06-.11-.13-.21-.19-.31-.4-.4-.92-.47-1.38-.11-.06,0-.13-.08-.18-.11,0-.04.02-.08.02-.12,0-.59-.58-.66-1.03-.73-.02-.07-.03-.15-.04-.21.06-.03.14-.06.21-.08.11-.35-.72-.54-.93-.62-.06-.04-.13-.07-.19-.11-.1-.09-.19-.18-.27-.26,0-.08.06-.14.11-.19.07.02.15.05.22.08.16.04.36.15.53.15-.12-.13-.23-.27-.32-.43-.04-.03-.07-.06-.11-.1-.02-.11-.05-.23,0-.35-.04,0-.07.02-.1.04-.05-.03-.1-.06-.15-.1,0-.13.11-.25.23-.3-.02-.02-.02-.03-.03-.04.06-.15.11-.19.23-.28.15-.37.56-.36.91-.37.07.05.11.28.14.37,0,.22-.05.44-.02.65.02.04.05.08.07.13.02-.02.03-.02.05-.03-.02-.04-.04-.06-.07-.07,0-.06,0-.12.02-.19.18-.12.24-.23.24-.44,0-.09-.07-.18-.1-.26,0-.15.06-.15.19-.2-.03-.13-.13-.32-.05-.44.09-.06.18-.09.28-.09,0-.31-.04-.52.33-.47.15-.1.29-.07.37.09.02,0,.06.02.09.04.24-.78.49-1.57.74-2.34,0-.06-.42-.36-.52-.47-.02,0-.02,0-.03,0-.23-.22-.46-.43-.69-.64-.21-.14-.45.02-.63.15-.16.2-.23.46-.32.7-.2.27-.46.53-.46.88-.06.04-.11.08-.16.12v.14c.04.06.09.13.14.2.02.15.11.22.2.34,0,.02.02.05.04.08,0,.26-.34.39-.54.45-.12,0-.24,0-.36,0-.15-.11-.06-.43-.15-.61,0-.15.02-.29.03-.44-.04-.06-.08-.11-.11-.15,0-.06,0-.11,0-.17.06-.23.08-.24.24-.4.12-.44.42-.81.69-1.18.09-.15.18-.31.27-.46.04-.16.07-.35.19-.47.07-.06.15-.11.23-.16.11-.03.22-.05.34-.04.12.07.27.18.42.18-.16-.27-.28-.56-.36-.86-.04-.05-.07-.1-.11-.14-.15,0-.24.06-.37.12-.42.28-.83.55-1.25.82-.07.11-.17.29-.32.19-.02-.03-.05-.06-.06-.08-.15.21.1.64-.11.81-.17.05-.34.1-.51.15-.06,0-.13,0-.19,0-.09-.02-.17-.03-.25-.05-.11-.33.13-.65.26-.93.11-.11.15-.27.24-.39.16-.07.32-.15.49-.22.26-.23.55-.44.84-.64.21-.13.43-.25.65-.37.17-.17.27-.27.46-.38.06-.02.13-.04.2-.06.17,0,.33-.02.48.07.07.11.15.23.23.35.11.1.23.2.34.31.19-.53.37-1.07.56-1.59.02-.12.06-.23.09-.35-.02,0-.02,0-.03,0-.03.1-.11.19-.21.23-.14,0-.32,0-.32-.18h-.15c-.02-.12-.02-.23-.03-.35h-.05c0,.12-.02.24-.02.36-.07.05-.15.06-.23.09-.09.09-.27.04-.37,0,0-.14-.12-.19-.21-.27,0-.14,0-.22.09-.32-.02-.14-.03-.27,0-.4-.03-.3-.06-.6-.09-.9-.03-.04-.06-.07-.1-.11-.02-.21-.05-.42-.06-.63h-.19c-.06-.11-.06-.14.02-.22,0-.13.02-.25.03-.37.03-.11.06-.22.11-.32,0-.19-.26-.32-.08-.5.04-.02.08-.02.12-.03-.07-.15,0-.19.12-.23.24.03.43.11.64.22.09-.06.18-.13.27-.19.06-.03.13-.06.19-.08.28-.06.6-.02.88.02.11-.03.19-.11.28-.15,0,.08,0,.16,0,.25.23,0,.59.13.67.37.19.04.38.08.51.24.16.06.31.18.44.29.06.1.13.2.19.31.04-.14.08-.27.12-.4-.06-.19-.06-.4-.07-.6.02-.03.04-.06.06-.08,0-.15-.02-.29-.02-.44.12-.26.25-.51.38-.76.04-.04.08-.08.13-.11.06-.02.11-.03.17-.04-.03-.05-.06-.09-.1-.13-.11-.37.06-.6.41-.68,0-.03.02-.06.02-.09-.06-.06-.2-.09-.29-.13.03-.11.07-.22.11-.32.09,0,.19.05.28.08.04-.1.08-.19.12-.29.11.03.23.06.35.11-.03.1-.06.19-.1.3.09.03.19.06.28.1-.03.12-.06.24-.09.36-.1-.03-.19-.06-.29-.1-.05,0-.05.07-.06.11.2.25.19.58-.11.77-.23.08-.12.06-.12.28,0,.02-.02.03-.02.05,0,.19-.02.26-.12.4-.04.2-.06.35-.25.46-.06.18.02.28.09.46.04.19.08.39.13.59.06.18.11.36.17.54.1,0,.2.02.31.04.08.04.17.08.26.12.06-.03.13-.06.2-.08.06,0,.12,0,.19.02-1.19-.93-.69-2.91,1.03-3.15,1.71-.15,2.74,1.67,1.46,3.1.03.04.06.08.1.12h.65c.48.11.69.43.99.79.11.09.25.24.4.26-.04-.24-.06-.43.02-.66.19-.39.41-.52.82-.61h.36c.27.05.43.18.63.36.15.23.23.42.29.69v.33c-.03.1-.06.2-.08.31-.06.09-.12.18-.18.27-.08.06-.15.13-.23.2-.04.15-.13.29-.24.4-.06.05-.13.1-.19.15.14.11.27.23.41.36,0,.05,0,.1.02.15-.15.18-.3.38-.49.52-.06.02-.12.04-.18.06h-.15c-.19-.05-.1-.15-.32.04-.16.06-.37.11-.49-.06-.2.1-.46.16-.63,0-.02-.04-.03-.08-.04-.12-.05.06-.21.28-.3.28,0-.02-.02-.02-.02-.03,0,.02-.02.03-.02.05,0,0,.02,0,.03.02-.06.03-.13.07-.19.11-.06.02-.13.03-.19.06-.12,0-.23-.02-.35-.02-.15.05-.3.11-.44.16.06.05.11.1.17.15.14.16.19.27.21.49.11,0,.15.15.17.22.19,0,.39.08.56.13.48.19.93.47,1.23.9.15-.03.29-.06.44-.09.14,0,.28,0,.43,0,.12.03.24.07.37.11.1.06.19.13.3.2.26.26.42.53.54.88.02.16.05.32.08.49.05.04.11.09.16.14.02.04.05.08.08.12,0,.18,0,.36,0,.54.04.3.1.61.1.91.03.05.06.11.1.16-.02.15-.03.31-.04.46-.06.03-.11.06-.15.11.02,0,.04-.02.06-.02.03.13.06.26.1.4.08.12.15.19.27.27,0,.07-.02.15-.02.23-.31,0-.67-.05-.91-.24-.05-.06-.1-.11-.15-.16-.1.06-.19.14-.29.21-.11.03-.22.03-.33.04.04-.11.08-.2.12-.3-.02-.3-.03-.6-.04-.9,0-.08.02-.16.02-.24-.11-.11-.1-.4-.11-.55-.06-.13-.1-.24-.1-.39,0-.05.02-.09.04-.13-.03-.49-.06-1.16-.43-1.53-.02-.02-.05-.03-.07-.05-.1-.02-.19-.03-.29-.05-.02.24-.05.53-.11.77,0,.02.02.04.03.06-.06.19-.1.39-.15.58-.02,0-.04-.02-.06-.02-.11.11-.23.78-.27.91,0,.16,0,.32,0,.49.06.27.14.47.36.64.17.03.36.13.53.16.02.04.05.09.08.14-.08.25-.15.5-.23.76.16.02.32.05.48.08.4.18.55.44.65.86,0,.1,0,.2.02.31-.05.33-.15.55-.36.81-.22.18-.5.27-.77.36-.16.02-.32.05-.48.08-.04.02-.08.04-.12.06,0,.21,0,.42,0,.63-.03.02-.06.04-.08.06-.29.03-.59.02-.88,0,0-.02.02-.05.04-.06-.07-.02-.14-.03-.2-.04.02-.26.1-.53.32-.67-.12-.02-.57-.18-.67-.13,0,.2-.03.41-.08.61-.11.14-.47.1-.62.1,0,.07,0,.15,0,.23.03.11.07.21.11.32-.02.03-.03.07-.05.11-.16.08-.18.4-.45.31,0-.06-.16.04-.17.04-.07,0-.14.02-.2.04-.1,0-.19-.02-.28-.02-.05-.02-.09-.03-.13-.04-.02.06-.03.12-.04.19-.05.02-.09.03-.13.05-.04-.02-.07-.05-.11-.06-.05.02-.16.02-.2-.02-.05.05-.15.03-.21.03-.04-.06-.08-.13-.11-.19-.02-.08-.03-.16-.05-.23.1-.18.26-.57.53-.45.08-.06.11-.07.21-.07.07.04.15.09.23.14.09-.12.21-.22.32-.32,0-.15,0-.21-.15-.25-.28-.02-.57-.05-.85-.06-.17-.08-.3-.15-.43-.28-.02,0-.04,0-.06,0-.16.12-.26.23-.13.41.1,0,.17-.05.23-.14.02,0,.03,0,.05,0,.05.06.11.13.16.19v.12c-.2.18-.38.38-.52.61-.02.07-.06.19-.1.23-.12,0-.14.06-.23.12-.07,0-.14,0-.2,0,.06-.07-.08-.09-.13-.09-.07.05-.14.11-.2.16-.16.02-.32.02-.48-.04-.02.06-.03.11-.04.17-.06,0-.11.02-.16.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m9.36,35.55c-.03-.08-.06-.15-.1-.23.03,0,.06,0,.1,0,0,.02.02.05.03.08-.02.04-.03.09-.04.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m9.81,35.55c-.04-.06-.14-.15-.14-.23.03,0,.06,0,.1.02,0-.02.02-.02.02-.03-.06-.02-.06-.04-.13-.04.02-.11.1-.2.18-.27.15.03.35.13.49.06,0-.02,0-.04,0-.06-.06.03-.2.02-.28.02.07-.15.27-.16.4-.12.05-.04.1-.08.15-.12.1-.1.19-.19.3-.29v-.02c-.27-.06-.59-.15-.75-.39-.02-.06-.03-.13-.04-.19.03-.2.14-.36.28-.51.21,0,.36-.05.53-.16.04.03.08.07.13.11.04,0,.08.02.13.04.09,0,.18-.02.27-.02v.12c-.2.08-.44.31-.4.55h.04c0-.19.16-.49.38-.49.02.07.03.15.06.22-.19.12-.26.17-.36.36v.17c.04.06.08.11.13.17.17.04.22-.03.34-.07.02.02.03.05.05.07h-.03c-.23.23-.45.44-.53.77-.04,0-.08-.02-.12-.02-.02-.03-.03-.06-.05-.1-.03,0-.06,0-.1,0,0,.02,0,.03,0,.05.02,0,.03,0,.06,0v.17c-.06,0-.12.02-.18.02.02-.08.03-.16.06-.24-.02,0-.03-.02-.05-.02-.12.11-.24.21-.36.32-.11.02-.27.03-.35-.04.08-.05.11-.07.21-.09v-.05c-.1,0-.18.02-.24.09-.19.05-.18.04-.22.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m7.62,35.54c-.06-.07-.11-.15-.15-.22.03-.03.06,0,.11,0,0-.02,0-.03.02-.05-.04,0-.08-.02-.12-.02,0-.09.11-.19.16-.26.2.02.47.11.57-.11-.02,0-.03,0-.05,0-.07.09-.17.1-.28.1.1-.12.23-.21.36-.3-.02-.15-.04-.31-.06-.45.03,0,.07-.02.11-.02v-.05c-.07-.02-.15-.02-.22-.03-.02-.04-.05-.08-.06-.11-.18.04-.34.13-.53.09-.02.02-.02.03-.03.05.1,0,.19,0,.29,0,.07-.02.17-.1.25-.06.02.05.08.07.12.11,0,.06,0,.13,0,.2-.11.02-.22.05-.32.08-.27,0-.55,0-.82-.03.06-.23.29-.43.45-.59,0,0,.18-.11.14-.15-.53.29-.83.94-.83,1.53-.06,0-.04-.4-.04-.46.02-.09.03-.18.05-.26.1-.18.19-.37.32-.53,0-.02,0-.04,0-.06-.04,0-.07.02-.11.02-.09,0-.18,0-.26,0-.06-.02-.15-.06-.21-.03,0,.12-.27.31-.36.37-.32.16-.64.32-.93.52.04-.05.08-.1.13-.14.39-.23.83-.44,1.12-.81-.06-.07-.13-.14-.19-.2-.32-.12-.81.19-1.08.28-.12.02-.23.05-.35.08-.15,0-.28.02-.42.03.05-.05.2-.06.27-.07.38-.15.76-.29,1.14-.44.12-.02.25-.04.38-.06-.06-.19-.02-.38.1-.53,0-.02,0-.04,0-.06-.15-.03-.29-.02-.44,0-.36.09-.7.18-1.05.28-.17.02-.34.04-.51.06-.4,0-.81-.05-1.18-.19-.08-.06-.16-.11-.23-.17.15,0,.37.11.51.15.15.02.32.05.48.08h.41c.73-.06,1.41-.36,2.14-.42.25.05.48.08.6.32,0,.15,0,.31-.18.36-.12,0-.28-.13-.11-.21.03,0,.06,0,.1,0,.09-.14-.11-.21-.2-.21-.32.15-.28.45-.08.7.19.14.41.18.64.09.1-.08.19-.18.24-.29.07-.33-.06-.56-.35-.7,0,.02,0,.03,0,.06.31.1.37.43.27.7-.19.25-.46.29-.74.11-.18-.18-.23-.4-.04-.59.15-.05.18-.02.24.08-.18.02-.25.12-.13.28.03,0,.07.02.11.04.27,0,.35-.34.23-.54-.06-.05-.11-.09-.15-.13-.33-.15-.57-.11-.93-.07-.24.06-.49.11-.72.18-.26-.17-.32-.54-.29-.82.06-.08.11-.15.17-.23.11.23.2.33.45.39.05,0,.1,0,.15,0v-.05c-.39,0-.49-.22-.59-.56-.02,0-.04,0-.06,0,0,.16-.02.29-.15.39-.11.02-.31.03-.4-.02,0-.04.02-.04.06-.04v.05c.11,0,.36,0,.41-.11,0,0-.02-.02-.02-.02-.06.02-.11.05-.15.07-.04,0-.08,0-.11,0,.12-.08.16-.15.2-.28-.02,0-.03,0-.05,0-.03.17-.14.22-.27.29.03-.04.06-.07.11-.11.02-.06.05-.11.08-.15,0-.17,0-.33-.07-.49,0-.08.09-.08.15-.11.08-.16-.1-.32-.03-.45.08,0,.16-.02.24-.02v.08c-.15,0-.17,0-.18.13.04.11.09.22.14.33.02,0,.03,0,.06.02,0-.33.02-.66.03-.99.05-.11.16-.03.25-.03.02-.03.05-.06.07-.08.03,0,.07,0,.11.02-.04.09-.08.18-.11.27,0,.08.02.16.03.24-.02,0-.05.02-.07.04,0-.08,0-.15.02-.23,0,0-.02-.02-.02-.02-.06.06-.03.14-.04.22-.08.26-.17.43-.06.7.03.05.07.1.11.15.06.02.13.05.19.08.21,0,.41-.05.53-.23.06-.19,0-.4.04-.6.04-.08.1-.18.1-.27-.06-.08-.23-.19-.06-.19,0,0,.02.02.03.02,0,.03,0,.06,0,.11h.05c0-.12-.02-.18.11-.18.06.06,0,.18-.02.24-.03.02-.06.06-.1.09,0,0,.02.02.03.03.05-.06.11-.11.16-.16.11.02.11.11.13.2-.11-.05-.16-.06-.24.02,0,.21.05.42.03.63-.06.2-.15.3-.32.43-.09.02-.18.03-.27.05,0,.02,0,.03,0,.05.28,0,.4-.12.58-.32.07.19-.06.39-.19.52-.21.06-.48.07-.66-.06,0,.02-.02.03-.02.05.05.02.11.06.16.09.16.03.33.02.49,0,0,.3.21.49.51.4.23-.09.45-.24.66-.36,0,0,.02,0,.03,0-.04.07-.05.17.04.22.04,0,.08,0,.13,0,.1-.05.47-.5.64-.33-.13,0-.19.06-.19.18.07.05.11.06.2.06.22-.15.34-.52.66-.43,0,.02.02.03.02.05-.08-.03-.14-.03-.2.03,0,.11-.02.15.11.19.21-.02.4-.12.6-.18.67-.11,1.37-.19,2.04-.06.15.03.29.06.44.11.22.08.44.16.66.24.26.15.52.29.78.44.26.26.65.41.97.57.17.05.35.1.53.16.19.03.38.07.57.11,0,.05-.07.15-.1.19,0,.03,0,.07,0,.11-.59-.09-1.16-.27-1.71-.49-.16-.03-.32-.06-.49-.08.05-.06.11-.11.16-.16,0-.04-.19-.08-.21-.09-.04-.06-.08-.13-.11-.19-.02,0-.03,0-.05,0,0,.11.06.19.15.25.04.02.08.04.12.06-.1.1-.19.19-.29.3-.18.34-.04.59.3.7.07,0,.15-.02.22-.02.06-.04.15-.14.22-.11,0,.26.02.52.03.78.03.08.11.23.09.32-.03.02-.06.03-.1.05-.02.05-.02.1-.03.15-.04.02-.07.05-.11.08,0-.06-.02-.11-.02-.16-.09,0-.16.11-.24.17-.15.05-.36.09-.5.02v-.03s.04-.09.05-.15c-.02,0-.03,0-.04.02,0,.02,0,.05,0,.07-.2.13-.23.02-.28.26-.07,0-.15-.15-.17-.21.05,0,.1-.02.15-.02-.05-.02-.1-.04-.15-.06.05-.08.11-.16.16-.24.19,0,.38,0,.57.02.02-.02.05-.05.08-.07-.09,0-.18.02-.27.03,0-.02,0-.03.02-.05.15-.18.28-.38.52-.24,0,.02.02.03.04.05,0-.02.02-.02.03-.03-.05-.08-.15-.11-.23-.15-.06-.26-.06-.3-.27-.4-.31-.05-.65,0-.95-.1-.07-.05-.31-.18-.31-.3-.09,0-.11-.26-.12-.31,0-.23.06-.44.17-.63-.23-.15-.53-.13-.8-.1v-.02c.19-.04.38-.09.57-.11.11,0,.44-.04.53.05-.18.09-.23.38-.15.54,0,0,.02-.02.04-.02-.06-.18,0-.34.11-.48.04-.02.08-.04.13-.06-.42-.21-.99-.06-1.41.06-.22.11-.44.21-.65.32-.13.09-.25.18-.37.27-.23.19-.43.45-.59.71-.08.06-.18.11-.27.13,0-.18-.04-.36.05-.55.06-.08.11-.16.18-.24-.04-.13-.26.28-.27.33-.05.24-.06.61.12.8.04.02.08.03.13.06-.12.15-.17.3-.1.49,0,.06-.06.07-.11.1-.02.06-.03.11-.05.17-.03.02-.06.03-.09.06-.02-.06-.02-.11-.03-.15h-.05c-.1.15-.61.36-.71.15-.22,0-.23.03-.26.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m9.57,35.54c-.05-.07-.09-.14-.13-.2.06,0,.1,0,.15-.02.03.07.02.14.02.22h-.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m11.95,35.53c-.03-.08-.06-.15-.1-.23.06-.06.11.03.14.07-.02.05-.03.1-.04.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m7.16,35.51c-.04-.09-.15-.2,0-.2.02.06.04.12.02.19,0,0-.02,0-.02.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m7.39,35.51c-.05-.06-.09-.13-.13-.19h.15c0,.06,0,.12.02.19h-.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m12.17,35.51c-.06-.06-.11-.13-.16-.19.05,0,.11-.02.16-.02,0,.06.02.15,0,.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m9.57,35.31s-.08-.02-.12-.02c.08-.16.23-.28.33-.42.06.02.11.06.18.09v.02s-.08-.02-.11-.03c-.14.06-.21.23-.24.36h-.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m7.38,35.3s-.07-.04-.12-.05c.09-.13.2-.34.35-.41.05.04.1.08.15.12-.05,0-.1-.02-.14-.02-.12.08-.19.23-.23.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m6.65,35.28c-.29-.45-.87-.62-1.36-.44,0-.07.82-.46.92-.52.11-.11.21-.22.32-.32.14,0,.28.02.42.03-.02.03-.04.06-.06.1-.27.38-.27.69-.24,1.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m12.15,35.28s-.07-.06-.12-.03c.02-.17.23-.31.35-.41.06,0,.15.06.19.1-.06,0-.11-.02-.17-.02-.11.11-.17.22-.24.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m9.26,35.27c.06-.11.16-.42.35-.33,0,.06-.17.24-.21.32-.05,0-.1,0-.14.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m7.07,35.26c.06-.12.15-.41.34-.32-.06.09-.13.19-.19.28,0,0,0,.02,0,.04-.05,0-.09-.02-.14,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m11.93,35.24s-.05-.02-.06-.02c0-.11.17-.25.23-.33h.07s0,.02.02.02c-.1.11-.16.2-.22.32h-.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m13.43,35.07c-.07-.11-.06-.13,0-.25h.03s-.02.08-.02.13c0,.03.02.06.02.11,0,0-.02,0-.02.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m8.67,35.03c-.08-.08-.06-.2-.03-.31.02-.06.05-.11.08-.17-.03-.04-.08-.07-.08-.13.02,0,.03,0,.06,0,.14.17.1.17-.02.37,0,.05,0,.11,0,.16,0,.02.02.04.02.06-.02,0-.03,0-.04.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m11.03,35.02s-.03-.02-.04-.02c.02-.04.03-.08.05-.11.07-.11.22-.18.3-.29-.06,0-.11-.02-.15-.02,0-.02.02-.03.02-.04h.16c.11.11-.21.3-.27.35-.02.04-.05.08-.07.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m5.08,34.9c0-.24-.08-.38-.25-.55-.11-.07-.23-.17-.35-.19v-.02c.28-.03.57-.08.84-.16.2-.08.41-.16.62-.24.09,0,.18,0,.27,0,.05.05.1.11.15.16-.02.11-.23.25-.32.32-.36.2-.7.38-.98.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m15.29,34.58c-.12-.02-.23-.03-.35-.05.02-.17.08-.32.16-.47.02,0,.04-.02.06-.02,0,.1.28.16.35.17,0-.02,0-.03,0-.05-.11-.02-.21-.06-.3-.13.08-.11.07-.21.08-.35.19-.32.37-.65.48-1.01,0-.21,0-.42,0-.63.16-.05.32-.1.49-.14-.04.46,0,.93-.03,1.39-.02,0-.03.02-.05.03-.05-.05-.07-.07-.15-.06-.04.12-.08.24-.12.36v.19h-.12c0,.23,0,.48,0,.72-.15.05-.34.02-.49.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m13.9,34.36c-.09,0-.17-.02-.25-.02,0-.13-.02-.26-.02-.38-.03-.05-.06-.09-.1-.13.04-.05.08-.1.12-.14.03.03.06.06.11.1.09.02.18.05.27.07v-.05c-.11-.02-.26-.04-.31-.15.06-.02.14-.11.15-.18.15.05.31.1.46.15-.02.22-.05.44-.07.67-.12.02-.23.03-.35.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m15.97,33.81s-.02-.09-.02-.13c0-.06.02-.13.04-.19.35-.04.73-.11,1-.34.1-.14.18-.25.21-.42,0-.11,0-.23,0-.33-.72-1.63-2.66.83-3.78.12-.05-.06-.1-.11-.15-.16-.08-.19-.1-.39-.02-.59.04-.06.09-.13.14-.19.1-.05.19-.11.29-.14h.3c.19.11.22.17.22.39-.02.04-.03.08-.04.12.04,0,.09,0,.14,0-.12.15-.25.2-.44.23.06-.13.07-.27.09-.4.04.03.09.06.14.11.07-.19-.03-.3-.19-.35h-.1c-.32.09-.51.31-.44.65.1.17.19.23.38.31h.29c.61-.16,1.19-.51,1.76-.77.11-.04.21-.08.32-.11.12-.02.24-.03.36-.05.47,0,.74.16.95.58.02.08.03.16.05.24,0,.14,0,.28,0,.43-.09.32-.24.52-.53.7-.09.03-.17.07-.25.11-.14.03-.27.06-.41.11-.11.02-.22.03-.32.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m14.5,33.24c-.12-.05-.24-.1-.36-.14,0-.14.19-.35.26-.46.1-.04.2-.08.31-.12,0,.06-.06.23-.04.28h.04c.02-.11.05-.22.07-.32.05-.02.1-.05.15-.06,0,.17-.03.61-.15.73-.06,0-.11-.02-.17-.02-.02.04-.06.07-.06.12h-.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m4.09,33.1s.03-.06.06-.1v-.17s-.07-.08-.11-.11c-.16,0-.25-.03-.25.16,0,.02.02.05.04.08-.15-.04-.54-.4-.48-.53.02-.02.03-.02.05-.03.09.04.19.1.28.04.02-.03.03-.06.06-.1,0-.17-.04-.32-.19-.39-.09,0-.17-.02-.25-.02-.02-.06-.02-.11-.03-.15.05-.03.11-.06.16-.1.12,0,.24.02.36.03.02.06.03.13.06.2h.05c-.02-.1-.05-.19-.07-.29-.12.06-.2,0-.32,0-.02-.06-.02-.11-.03-.16.14-.09.32-.07.48-.08.02.13.04.26.06.4.08-.02-.02-.39-.02-.46,0,0-.02-.02-.02-.02-.08.02-.16.03-.23.05,0-.05-.02-.1-.02-.14.02-.02.36-.06.43-.06.02.1.04.19.06.29,0,.27-.06.46.02.72.04.06.09.12.14.19.02,0,.05,0,.07,0,.02-.02.04-.04.06-.06.08.17.2.31.34.44.08.07.16.15.25.23-.33.04-.66.09-.99.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m16.08,32.96c0-.13,0-.26.02-.39h.06c0,.13-.02.26-.02.39h-.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m13.79,32.39s-.02-.02-.02-.03c.1-.02.19-.03.29-.05.11-.05.23-.13.32-.2,0,.05,0,.1,0,.15-.19.07-.38.11-.58.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m13.61,32.31c-.11-.11-.11-.19-.11-.35.08-.17.16-.23.35-.27-.02.02-.02.03-.03.06v.27c-.02.11-.14.22-.2.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m14.5,32.31c.02-.36.11-.82-.06-1.16-.39-.34-.84-.55-1.31-.78-.51-.38-1.08-.91-1.26-1.54.18,0,.45,0,.6.11.12.24.24.49.4.7.15.15.32.31.48.46.56.4,1.21.64,1.83.92-.02.09-.06.17-.06.26h.05c0-.08.02-.17.08-.23.06.02.11.05.17.08-.13.31-.27.64-.44.93-.04.02-.08.04-.11.06,0-.15.11-.43.19-.56,0-.02-.03-.02-.05-.02-.08.21-.16.42-.23.63-.1.04-.19.08-.27.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m8.04,32.21c-.15-.15.14-.11.18-.11-.02-.06-.04-.11-.06-.17.09-.15.08-.38.07-.55-.02-.03-.03-.06-.04-.08-.16-.19-.29-.32-.54-.32-.36.1-.54.54-.15.74,0-.17.02-.27.21-.27.19.09.15.31,0,.42-.25.06-.43,0-.57-.22-.02-.05-.03-.1-.04-.15,0-.57.37-.83.85-1.07.25-.07.51-.15.77-.22.75-.1,1.54-.15,2.21-.53.06-.07.14-.14.21-.2-.18.44-.69.58-1.11.69-.73.11-1.55.18-2.19.58-.04.03-.1.06-.1.11.09.02.19.05.28.08.06.05.14.1.21.15.06-.04.11-.08.18-.11.06-.03.13-.06.19-.08.11-.03.21-.06.32-.08.46-.04.92-.09,1.37-.2v.02c-.41.12-.83.19-1.26.23-.25.06-.49.16-.73.27,0,0-.02.02-.02.03.03.14.06.27.11.42.13-.06.27-.11.4-.16.19-.03.39-.11.58-.11v.02c-.32,0-.72.19-1,.32,0,.19-.1.4-.23.53-.04,0-.08,0-.12.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m8.76,32.05c-.06-.02-.06-.05-.08-.1.05-.05.04-.03.11-.05,0,.02,0,.05.02.07.11,0,.09-.11.06-.19-.03-.02-.06-.03-.1-.04-.15,0-.23.06-.35.15,0-.06,0-.13.02-.19.57-.32,1.33-.42,1.98-.42,0,0,.02.02.03.02-.24.1-.32.19-.32.44-.4.02-.82.09-1.19.26-.06,0-.13.02-.19.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m7.93,31.87c.07-.22.09-.35-.08-.52-.16-.08-.31-.04-.43.08,0-.15.05-.19.15-.29h.25c.12.1.21.18.28.32v.18c-.02.07-.04.15-.06.22-.04,0-.08,0-.12,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m15.73,31.71c-.05-.19-.11-.41-.23-.57-.47-.26-1.01-.46-1.5-.7-.19-.11-.37-.22-.55-.32-.12-.11-.24-.21-.36-.32-.08-.09-.15-.18-.23-.26-.27-.39-.41-.73-.5-1.2h-.05c.02.18.06.36.12.53-.36-.16-.9-.11-1.29-.12-.66-.05-1.32-.16-1.96-.34v-.02c.1-.06.19-.12.29-.18.27-.25.55-.5.82-.75.05.02.1.07.15.06.05-.11.1-.22.15-.32-.02-.02-.05-.05-.06-.06.03-.07.07-.15.11-.21.13-.04.15-.21.26-.27.17-.02.35-.05.53-.07.08.33.32.18.57.18.2.07.41.15.62.23.28.36.57.72.87,1.08.11.18.27.36.4.53v.96c-.09.11-.06.25,0,.36.04.02.08.06.13.09.06,0,.11,0,.17,0,.21-.06.3-.31.15-.49,0-.15,0-.3,0-.44.15.12.36.36.52.44,0-.02,0-.03.02-.04-.17-.34-.3-.79-.53-1.08,0-.26,0-.52,0-.77.27.09.53.19.8.28.22.12.53.19.77.28-.19.6-.47,1.28-.2,1.9.07.11.15.21.22.32.21.12.44.19.67.25-.1.29-.19.58-.27.88-.06,0-.13.02-.19.02.02-.21.03-.44.14-.63v-.06c-.06-.06-.19-.09-.23-.15-.02,0-.03.02-.05.02.04.08.15.08.22.15-.03.11-.06.23-.1.34-.02.12-.03.25-.04.38-.12.03-.23.06-.35.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m3.22,31.63c.04-.06.11-.12.19-.1,0,0,0,.02.02.04-.07.02-.15.03-.21.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m8.44,31.51c0-.11-.05-.23-.08-.33.11-.06.23-.11.36-.16.09-.03.18-.06.27-.08.47-.05.93-.11,1.37-.27-.02.04-.05.08-.06.12,0,.19,0,.32.18.43-.69,0-1.38.04-2.03.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m5.57,31.48s-.06-.03-.09-.04c.04-.29.08-.58.12-.87.06,0,.08.06.13.07,1.3-4.12,2.6-8.23,3.91-12.35,0,0,.02-.02.02-.02.02,0,.05.02.08.03-.04.14-.07.27-.11.42-1.26,3.97-2.52,7.94-3.78,11.92,0,.02,0,.03,0,.05h.13c-.06.12-.32.73-.44.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m5.83,31.38c.05-.11.1-.2.15-.3.05.15-.03.23-.15.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m3.46,31.36c0-.1.11-.12.19-.12,0,.02,0,.05.02.08-.09,0-.13,0-.2.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m9.4,31.32v-.02h.04v.02h-.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m5.36,31.18c0-.11-.04-.28.06-.38-.02.12-.04.25-.06.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m18.52,31.08c-.15-.06-.29-.11-.43-.17-.04-.02-.08-.05-.11-.07-.05-.06-.09-.12-.13-.18.06-.13.13-.25.2-.37.02-.11.05-.23.08-.33.08,0,.22.16.27.23-.08.32.04.69.31.88-.06,0-.13,0-.19.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m8.23,31.04c-.06-.05-.11-.1-.17-.14-.07-.03-.15-.06-.21-.08.28-.28.85-.37,1.22-.44.4-.07.79-.15,1.19-.21.11-.03.21-.06.32-.09-.02.09-.02.19-.03.28.02.03.06.06.09.1-.27.07-.53.15-.78.22-.48.04-1.21.04-1.62.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m5,31.02c-.03-.09-.08-.17-.08-.27.03,0,.06,0,.11,0,0,.09-.02.18-.02.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m17.39,30.92c0-.07.02-.15.04-.21-.02-.35-.03-.7-.04-1.03,0-.02,0-.02.02-.03.24,0,.47.13.67.26-.02.25-.14.5-.27.71-.15.1-.28.2-.42.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m6.05,30.57s.02-.06.03-.1c-.02.03-.02.06-.03.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m5.21,30.51c-.04-.12-.11-.23-.06-.35.06,0,.14,0,.18.04,0,.07-.06.28-.12.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m5.22,30.39c-.02-.06-.04-.1-.04-.18h.06s0,.13-.02.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m5.49,30.31s.03-.08.06-.12c.06,0,.12.06.17.11-.08,0-.15,0-.23.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m6.22,30.27v-.02h.02v.02h-.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m18.42,30.13c-.27-.32-.65-.48-1.03-.57-.08-.12-.06-.24-.06-.38,0-.1-.24-.57-.03-.57.4.23.78.57,1.04.95.04.07.08.15.13.22,0,.11,0,.23,0,.36h-.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m14.07,29.97c-.14-.05-.28-.26-.15-.4,0-.3.02-.59.03-.88.02.02.04.05.06.08,0,.25.02.5.02.75-.15.07-.18.2-.07.35.19.1.34,0,.34-.21-.02-.03-.06-.14-.12-.14,0-.19,0-.39,0-.57.02.02.05.05.07.07,0,.17,0,.35.02.53.02.04.04.08.06.12,0,.22-.09.27-.28.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m14.09,29.88c-.12-.09-.19-.22-.03-.32h.12c.08.06.07.13.07.23-.06.02-.11.05-.16.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m3.24,29.61c0-.14-.02-.27-.02-.4.12-.02.24-.03.37-.05,0-.02,0-.03,0-.05-.14,0-.27.02-.4.04-.04-.19,0-.38,0-.57-.03-.02-.06-.05-.09-.07-.1-.19.09-.37.21-.49.17-.6.61-1.07.94-1.59.03-.13.06-.26.11-.38.11-.15.27-.28.47-.28.11.06.23.11.35.18.15.03.29.06.44.11.4.19.97.61,1.41.32-.14.43-.28.86-.41,1.29-.33-.27-.68-.55-.97-.86-.21-.18-.37-.34-.61-.44h-.19c-.1.02-.19.06-.27.09,0,0,0,.02,0,.04,0,0,.02,0,.03,0,.17-.07.32-.1.5-.06-.21.04-.48.15-.63.3-.11.21-.19.44-.27.67-.09.15-.23.3-.33.44-.04.07-.08.15-.11.23-.02.08-.03.16-.05.24-.22,0-.17.31-.11.44.03.04.06.08.1.12,0,.18.14.28.24.41-.19.24-.41.27-.7.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m7.28,29.58c.15-.28.33-.55.5-.81.06,0,.11.02.17.02.05.26.1.52.15.78-.12-.02-.23-.04-.35-.06-.16.02-.32.03-.48.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m8.29,29.54s-.1-.03-.15-.04c-.02-.13-.17-.61-.12-.71.25-.12.46-.44.62-.66.37-.59.75-1.21,1.16-1.78.19.19.23.49.31.74.05.11.1.21.15.32-.26.24-.52.49-.78.73-.39.24-.71.42-.93.82-.02.16-.03.33-.05.5-.07.05-.13.07-.22.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m7.11,29.52c-.15-.05-.43-.15-.43-.34.19.02.38.04.57.02.07-.02.15-.05.22-.07,0,.09-.16.3-.21.38-.06,0-.11,0-.15.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m14.12,29.52c0-.22,0-.44,0-.65,0,0,.02,0,.02.02,0,.21,0,.42,0,.63h-.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m18.38,29.52c-.14-.16-.36-.48-.54-.57.11-.29.19-.61.25-.93.06.06.13.11.19.18,0,.4.03.79.11,1.19,0,.04,0,.08,0,.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m14.78,29.4c-.23-.21-.46-.42-.69-.62-.06-.07-.11-.15-.16-.22-.5-.65-1-1.29-1.5-1.93-.02-.02-.03-.03-.04-.05-.14-.17-.27-.34-.4-.51.02-.08.22-.25.29-.25.34.43.67.9,1.03,1.32.18.27.44.54.62.82.15.2.32.4.48.61.12.28.24.56.37.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m17.78,28.9c-.14-.14-.34-.28-.52-.35-.05-.65-.14-1.92-1.1-1.74,0,.14,0,.28,0,.43-.03.17-.06.34-.1.51-.53-.19-1.06-.39-1.58-.57-.05-.06-.09-.13-.13-.19-.09-.05-.3-.1-.38-.02-.16-.06-.32-.11-.47-.16.2-.13.4-.36.52-.57.04-.16.08-.32.12-.47,0-.13,0-.25,0-.37.56,0,1.12.35,1.52.69.1.12.19.25.3.38.1-.04.21-.07.32-.11.27-.03.49-.02.76.02.3.1.53.34.71.58.05.11.11.23.16.34.02.06.03.13.06.19.06.45.05.99-.19,1.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m7.85,28.75s-.1-.1-.14-.14c0-.22.07-.2.24-.23.11.06.17.21.06.32-.06.02-.11.03-.17.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m8.21,28.47s-.02-.02-.02-.03c.06-.08.11-.15.17-.23,0,0,.02.02.02.04-.06.07-.12.15-.18.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m8.05,28.39s-.02-.03-.02-.04c.55-.8,1.1-1.6,1.66-2.4,0,.02,0,.03.02.05-.39.56-.78,1.12-1.16,1.69-.16.22-.32.44-.48.67v.03h-.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m14.28,28.31c-.15-.15-.07-.48-.08-.68.03,0,.06-.02.1-.02,0,.23-.02.47-.02.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m3.51,28.23s0-.08,0-.11c.1-.26.31-.48.46-.71,0,.02,0,.05.02.07-.13.19-.26.37-.39.57-.02.06-.03.11-.04.17-.02,0-.03,0-.04.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m15.95,28.17c-.54-.2-1.08-.4-1.61-.61.08-.08.13-.19.15-.31.02,0,.05,0,.08,0,.27.11.55.21.82.32.22.08.44.16.67.24-.03.11-.06.23-.08.35h-.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m8.55,28.15c-.06-.03-.12-.06-.18-.09,0-.02,0-.05.02-.06.45-.66.91-1.33,1.37-1.99.02,0,.06,0,.09.02-.05.09-.09.18-.13.27,0,0,.02,0,.04.02-.4.61-.79,1.25-1.21,1.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m14.13,28.11s-.02-.02-.03-.02v-.44s.02-.02.02-.02c0,.16,0,.32,0,.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m7.45,28.09c-.22-.06-.43-.15-.62-.28.28-.91.57-1.82.87-2.72.31.14.61.28.93.43.34.12.69.25,1.03.38,0,.02-.02.03-.02.06-.46.67-.92,1.34-1.38,2.02-.07-.02-.15-.11-.23-.11-.18.18-.32.22-.58.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m14.03,27.99s-.06-.07-.08-.11v-.28s.05,0,.08.02v.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m13.89,27.81s-.03-.04-.04-.06c-.1-.12-.19-.24-.28-.36-.02-.02-.02-.03-.03-.05.15.02.27.07.35.19,0,.09,0,.19,0,.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m14.05,27.58c-.17-.1-.22-.15-.22-.36.07-.23.3-.32.5-.17.02.04.05.08.08.13,0,.08-.02.16-.02.24-.04.03-.08.07-.11.11-.08,0-.16.02-.23.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m14.07,27.52c-.16-.1-.18-.13-.18-.32.04-.14.13-.15.26-.17.17.04.2.15.2.31-.05.15-.15.15-.28.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m10.4,27.47c-.06-.07-.11-.15-.16-.21-.06-.23-.19-.87-.44-.99.03-.06.06-.12.1-.18.06,0,.09.04.15.06.21.32.17.85.51,1.08,0,.07-.12.15-.12.25h-.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m14.09,27.47c-.12-.06-.19-.17-.1-.31.13-.09.23-.09.32.06,0,.05,0,.1,0,.15-.07.06-.12.07-.2.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m13.77,27.36c-.11-.04-.21-.08-.31-.12-.03-.04-.23-.27-.2-.3.04,0,.08-.02.12-.02.11-.11.29.03.43.06.02.02.05.03.07.05-.06.11-.12.18-.1.32,0,0-.02,0-.02.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m10.48,27.1c-.16-.25-.23-.57-.31-.86-.08-.13-.15-.15-.02-.27h.02c.18.18.33.4.53.56.05.02.11.05.16.07-.06.08-.13.16-.19.25-.15.03-.11.19-.2.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m12.55,26.92c-.16-.06-.32-.13-.48-.19.11-.02.19-.06.3-.06.03.04.21.23.18.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m13.24,26.9c-.14-.04-.25-.23-.32-.36-.1-.12-.19-.24-.28-.36-.08-.04-.21-.27-.27-.36.02-.02.05-.02.08-.02.14.16.28.23.49.15.11.05.21.09.32.11,0,.2.06.41.11.61,0,.06,0,.13,0,.2-.05,0-.09.02-.13.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m13.44,26.78c0-.06-.02-.13-.02-.19.05-.05.1-.1.15-.14.19-.19.27-.38.32-.65,0-.19,0-.36,0-.54.03-.07.07-.1.15-.07,0,.04.02.08.02.13,0,.44,0,.79-.28,1.16-.12.1-.23.19-.35.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m11.63,26.76s-.08-.08-.12-.11c-.02-.04-.03-.08-.05-.11-.17,0-.34.02-.51.02-.34-.08-.5-.4-.73-.62-.03,0-.06,0-.08,0,0-.19.14-.22.28-.22.14.09.18.28.24.43.06.06.14.13.21.19.07.02.15.04.23.06.21,0,.4-.04.59.04.16,0,.24-.08.24-.24,0-.04-.02-.07-.02-.11h.04c.12.17.25.34.38.51-.23.04-.47.13-.7.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m1.96,26.73c-.16-.08,0-.39.06-.52.13-.02.26-.04.4-.06-.02-.11-.25-.02-.33,0,0-.11.09-.23.19-.27.04-.18.04-.2.15-.31.15-.07.32-.15.48-.21.33-.29.61-.49.99-.72.12-.07.25-.15.38-.21.15-.14.31-.27.47-.4.06-.02.14-.05.21-.06.11,0,.21,0,.32.02.1.14.2.27.31.41.15.13.29.26.44.39-.02.16-.05.32-.06.49,0,.22,0,.44,0,.67-.15-.12-.23-.35-.23-.54h-.05c0,.22.07.51.28.61,0,.05,0,.1,0,.15-.1-.06-.19-.11-.29-.16-.36-.3-.49-.76-.65-1.19-.02-.03-.05-.06-.07-.08.15,0,.23,0,.36.09.04.06.09.12.14.19,0,0,.02-.02.03-.02-.06-.35-.55-.35-.81-.28-.5.2-1,.58-1.45.89-.07.06-.18.21-.24.24-.09-.12-.15-.11-.26-.03-.02.05-.04.1-.06.15,0,.2,0,.4.02.61-.15.04-.28.08-.42.12-.11,0-.21.02-.31.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m13.39,26.54c-.03-.16-.07-.33-.07-.5.04-.04.08-.07.12-.11v-.61c.14,0,.27,0,.41,0,0,.26.02.63-.12.87-.05.06-.1.13-.15.2-.06.05-.13.1-.19.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m6.56,26.43c-.15-.05-.43-.13-.53-.23,0,0,0-.02.02-.02-.02-.3-.02-.6-.03-.89.06-.43.15-.86.32-1.26.32.39.72.66,1.15.93-.14.43-.27.86-.4,1.29-.08.08-.16.14-.28.18-.08,0-.16,0-.24,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m11.69,26.39c-.1-.07-.15-.14-.09-.27.05-.04.1-.08.15-.12.23-.19.47-.36.7-.54.02,0,.04-.02.06-.02.11.04.14.05.16.18-.06.19-.2.15-.32.04-.18.14-.36.28-.53.43.03.07.07.19,0,.25-.05.02-.1.03-.15.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m11.1,26.35c-.1-.04-.19-.08-.28-.12-.02-.02-.05-.05-.07-.06-.09-.17-.14-.42-.32-.52,0-.23.35-.22.49-.32.04.22.16.31.38.23.02-.02.05-.05.08-.07.03.11.08.17.17.23.1,0,.26.04.26.17-.15.11-.36.21-.27.43-.15,0-.29.02-.44.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m9.98,26.07s-.03-.03-.04-.04c.02,0,.03-.02.06-.02,0,0,.02.02.03.03-.02,0-.03.02-.05.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m13.16,26c-.06-.03-.12-.06-.18-.1,0-.06.02-.12.02-.18,0-.16-.02-.32-.02-.49.06.02.12.05.19.07.06,0,.13-.02.2-.02,0,.19,0,.4,0,.6-.03.07-.15.09-.22.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m10.05,25.99s.02-.03.02-.04c0,0,0,.02.02.04h-.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m9.83,25.97c-.11-.07-.17-.19-.09-.31.21-.14.34,0,.31.23-.03.02-.06.04-.08.06-.05,0-.1,0-.14.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m12.74,25.95c-.07-.04-.14-.08-.2-.11.07-.02.13-.08.18-.15v-.17s-.08-.08-.11-.11c-.02,0-.05,0-.07,0,0-.06,0-.13,0-.19.06,0,.13,0,.19,0,.05-.04.1-.08.15-.11.02.02.03.06.05.09,0,.27.16.72-.18.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m9.63,25.84s-.02-.02-.03-.03c-.64-.21-1.28-.48-1.88-.78,0-.11.06-.24.11-.36.18.09.36.18.53.27.44.17.88.34,1.33.51,0,.08,0,.19-.03.26v.12h-.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m11.87,25.84c-.18-.23-.35-.45-.52-.67.07-.03.19-.1.22-.17.1.05.23.27.3.36.07.08.21.21.21.32-.07.05-.15.1-.21.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m12.32,25.78s0-.05.03-.02c-.02,0-.02.02-.03.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m10.13,25.77c-.02-.06-.05-.11-.07-.15-.28-.14.03-.92.12-1.12.11-.15.23-.28.34-.42.14.13.27.26.41.39,0,.05,0,.11,0,.16-.12.18-.52.52-.29.74-.06.02-.11.05-.15.07-.07.06-.11.11-.14.2-.1.02-.15.06-.23.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m11.59,25.69c-.11-.07-.16-.15-.14-.29.06.09.14.18.21.27-.02,0-.05,0-.07.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m12.12,25.6c-.05-.06-.1-.13-.15-.19.03-.11.06-.23.1-.33.05-.02.11-.03.16-.04-.04.19-.08.37-.11.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m12.19,25.6c.06-.39.13-.77.2-1.15.06.06-.14.98-.16,1.11-.02,0-.03.02-.04.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m9.75,25.58c0-.15,0-.28,0-.42.06-.54.3-.87.66-1.26.08-.02.15-.15.2,0-.02.02-.02.03-.03.06-.48.43-.71.95-.65,1.61-.06,0-.12.02-.18.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m11.11,25.54c-.18-.12-.13-.29-.02-.44.05.02.1.04.15.06.05.05.1.1.15.15-.02.19-.14.19-.28.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m12.3,25.52c.02-.14.05-.27.07-.4.03.02.06.04.11.06-.02.07-.02.15-.03.23-.05.03-.1.07-.15.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m3.26,25.49s-.02-.03-.02-.05c.05-.03.1-.06.15-.08.06-.06.51-.47.6-.43,0,.05-.03.06-.07.07-.12.1-.24.2-.36.31-.1.06-.19.11-.29.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m9.65,25.4c-.61-.23-1.24-.48-1.81-.78,0,0,0-.02,0-.02.15-.49.32-.98.48-1.46.28.04.57.09.85.14,0,.16.22.26.33.32,0-.06.02-.11.04-.16.02-.03.03-.06.06-.1h.19c0,.15.21.23.31.31.04.11.09.23.14.36-.17.2-.28.41-.41.64-.04.13-.08.26-.11.4,0,.12,0,.24,0,.36h-.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m10.7,25.34c-.08-.08-.07-.15-.04-.26.11-.15.21-.29.32-.44.02,0,.03.02.05.02-.02.08-.03.17-.04.26,0,.05.02.1.04.15-.03.07-.11.18-.17.23-.06,0-.11.02-.15.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m11.92,25.34c-.1-.12-.19-.24-.28-.36,0-.09.1-.13.15-.18.04.14.11.2.23.26-.03.09-.06.19-.1.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m13.2,25.28c-.18-.06-.19-.09-.28-.24,0-.15.02-.31.04-.45.02,0,.04-.02.06-.02.12.14.24.27.37.42,0,.08.02.17-.03.23-.06.02-.11.04-.16.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m12.58,25.16c-.19-.08-.2-.1-.18-.3.02-.12.05-.24.07-.36.06.04.12.08.19.12.08,0,.16-.02.24-.02-.02.1-.03.19-.04.3-.02.05-.04.1-.06.15-.08.03-.15.06-.23.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m11.26,25.12c-.06,0-.15-.1-.19-.13-.18-.54.67-.45.44,0-.08.08-.15.1-.25.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m13.71,25.12c-.27-.13-.45-.36-.65-.58.02-.02.06-.05.09-.06.08.09.43.61.61.49,0-.22-.37-.4-.52-.49h-.02v-.03c.28,0,.54.19.66.44,0,.05,0,.11,0,.16-.05.05-.11.08-.19.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m12.04,25.02s-.1-.07-.15-.11c-.02-.03-.03-.06-.04-.1,0-.27.2-.58.31-.82.02,0,.06.02.09.03-.06.17,0,.22.1.38-.04.17-.07.34-.11.52-.05.06-.12.08-.2.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m13.67,24.94c-.14-.1-.27-.23-.36-.36.15.11.32.21.41.36h-.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m7.49,24.91c-.19-.12-.37-.24-.55-.36-.15-.14-.29-.27-.44-.4-.06-.07-.11-.15-.16-.22.04-.12.09-.23.14-.35,0,0,.02,0,.02,0,.19.22.4.44.61.63.16.11.32.23.49.34-.04.12-.08.24-.11.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m11.61,24.86c-.02-.14-.1-.23-.22-.28v-.03c.15-.23.29-.47.44-.7.09.03.19.06.28.11-.11.24-.22.49-.32.74-.04.06-.11.15-.18.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m11.07,24.64c-.05-.07-.05-.13-.04-.22.16-.23.32-.45.49-.68.07,0,.19.03.24.08-.11.18-.21.36-.32.53-.05.06-.09.12-.13.19-.09,0-.18.06-.25.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m12.68,24.59v-.1c-.07,0-.19.05-.15-.06.02,0,.05,0,.08,0,0-.1-.19-.07-.24-.07,0-.02-.02-.05-.02-.07.05,0,.15,0,.19-.04,0-.02-.02-.03-.02-.04-.06.02-.18,0-.24,0,0-.14.05-.14.17-.08h.17s.02-.05.04-.07h.03v-.04c-.06-.04-.13-.07-.19-.11,0-.02,0-.03,0-.04,0,0,.02-.02.02-.02.11.06.26.06.38.06.14.06.32.32.32.49-.1.06-.19.11-.28.17-.08.02-.16.03-.23.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m7.59,24.49c-.39-.28-.78-.6-1.08-.97,0-.27.18-.65.26-.91.42.16.84.33,1.28.45,0,0,0,.02.02.03-.15.46-.29.93-.44,1.4h-.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m13.27,24.37c-.03-.16-.19-.34-.19-.49.12-.03.23-.02.35-.02.02.11.04.23.06.34.18-.08.99-.49,1.23-.25-.49.1-.98.26-1.46.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m14.28,24.14s-.02-.02-.02-.02c.1-.03.19-.06.29-.09.05,0,.1,0,.15,0-.07.02-.14.06-.2.09-.07,0-.15.02-.22.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m13.55,24.13c0-.06-.02-.11-.02-.16-.02-.05-.03-.1-.05-.15.02-.03.03-.06.06-.08.1,0,.14-.04.22-.08.06-.02.11-.03.18-.05.05-.04.1-.08.15-.11,0-.07,0-.14,0-.2.12,0,.21-.06.34-.06.07-.07.1-.05.2-.06,0-.02.02-.05.04-.06.02,0,.05,0,.07.02.02.23.09.54-.1.73-.4,0-.72.13-1.09.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m12.47,24.07c-.24-.11-.49-.22-.72-.32-.23-.07-.45-.15-.68-.21-.47-.11-.95-.2-1.42-.26.02-.06.04-.07.1-.1.34.05.68.11,1.03.16.25.07.51.15.77.22.29.11.81.25,1.04.49-.04,0-.08.02-.11.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m14.79,23.95s-.06-.05-.09-.07c.15-.24.14-.5.09-.78.02-.03.05-.06.08-.08-.02-.1-.03-.19-.04-.28,0,0,.02,0,.04,0,.22.15.29.48.34.72-.08.11-.15.22-.23.33-.06.06-.13.11-.19.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m16.03,23.91s-.06-.03-.08-.05c-.06-.24.22-.46.44-.43v.15c-.07.07-.15.13-.25.13,0-.03,0-.06,0-.1-.02,0-.03,0-.04,0,0,.03-.02.07-.02.11.11.11.27-.02.36-.11.03-.06.04-.18,0-.23-.06,0-.11,0-.17,0-.07.03-.15.07-.21.11-.19.21-.39.41-.69.37-.1-.22.02-.33.2-.44.06,0,.13,0,.19,0,.05.03.04.11.03.16-.07.06-.15.11-.24.11v-.07s-.03,0-.04,0c0,.02-.02.05-.02.07.09.18.49-.06.31-.3-.19-.07-.37.06-.49.18-.04-.15-.08-.31-.12-.45-.06-.13-.18-.26-.22-.37.27,0,.49.17.72.28.11.03.21.06.32.11.07,0,.15,0,.23.02.15-.02.29-.08.42-.15.07-.05.15-.1.22-.15,0,.11.4.38.44.42,0,.08-.25.35-.34.44-.06.02-.11.06-.16.09-.06,0-.11,0-.15,0-.02-.02-.04-.03-.06-.05v-.13c.11-.13.21-.25.4-.25,0,.14-.06.18-.17.25,0-.02,0-.05,0-.06h-.03s-.02.02-.02.03c.02.19.21,0,.27-.07v-.16s-.02-.03-.03-.04c-.3,0-.52.34-.73.52-.09.02-.17.06-.25.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m12.35,23.83s-.06-.02-.08-.03c.05-.02.1-.04.15-.06,0,0,0-.02,0-.02,0,.02.02.03.04.06-.03.03-.06.05-.11.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m12.68,23.83s.07-.05.11-.06c0,.02.02.03.03.05-.05,0-.1,0-.15.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m12.94,23.83s-.06-.05-.1-.06c0-.17-.03-.38.03-.54.1,0,.19.02.29.03-.02.16-.03.32-.05.49-.06.04-.11.07-.18.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m13.31,23.83c-.07-.03-.1-.05-.12-.12.02-.16.03-.32.06-.49h.15s.1.02.15.04c-.02.15-.03.31-.05.47-.04.06-.11.09-.18.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m13.15,23.82s0-.02.02-.03c0,0-.02.02-.02.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m12.56,23.78s-.06-.06-.09-.09c0-.18.02-.35.04-.52h.05c.07.06.15.07.24.08-.02.15-.03.3-.05.45-.02.02-.05.03-.07.06-.04,0-.08,0-.12.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m12.22,23.74s-.06-.06-.1-.08c0-.18.02-.36.03-.53h.05c.06.06.16.07.25.07,0,.11-.02.43-.09.49-.05,0-.1.02-.15.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m12.08,23.72s-.03-.02-.04-.03c0,0,.02-.02.04-.02v.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m13.55,23.68c0-.15.02-.29.04-.43.13-.07.13-.13.16-.26.02,0,.03,0,.06,0,.02.13.02.4.23.36v.12s-.1.06-.15.11c-.11.03-.23.07-.34.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m11.96,23.67c-.07-.03-.14-.06-.2-.08.02-.17.03-.33.05-.49.1.05.18.05.29.05-.02.16-.05.32-.06.49-.02,0-.05.02-.07.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m10.09,23.6c-.12-.06-.19-.12-.26-.23.12,0,.24.02.36.04.03.06.06.13.11.19h-.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m11.67,23.56c-.06-.02-.11-.04-.16-.06,0-.13,0-.25.02-.37.07-.02.15-.04.22-.06-.02.16-.03.32-.04.49h-.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m9.44,23.54c-.2-.15-.27-.26-.27-.52.02-.09.06-.17.09-.25.05-.07.1-.14.15-.2,0-.11,0-.22,0-.32.16-.18.31-.29.34-.53h.03s.1.11.15.16c.15.27.25.71.05.99-.21.19-.44.39-.52.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m13.95,23.29c-.06-.06-.11-.36-.09-.44.02-.02.06-.04.09-.06.03.15.06.31.1.46-.03,0-.06.02-.1.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m14.14,23.24c-.07-.07-.11-.38-.12-.49.05,0,.1,0,.15.02.02.15.04.29.06.44-.03,0-.06.02-.1.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m9.1,23.22c-.26-.05-.52-.09-.77-.13,0-.03,0-.06.02-.09.25.04.51.08.77.13,0,.02,0,.06,0,.09h-.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m13.47,23.21s-.07-.06-.11-.1c0-.1,0-.19,0-.28.06-.06.15-.07.19-.15,0-.03.02-.06.02-.08.02.06.04.16.11.19,0,.11-.02.21-.02.32-.05.06-.13.08-.2.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m12.68,23.2s-.06-.06-.09-.08c0-.12.02-.24.02-.36.04-.02.08-.05.13-.06.02.02.04.04.06.06.04.02.08.03.12.06,0,.12,0,.27-.1.36-.06,0-.11.02-.15.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m13.08,23.2s-.05-.02-.07-.02c-.02-.02-.03-.05-.04-.07,0-.26,0-.27.19-.39.05.03.11.06.16.1-.02.12,0,.32-.13.37-.04,0-.08,0-.11.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m10.1,23.18c-.1-.02-.19-.03-.29-.04,0-.08.07-.13.13-.17.07.02.15.03.22.06,0,.05,0,.1.02.15h-.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m14.33,23.18c-.06-.06-.14-.38-.11-.45.03-.03.06-.06.11-.1.02.07.14.43.08.54-.03,0-.06,0-.08,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m12.3,23.14s-.06-.06-.1-.09c0-.11.02-.23.03-.34.05-.03.1-.06.15-.08.06.06.1.11.18.12-.02.11-.04.23-.06.34-.06.03-.12.04-.2.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m14.54,23.13c-.11-.11-.13-.37-.15-.53.04-.02.09-.02.14-.03,0,.17.08.35.08.52-.02,0-.05.02-.07.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m11.92,23.1s-.06-.05-.08-.07c0-.13,0-.25.02-.37.05-.02.11-.05.16-.06,0,.06.11.1.15.12,0,.14,0,.32-.13.38-.04,0-.08,0-.12,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m16.11,23.09c-.35-.08-.65-.27-.99-.4h-.31c-.02-.08-.03-.16-.05-.23.02-.06.03-.11.05-.17.24,0,.51.26.69.39.11.06.21.11.32.17.1.02.19.05.29.08.18,0,.36,0,.54-.02-.16.14-.36.17-.55.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m9.06,23.08c-.23-.05-.46-.1-.69-.14.12-.4.24-.78.36-1.17.26.11.16.11.23-.12.02-.04.04-.07.06-.11h.02c0,.11.02.21-.03.31-.19.13-.19.41-.11.61.06.07.17.23.28.2,0-.04,0-.08.02-.12.04-.1.07-.16.14-.23,0,.06,0,.13,0,.2-.07.19-.24.32-.24.57h-.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m11.43,23.08v-.02h.02v.02h-.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m11.55,23.06s-.06-.03-.09-.05c-.04-.12-.02-.25,0-.38.05-.02.11-.04.16-.06.05.02.11.05.16.08-.02.11-.03.21-.04.32-.06.02-.13.05-.19.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m14.72,23.06c-.11-.16-.14-.4-.14-.59.02,0,.05-.02.07-.02v.03s.04,0,.06,0c.02.15.13.42.06.57-.02,0-.04,0-.06,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m8.07,23.02c-.57-.17-1.12-.4-1.65-.65,0-.05.05-.1.1-.1.15.07.29.15.44.22.31.12.61.24.92.36.07.02.15.05.23.07,0,.02-.02.06-.02.09,0,0-.02,0-.02,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m16.27,22.89c-.19-.03-.37-.09-.56-.16-.29-.19-.58-.49-.94-.5-.07-.28-.15-.56-.21-.83-.02-.14-.05-.27-.07-.4.06.04.14.08.21.12.41.31.73.75,1.15,1.05.1.05.19.1.3.16.31.09.55.09.86.02.09-.03.19-.06.28-.1-.03.34-.42.49-.7.6-.11,0-.22.02-.32.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m8.11,22.87c-.43-.17-.86-.34-1.28-.51-.02-.15-.02-.31-.03-.45.2-.13.37-.29.53-.47.07-.15.15-.31.22-.46.02-.12.05-.24.08-.36v-.78c.06,0,.11,0,.18,0-.02-.08-.02-.16-.03-.23.11.07.11.14.11.27-.15.23,0,.4.18.52.06,0,.14,0,.21,0,0-.06,0-.13,0-.19,0,0,.02-.02.04-.02.02.07.04.12.04.21-.11.19-.09.31.05.48.05.02.1.04.15.06.06,0,.12,0,.19,0v-.1s.02.09.02.11c-.2.64-.44,1.29-.61,1.94h-.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m13.77,22.81c-.02-.07-.03-.14-.04-.2,0-.24,0-.47.06-.7.04.21.09.42.14.63,0,.15-.02.21-.15.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m12.93,22.75s-.07-.06-.11-.08c0-.16,0-.32.03-.49.1.11.18.1.32.11-.02.12-.03.24-.05.36-.05.07-.11.08-.19.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m13.32,22.75s-.11-.06-.12-.1c0-.15-.02-.35.08-.45.08.06.15.09.25.09,0,.15,0,.31-.07.43-.05,0-.1.02-.14.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m6.27,22.71s-.06-.02-.08-.02c0-.14,0-.29-.08-.41.11,0,.27.11.32.2,0,.06-.02.14-.02.21-.05,0-.1.02-.14.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m14.06,22.71s-.06-.07-.08-.11c-.02-.11-.03-.21-.05-.32-.04-.18-.08-.35-.11-.52.04-.1.1-.2.17-.27.15.31.25.75.25,1.1-.06.06-.11.09-.18.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m11.38,22.7c-.39-.22-.72-.64-.72-1.12.11.03.23.07.36.11.02.1.08.4.23.4v-.05c-.1-.1-.17-.18-.17-.32.06,0,.13.02.2.04,0,.13-.02.22.07.31,0,.14-.06.37.02.49,0,0-.02,0-.02,0-.23-.18-.3-.27-.34-.55-.02,0-.04-.02-.06-.02.03.33.16.48.44.65,0,.02,0,.03,0,.05h-.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m12.54,22.7c-.19-.07-.1-.36-.08-.51.06.02.14.03.21.06.04,0,.08-.02.12-.02-.02.14-.05.27-.06.41-.06.04-.11.06-.19.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m5.37,22.69c-.04-.06-.08-.11-.12-.16-.04-.03-.08-.06-.12-.08,0-.14.1-.23.14-.36.15.02.31.03.46.05,0,0,0,.02.02.02-.22,0-.23.36-.23.49-.03.03-.09.04-.14.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m12.16,22.66s-.06-.03-.09-.05c-.05-.11,0-.32.02-.44.07.02.27.04.3-.03,0,.04,0,.09,0,.14-.02.23,0,.35-.23.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m5.6,22.62s-.02,0-.03,0v-.17c.02-.06.05-.12.07-.18,0,0,.02-.02.03-.02,0,.11,0,.23,0,.35-.03,0-.06.02-.08.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m9.13,22.61s-.08-.08-.12-.11c-.11-.23-.13-.42.06-.61.02-.04.03-.08.06-.12,0-.08.02-.2-.03-.27.15-.18.29-.27.32-.5h.03c.21.27.29.59.19.92-.18.19-.34.36-.46.57,0,.04,0,.08,0,.12h-.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m11.75,22.61s-.06-.04-.09-.09c0-.13.02-.26.04-.39.06,0,.14,0,.21,0,.03-.02.06-.04.1-.06-.02.15-.03.3-.04.45-.06.07-.13.08-.22.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m13.65,22.61c-.05-.53-.02-1.22.44-1.58.1-.03.23-.07.32,0,.02.05.11.19.06.24-.06-.09-.22-.07-.3-.03-.46.36-.49.82-.52,1.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m11.46,22.57s-.04-.05-.06-.07c0-.13,0-.26.02-.39.07-.02.15-.09.21-.02,0,.15-.02.3-.05.44-.04,0-.08.02-.12.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m14.37,22.55s-.05-.06-.07-.08c-.06-.36-.17-.72-.25-1.06.06-.06.1-.1.17-.13.04.12.09.24.14.36.04.23.09.46.14.7,0,.1-.05.16-.12.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m5.36,22.53s-.08-.06-.11-.09c0-.11.08-.18.14-.26h.06c0,.11-.02.21-.02.32-.02,0-.05.02-.06.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m6.03,22.51c0-.09-.02-.18-.02-.26.08.06.09.16.12.26h-.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m5.37,22.49c-.07-.07-.05-.11.02-.18,0,.06-.02.11-.02.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m14.62,22.43s-.06-.08-.08-.12c-.05-.28-.11-.6-.19-.87-.03-.06-.06-.12-.08-.18.39,0,.36.79.47,1.03,0,.08-.06.13-.12.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m16.52,22.36c-.28-.06-.53-.17-.77-.34-.49-.44-.91-1.08-1.6-1.19-.36,0-.65.07-.95.25,0-.02-.02-.05-.02-.07.2-.13.4-.29.52-.49.42-.07.78-.08,1.15.18.22.25.57.75.94.84.08,0,.16,0,.25,0,.04.04.08.08.12.13.25.15.6.23.88.11.23-.11.3-.31.36-.53,0-.26,0-.45-.22-.62-.28-.14-.53-.14-.76.09-.03.06-.06.13-.09.2v.2c.13.27.39.36.61.14.03-.11.06-.28-.02-.39-.11-.06-.15-.07-.27-.02-.03.05-.09.12-.06.19h.05c0-.09.02-.13.1-.17.23,0,.22.23.13.39-.02.02-.05.03-.07.06-.11,0-.21.02-.32-.05-.17-.17-.11-.4.02-.57.3-.19.65-.12.82.19.05.16.02.44-.04.6-.17.24-.32.29-.6.32-.1-.02-.19-.04-.28-.06-.24-.11-.4-.26-.48-.51,0-.11,0-.23,0-.33.13-.4.33-.5.69-.63.12,0,.25,0,.38,0,.19.03.32.11.48.23.32.37.41.8.25,1.27-.19.36-.44.45-.82.56-.13,0-.25.02-.37.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m6.35,22.33c-.13-.06-.26-.13-.38-.19.02-.03.05-.06.07-.1.14.02.26.11.37.17-.02.03-.05.07-.06.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m13.48,22.25c-.23,0-.16-.36-.14-.51.11,0,.2-.03.29-.08-.02.19-.05.37-.07.57-.03,0-.06.02-.08.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m13,22.24s-.09-.06-.11-.12c0-.15.02-.3.04-.44.1-.02.19-.05.27-.1.02.03.05.07.08.11-.02.15-.02.31-.03.46-.08.06-.14.08-.24.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m6.66,22.2s-.05-.1,0-.15h.04v.15h-.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m12.58,22.19c-.18-.12-.11-.31-.08-.51.07-.06.15-.11.22-.16.06.04.07.12.16.15-.02.15-.02.4-.12.5-.06,0-.12.02-.18.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m6.43,22.17c-.13-.06-.25-.13-.37-.19-.02-.03-.02-.06-.03-.1.16-.53.33-1.06.5-1.58.05-.02.1-.02.15-.03.17.11.54.3.54.54-.11.44-.43.85-.92.85,0,0,0,.02,0,.04h.28c-.02.14-.06.33-.11.46,0,0-.02,0-.02,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m12.17,22.15c-.18-.09-.14-.22-.11-.4.12-.02.24-.05.37-.06-.02.12-.03.24-.05.36-.06.06-.13.09-.22.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m5.83,22.13c-.13-.08-.14-.17-.02-.28.16,0,.19.04.19.2-.04.06-.11.06-.16.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m11.75,22.09s-.08-.07-.12-.11c0-.11.02-.2.02-.3.11.02.23.04.35.06,0,.08-.02.16-.02.24-.06.07-.14.09-.23.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m5.67,22.08c-.15-.02-.31-.04-.46-.06v-.15c.15.02.31.03.46.05v.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m11.42,22.05s-.05-.05-.07-.06c0-.16,0-.33.02-.49.06.05.13.1.2.15,0,.15.03.38-.15.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m5.68,21.89c-.14-.02-.27-.05-.4-.06-.03-.11-.06-.21-.08-.31-.02-.23-.05-.45-.06-.68-.03-.04-.06-.07-.1-.11-.02-.19-.03-.37-.04-.55.09-.03.19-.06.28-.08.34-.05.69-.02,1.02.04,0,.02.02.03.02.05-.17.53-.34,1.06-.51,1.59-.05.03-.09.06-.13.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m6.69,21.89s-.02-.08-.03-.12c.09-.06.19-.11.28-.16.32-.25.42-.61.52-.99,0-.28-.02-.56-.02-.83.03,0,.06.02.11.03.03.34.04.68-.02,1.02-.06.15-.11.29-.16.44-.11.17-.24.32-.4.45-.1.05-.19.1-.27.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m5.97,21.82s-.06-.02-.08-.02c0-.04,0-.07,0-.11.15-.47.31-.94.46-1.41,0,0,.02-.02.02-.02.03,0,.06.02.11.04-.17.5-.33,1-.49,1.5,0,0-.02,0-.02.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m8.86,21.78c-.06-.06-.06-.06-.08-.14.13-.41.26-.82.4-1.24.05,0,.15.37.17.44,0,.11-.02.21-.02.32-.15.17-.44.36-.44.62h-.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m6.68,21.7s-.02-.04-.02-.06c.21-.11.33-.27.48-.45.03-.09.06-.18.11-.27,0-.07.12-.64-.03-.57-.11-.08-.22-.16-.32-.23-.12-.05-.19-.07-.23-.18.09-.28.19-.57.28-.85.15,0,.22.02.28.15.05.17.11.34.16.52,0,.11.02.21.04.32v.4c-.07.53-.26.97-.74,1.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m11.23,21.7c-.19-.06-.39-.13-.57-.19-.15-.02-.31-.02-.27-.21.32,0,.62.15.91.25v.15h-.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m11.97,21.69c-.27-.09-.47-.16-.68-.37-.06-.08-.13-.16-.19-.23-.06-.11-.35-.58-.13-.65h.16c.04.06.09.1.11.17.04,0,.08-.04.11-.06.04,0,.08.02.12.03.05.25.15.41.32.59.06.03.11.06.17.11.06.02.11.03.17.06.08,0,.16,0,.25,0-.02-.07-.11-.05-.16-.05-.41-.09-.72-.38-.67-.82.05-.05.15-.05.23-.06.02-.05.04-.1.06-.15.02-.02.05-.03.08-.04h.15c-.07.11-.02.37.02.49.11.2.21.27.42.33.06,0,.11,0,.17,0,0,.15.06.2.19.27-.1.08-.19.16-.28.24-.13.04-.25.08-.37.12-.08,0-.16,0-.24,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m13.39,21.69c-.29-.08.03-.49.1-.65.11-.04.21-.08.32-.11h.39c-.09.05-.18.11-.26.16-.06.09-.12.19-.18.28-.09.23-.15.27-.36.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m12.9,21.62s-.06-.05-.1-.06c0-.18.12-.23.27-.28.09-.12.2-.16.32-.23,0,.15-.15.38-.23.5-.08.04-.17.07-.26.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m11.25,21.48c-.27-.1-.53-.19-.79-.29-.02-.06-.04-.08-.04-.16.18-.06.51.12.69.17.06.06.13.14.2.21,0,.02,0,.05,0,.07h-.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m10.28,21.38c-.13-.06-.28-.13-.42-.16,0-.05,0-.07.03-.11.16,0,.33.08.48.14-.04.04-.05.07-.05.13h-.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m12.89,21.27c-.11-.09-.15-.11-.15-.25.06-.11.1-.15.23-.15.16.05.19.24.07.36-.06,0-.11.02-.15.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m5.38,21.24c0-.1-.02-.17.02-.26,0-.06-.12-.12-.14-.2.07-.14.15-.27.22-.4.02,0,.04,0,.06,0,0,.21,0,.4-.08.59-.02.09-.04.18-.06.27,0,0-.02,0-.02,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m12.89,21.24c-.17-.08-.14-.2-.05-.32.1-.03.19-.02.24.07v.16s-.06.04-.08.06c-.04,0-.08,0-.11.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m10.37,21.19c-.15-.06-.3-.11-.44-.17,0-.06-.04-.08.03-.11.12,0,.27.07.38.11,0,.06.02.11.03.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m12.9,21.19s-.06-.05-.08-.07c0-.13.02-.16.15-.16.11.09.06.2-.06.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m11.03,21.14c-.18-.06-.41-.13-.57-.23-.02-.02-.03-.05-.04-.07,0-.05,0-.09.02-.13.13-.06.36.06.48.1.05.11.1.23.15.34h-.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m9.69,21.11v-.03h.02v.03h-.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m9.83,20.99s-.06-.04-.09-.06c-.02-.02-.02-.04-.03-.06-.11-.46-.24-.93-.24-1.41.06-.21.13-.41.2-.61h.04c.05.17.11.35.16.53,0,.13.02.26.04.4.13.06.14.33.16.45-.03.11,0,.23-.07.32,0,.04,0,.08,0,.13-.1.03-.07.1-.08.18-.03.04-.07.09-.07.14h-.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m12.56,20.99c0-.07,0-.15.02-.22.1-.03.19-.06.3-.08,0,.04-.02.09-.02.14-.06.05-.12.08-.16.15-.05,0-.1,0-.14.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m10.36,20.97c-.13-.05-.26-.1-.38-.15v-.07c.09-.09.25,0,.36.04.03.05.06.11.1.16-.02,0-.05,0-.07.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m12.47,20.97c-.07-.04-.15-.08-.21-.12,0-.04,0-.08,0-.12.08.02.16.03.24.05v.19h-.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m13.15,20.96s-.09-.08-.13-.12c0-.06.02-.11.02-.15,0-.22,0-.44.02-.65.1.07.19.19.19.31.19.02.38-.09.38.18-.08.16-.32.4-.49.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m9.59,20.95c-.08-.42-.19-.84-.19-1.27.04.22.08.44.12.67.03.17.15.43.09.6h-.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m5.61,20.93s0-.05,0-.06c.06-.09.04-.27.04-.38h.05c0,.09.03.39-.08.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m8.56,20.89c-.21-.08-.28-.27-.17-.46,0-.1.02-.26-.08-.31,0-.13.15-.33.2-.46,0-.11-.02-.23-.07-.33.24,0,.45.41.49.61,0,.33-.29.59-.24.95h-.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m12.93,20.83v-.19s.03-.03.06-.04c0,.07-.02.15-.02.23h-.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m8.78,20.79s-.04-.04-.06-.06c.04-.13.09-.26.14-.38.02,0,.03.02.05.02,0,.14-.11.28-.11.41h-.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m12.2,20.79s-.08-.11-.06-.15c.02.02.03.03.06.05v.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m5.22,20.77c-.08,0,.03-.2.04-.22.02,0,.03.02.05.02-.04.06-.06.12-.06.19h-.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m10.32,20.75c-.09-.04-.18-.08-.27-.11,0-.23.24-.06.37-.02-.02.02-.05.05-.06.07v.06h-.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m10.84,20.73c-.11-.06-.27-.08-.34-.19,0-.05,0-.1,0-.15.11,0,.24.07.34.13.02.06.03.13.05.2h-.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m12.43,20.72c-.09-.04-.18-.08-.26-.11-.02-.02-.04-.05-.06-.07.25.16.63.12.87-.02-.12.19-.36.19-.56.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m5.45,20.69s-.02-.02-.02-.02c.02-.06.04-.11.06-.15,0,.06,0,.11.02.18h-.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m7.23,20.67c-.1-.13-.39-.44-.57-.44,0-.04.02-.08.03-.11.19,0,.32.24.49.28,0,.02.02.04.04.06,0,.06,0,.14,0,.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m12.4,20.59c-.09-.04-.17-.07-.25-.11-.08-.08-.05-.16-.03-.26.02.02.05.05.07.08.3.18.57,0,.73-.27,0-.03.03-.25.06-.25,0,.21,0,.43,0,.65-.15.15-.4.15-.59.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m10.44,20.57c-.08-.03-.27-.08-.32-.14,0-.19.19-.06.31-.03,0,.06,0,.11.02.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m9.32,20.37s-.02-.05-.03-.07c0,0,.02-.02.03-.02v.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m8.12,20.35c-.24-.1-.31-.24-.19-.49,0-.15-.02-.22-.13-.32,0-.03-.02-.06-.02-.1.02-.13.05-.25.08-.37.17-.08.32.1.44.16.04.06.08.13.12.19,0,.07.02.15.02.23-.08.23-.23.41-.26.66,0,0,0,.02.02.03h-.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m12.38,20.34c.15-.04.28-.09.38-.19.04-.06.08-.11.12-.17-.04.13-.14.23-.25.31-.09.02-.17.03-.25.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m8.92,20.33s-.02-.02-.02-.02c.02-.05.03-.1.06-.15.05,0,0,.13,0,.16h-.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m12.29,20.28c-.08-.01-.08-.11-.04-.17.02,0,.1-.02.13-.02,0-.02.02-.04.02-.04-.08.03-.14.03-.17.02-.06.06-.05.12-.04.18-.04-.06-.1-.11-.15-.18-.09-.13-.18-.29-.2-.43.1.04.17.06.25-.06-.1.07-.18.06-.22.03.06,0,.19-.02.23-.11.03.07.06.28.08.42.05.01.13,0,.14,0,.02-.06.06-.02.08-.03.02-.03,0-.1-.02-.12-.02.03-.02.05,0,.08h-.06c-.02-.09-.12-.42-.06-.51.02,0,.04-.04.07-.04-.03.07-.05.09-.05.13.03.18.29.18.4.02-.08.11-.27.11-.29.06.14,0,.34-.09.34-.17-.07-.05-.14-.06-.19-.07.05-.04.13,0,.19,0v-.04c-.14-.11-.38-.09-.51.06-.01.02-.03.04-.04.05.03.15.07.4.1.56h-.06c-.02-.16-.08-.38-.1-.54-.02,0-.03,0-.04,0-.07-.03-.08-.05-.2-.05-.15.05-.1,0-.09-.11.12,0,.14-.02.21-.12.02,0,.05.02.08.04.11,0,.16-.03.23-.1.02,0,.05.02.07.04h.19c0,.11.17.1.24.1.02.16.08.18.23.2,0,.06,0,.15-.05.19.02,0,.03.02.06.03,0,0,0,.02,0,.03-.03,0-.06,0-.09.02-.06.22-.15.5-.36.62-.1.02-.21.04-.3.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m6.46,20.25c-.11-.07-.15-.2-.02-.28.09,0,.14,0,.19.07,0,.05,0,.1,0,.15-.06.02-.11.04-.15.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m4.98,20.13s0-.07,0-.11c.44-.15.87-.15,1.34-.04-.02.03-.02.06-.03.11-.13-.02-.25-.05-.37-.06h-.48c-.16.03-.32.06-.47.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m12.2,20.03s-.02-.02-.03-.03c0-.02.02-.04.03-.05.05,0,.15-.03.16-.03l.08.06c-.07,0-.21,0-.24.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m4.8,20c.06-.35,0-.75.36-.93-.04.06-.08.14-.12.21,0,.06,0,.11,0,.18.03.06.06.12.11.19,0,.19-.16.32-.34.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m6.35,19.94c-.36-.15-.87-.09-1.24-.02.03-.06.06-.13.11-.19.04.04.08.08.13.13.13-.08.15-.22.13-.37-.02-.02-.02-.05-.03-.06-.06-.02-.15-.07-.2-.12.06-.3-.09-.45-.27-.67.19.02.46.08.6.22.09.19.78.19.94.19.06.02.11.04.18.06-.09.27-.18.55-.26.83-.02,0-.05,0-.06.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m6.57,19.92s-.06-.02-.08-.02c.08-.27.17-.55.26-.82h.12c-.09.27-.18.55-.26.83h-.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m13.04,19.83c0-.06-.02-.11-.02-.17.11-.11.15-.25.06-.39-.06,0-.11-.02-.17-.02-.02-.02-.03-.03-.04-.05v-.14c-.07,0-.15,0-.22,0-.02-.04-.05-.07-.06-.11h-.21c-.14-.14-.11,0-.23.06-.08,0-.14-.08-.21-.06,0,.05-.06.11-.1.14-.05,0-.1-.02-.15-.02v.19c-.13,0-.14-.02-.19-.15,0-.09.02-.18.04-.26.05,0,.1,0,.15,0,.08-.08.1-.04.22-.04.04-.04.08-.08.12-.11.08.12.24.03.32-.04.08.04.18.04.27.02,0,.1.16.1.23.1.05.14.11.15.27.18.02.03.05.06.07.11.18,0,0,.32-.03.36,0,.06,0,.13,0,.2-.04.06-.08.11-.12.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m5.34,19.79c-.09-.11-.18-.22-.26-.32,0-.15.02-.21.11-.32,0,.08-.03.15.02.22.19.1.21.09.21.3-.03.04-.06.08-.08.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m7.59,19.79c-.25-.12-.23-.27-.31-.53-.07-.13-.11-.19-.26-.22-.15,0-.3-.02-.44-.02.11-.05.21-.09.32-.13.06-.07.14-.14.21-.2.29,0,.54.03.68.32,0,.05,0,.1,0,.15-.03.18-.13.45-.06.63h-.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m11.83,19.53s.03-.04.05-.04c0,.01,0,.05.04.05,0,0-.09.01-.09-.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m11.98,19.53s0-.05,0-.05c0,0,.06,0,.07,0,0,0-.03.05-.08.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m12.36,19.42s.02-.05.04-.05c0,0,.01.05.05.06-.03,0-.08-.01-.09,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m11.79,19.44s-.02-.03-.02-.04c.02,0,.03,0,.06,0-.02.02-.03.03-.04.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m11.82,19.48c0-.06.14-.13.21-.05-.02,0-.16,0-.21.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m12.09,19.43s-.03-.03-.03-.04c0,0,.02-.02.03-.02,0,.03,0,.02,0,.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m12.5,19.41s.01-.05.02-.07c.02,0,.09,0,.1,0-.03.06-.1.06-.13.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m12.36,19.34c0-.07.13-.08.23-.04-.06,0-.18.03-.23.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m11.92,19.33h0s.01-.01.05-.01c0,0,.02.01.02.02-.03,0-.03,0-.06,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m9.28,19.26c-.02-.13-.03-.26-.04-.39.05,0,.11.02.16.02-.04.12-.08.24-.12.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m12.39,19.21v-.02h.02v.02h-.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m4.95,19.17c-.06-.11-.11-.22-.16-.32.16,0,.35-.02.37.17-.08.03-.16.08-.21.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m13.21,18.99c-.06-.08-.16-.08-.25-.11-.03-.05-.05-.12-.03-.18-.07,0-.14.06-.22.02-.02-.03-.03-.06-.04-.08-.07,0-.15,0-.22.02-.04-.02-.07-.05-.11-.07-.08.13-.14.16-.27.08h-.07s-.04.06-.06.09h-.21s-.07.06-.14.06c-.02-.02-.03-.04-.05-.06,0-.19.03-.19.21-.21.08-.06.15-.02.24-.02.05-.04.1-.07.15-.11.04.02.08.04.12.06.07,0,.15-.03.2-.08.15.07.18.1.33.04.06,0,.1,0,.15.03.1.19.34.2.26.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m6.09,18.97c-.14-.04-.27-.07-.4-.11,0,0-.02-.02-.02-.02.14-.19.33-.24.54-.32.16,0,.32,0,.48.03.12,0,.24,0,.37,0,0,.11-.12.23-.19.29-.12.04-.24.08-.36.12-.15,0-.29,0-.43,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m9.3,18.85c-.09-.04-.02-.09,0-.15-.02-.15-.03-.28-.04-.42.07-.15.15-.31.23-.45.1,0,.21-.02.32-.02.1.07.15.15.18.26-.06-.03-.11-.08-.14-.14-.11-.04-.28-.08-.38-.02,0,0,0,.02.02.03,0,0,.02-.02.04-.02.09,0,.18.02.27.03.07.07.12.12.12.23h-.02s-.1-.1-.15-.14h-.21v.05s.11,0,.16,0c.07.03.21.15.13.23-.02-.06-.18-.12-.23-.1-.02.08-.06.21-.11.27h-.16s0,.03,0,.05c.06,0,.12,0,.19.02-.03.1-.06.19-.08.3h-.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m11.75,18.51c0-.25.16-.27.37-.27.1-.1.25-.11.34,0,.08,0,.15-.06.25-.06.05.06.11.12.16.19.03.02.07.04.11.06v.04c-.13-.11-.25-.03-.4-.03-.02-.03-.05-.06-.07-.09h-.06c-.05.07-.13.11-.22.09-.1-.13-.12-.06-.19.03-.06,0-.11,0-.16,0-.06-.06-.09-.02-.13.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m9.79,18.47s0-.06.02-.08c.02-.02.05-.02.07-.03-.02.05-.04.08-.09.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m10.03,17.97c-.05-.1-.02-.12,0-.23h.04c0,.06-.02.14-.02.21,0,0-.02,0-.02.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m9.93,17.82s-.06-.05-.1-.06c0-.03,0-.06.02-.08.04,0,.08.02.12.03,0,.03-.02.07-.02.11h-.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m9.52,17.76c0-.08.08-.17.12-.23.17-.08.3,0,.44.09v.06c-.11-.03-.23-.06-.33-.08-.05.13-.1.15-.23.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m10.01,17.51s-.06-.04-.08-.06c0-.04.02-.08.02-.12.04,0,.09.02.14.02-.02.05-.03.1-.04.15h-.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m10.3,16.65s-.05-.02-.06-.02c.02-.11.06-.21.09-.32-.1-.03-.19-.06-.28-.09,0-.02,0-.05,0-.06,0,0,.02-.02.04-.02.09.02.18.06.27.09.03-.1.06-.19.1-.29.17.02,0,.19,0,.32.09.02.19.06.28.09,0,.02-.02.05-.02.08-.34-.03-.31-.22-.39.22h-.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m12.41,17.28c.92,0,1.66.74,1.66,1.66,0,.56-.28,1.06-.71,1.36,0,0-.01,0-.02.01-.01-.04-.03-.09-.06-.13.39-.28.65-.73.65-1.24,0-.84-.68-1.52-1.52-1.52s-1.52.68-1.52,1.52c0,.59.34,1.11.84,1.36l-.16.07c-.49-.29-.81-.82-.81-1.43,0-.92.74-1.66,1.66-1.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m4.04,13.67c.21-.25.43-.5.65-.74-.23-.25-.44-.49-.66-.74.04,0,.08,0,.13,0,.17.19.52.51.64.75-.21.23-.42.46-.62.7-.05,0-.09.02-.13.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m7.94,13.06c-.1-.13-.12-.19.02-.27.15,0,.16.06.16.2-.06.06-.1.06-.18.07m-2.55,0c-.07-.07-.09-.11-.07-.22.1-.06.15-.08.23,0,0,.15,0,.19-.16.21Zm1.05.08s-.1-.08-.14-.12v-.19s.05-.06.07-.09c.13-.04.47-.08.59,0,.02.02.04.06.06.09,0,.19.02.2-.11.3-.16,0-.32,0-.48.02Zm1.48.02c-.15-.11-.16-.14-.16-.32.05-.15.16-.17.31-.17.08.02.14.09.16.17,0,.15-.02.24-.14.3-.06,0-.11,0-.17.02Zm-2.56,0s-.06-.04-.09-.06c-.11-.14-.08-.19-.03-.35.14-.08.23-.12.37-.02.02.04.04.08.06.12v.12s-.06.09-.1.14c-.07,0-.15.02-.22.04Zm1.05.08c-.06-.04-.11-.07-.15-.11-.11-.23-.1-.43.16-.54.19,0,.46-.04.63.06.02.04.06.09.09.14,0,.06,0,.11.02.17-.02.13-.09.23-.22.27-.18,0-.36,0-.53.02Zm-.06.1c-.07-.05-.15-.09-.21-.13-.15-.3-.11-.61.23-.71h.62c.29.07.28.31.28.56-.04.13-.13.23-.27.27-.23,0-.44,0-.66.02Zm-.02.11c-.07-.04-.15-.07-.21-.11-.05-.07-.1-.14-.15-.2,0-.3-.05-.47.18-.67.06-.02.13-.05.19-.07.4,0,.91-.12,1.04.36,0,.13,0,.26,0,.4-.05.06-.1.13-.14.19-.06.02-.11.05-.16.08-.25,0-.5.02-.75.02Zm-2.01.22c.21-.24.42-.49.64-.72v-.03c-.22-.24-.44-.49-.65-.73h5.37c-.32.22-.81.49-1.08.75.35.23.7.47,1.05.71-1.78,0-3.56,0-5.34.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m3.92,13.63c-.16-.23-.32-.47-.49-.7.15-.23.32-.45.48-.67h.03c.19.22.4.44.6.66,0,.05-.58.66-.62.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m5.53,11.41c-.11-.03-.21-.06-.31-.1-.07-.05-.15-.1-.22-.15v-.02h-.02c-.06-.08-.11-.15-.16-.23-.06.15-.14.27-.24.37-.4.27-.95-.03-1.07-.45.03.06.07.12.11.19.04.04.08.09.13.14.18.11.31.16.52.16.08-.04.16-.08.25-.11.13-.13.18-.28.22-.45.05,0,.1-.02.16-.02,0,.38.49.58.82.58.26-.05.44-.12.61-.33.02-.05.05-.09.07-.13.03,0,.07,0,.11,0-.1.3-.4.46-.7.53-.1,0-.19,0-.28,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m7.54,11.41c-.11-.03-.21-.06-.31-.1-.15-.1-.46-.28-.46-.49.02,0,.05-.02.08-.02,0,.09.17.26.23.32.06.03.11.06.18.11.47.15.95.05,1.09-.46.06,0,.13-.02.2-.02.12.22.27.37.49.49.13.02.26.04.4.06.32-.05.47-.22.64-.47.04,0,.09.02.14.03-.28.71-1.35.67-1.71.04h-.1c-.06.09-.11.18-.15.27-.24.18-.42.19-.72.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m11.11,11.41c-.33-.05-.62-.23-.74-.54.04-.02.09-.02.14-.03.23.4.61.58,1.07.39.2-.11.36-.28.46-.49.06,0,.14.02.21.02,0,.35.39.48.65.54.15,0,.31-.02.44-.08.19-.11.28-.25.4-.42.03,0,.06,0,.1.02-.06.12-.16.23-.24.34-.25.16-.45.24-.75.24-.2-.04-.4-.11-.54-.25-.03-.04-.06-.08-.08-.12-.06-.19-.12-.15-.21-.02-.06.06-.13.13-.19.19-.18.1-.33.16-.52.2-.06,0-.13,0-.19,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m4.35,11.17s.02-.03.02-.05v.04s-.02,0-.02,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m3.84,11.09s-.21-.21-.17-.25c.02,0,.04.02.06.04.03.06.06.14.11.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m10.95,13.67c.29-.29.75-.46,1.03-.74-.11-.08-.23-.16-.34-.23-.24-.17-.49-.34-.72-.5h5.37c-.13.15-.68.69-.65.76.21.23.42.47.64.71-1.78,0-3.56,0-5.34,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m16.43,13.67c-.22-.25-.44-.5-.65-.74.19-.23.4-.44.6-.66.02-.03.03-.06.06-.08h.11s0,.02,0,.03c-.22.23-.44.48-.65.72.19.21.49.49.65.74h-.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m16.65,13.61c-.19-.22-.4-.47-.61-.68.19-.23.4-.45.6-.68h.03c.15.22.32.44.48.66,0,.08-.42.6-.5.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m16.23,11.17s-.02-.03-.02-.05c0,.02,0,.03.02.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m16.75,11.09c.05-.08.08-.21.17-.25-.03.09-.1.19-.17.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m9.84,13.67c-.36-.25-.71-.49-1.06-.74.36-.25.71-.5,1.08-.74h.23c-.36.24-.73.49-1.08.74.36.24.71.49,1.07.74h-.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m10.28,13.67c-.36-.25-.71-.49-1.07-.74.36-.25.72-.49,1.08-.74.35.23.7.48,1.06.72,0,0,0,.02.02.03-.36.23-.73.48-1.09.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m10.52,13.67s.05-.05.07-.07c.32-.22.65-.44.97-.65,0-.02-.02-.03-.02-.05-.36-.24-.7-.48-1.05-.71.08,0,.16,0,.24,0,.35.23.7.48,1.05.72v.03c-.35.23-.7.47-1.03.7-.08,0-.15,0-.23.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m15.1,13.06c-.06-.09-.12-.14-.05-.24.17-.08.23,0,.23.17-.06.06-.11.06-.18.07m-2.55,0c-.07-.07-.09-.11-.07-.22.08-.06.17-.1.23.02,0,.07.02.15-.06.19-.04,0-.07,0-.11.02Zm-4.6,0c-.1-.13-.12-.19.02-.27.15,0,.16.06.16.2-.06.06-.1.06-.18.07Zm-2.55,0c-.07-.07-.09-.11-.07-.22.1-.06.15-.08.23,0,0,.15,0,.19-.16.21Zm8.3.08c-.15-.1-.11-.15-.13-.32.1-.19.41-.12.59-.12.15.07.14.16.14.32-.04.03-.08.06-.12.1-.16,0-.32,0-.48.02Zm-7.24,0s-.1-.08-.14-.12v-.19s.05-.06.07-.09c.13-.04.47-.08.59,0,.02.02.04.06.06.09,0,.19.02.2-.11.3-.16,0-.32,0-.48.02Zm8.63.02s-.1-.07-.14-.11c-.08-.24.05-.38.28-.38.15.07.17.17.15.34-.04.13-.18.13-.3.15Zm-2.56,0c-.15-.12-.16-.13-.16-.32.13-.23.35-.21.48,0,0,.24-.08.3-.32.32Zm-4.59,0c-.15-.11-.16-.14-.16-.32.05-.15.16-.17.31-.17.08.02.14.09.16.17,0,.15-.02.24-.14.3-.06,0-.11,0-.17.02Zm-2.56,0s-.06-.04-.09-.06c-.11-.14-.08-.19-.03-.35.14-.08.23-.12.37-.02.02.04.04.08.06.12v.12s-.06.09-.1.14c-.07,0-.15.02-.22.04Zm8.3.08c-.2-.1-.24-.23-.22-.45.16-.27.43-.19.73-.19.22.07.27.29.19.51-.06.04-.11.08-.17.12-.18,0-.36,0-.53.02Zm-7.25,0c-.06-.04-.11-.07-.15-.11-.11-.23-.1-.43.16-.54.19,0,.46-.04.63.06.02.04.06.09.09.14,0,.06,0,.11.02.17-.02.13-.09.23-.22.27-.18,0-.36,0-.53.02Zm7.19.1c-.31-.15-.29-.28-.27-.61.18-.33.6-.23.92-.23.28.09.28.29.28.56-.02.08-.1.16-.16.23-.04,0-.08.02-.11.04-.22,0-.44,0-.65.02Zm-7.25,0c-.07-.05-.15-.09-.21-.13-.15-.3-.11-.61.23-.71h.62c.29.07.28.31.28.56-.04.13-.13.23-.27.27-.23,0-.44,0-.66.02Zm7.22.11c-.1-.05-.22-.1-.28-.19-.03-.06-.06-.11-.08-.16v-.36c.08-.18.17-.3.37-.35h.68c.2.06.33.17.38.37,0,.23.02.36-.11.53-.08.05-.16.11-.26.13-.23,0-.47,0-.7.02Zm-7.24,0c-.07-.04-.15-.07-.21-.11-.05-.07-.1-.14-.15-.2,0-.3-.05-.47.18-.67.06-.02.13-.05.19-.07.4,0,.91-.12,1.04.36,0,.13,0,.26,0,.4-.05.06-.1.13-.14.19-.06.02-.11.05-.16.08-.25,0-.5.02-.75.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m4.07,34.05s.07-.07.11-.11c.11-.37-.31-.53-.57-.65.23,0,.45.02.69.03.56-.06,1.1-.24,1.64-.36h.29c-.04.08-.07.17-.11.26,0,.08,0,.17,0,.26-.32,0-.62.16-.91.28-.15.05-.31.11-.45.16-.23.04-.45.08-.68.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m9.2,33.93c.04-.22.32-.44.46-.59.14-.11.27-.2.42-.3,0,0,0,.02,0,.02-.08.13-.16.27-.23.4-.15.19-.41.4-.65.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m9.89,33.56s-.02-.02-.02-.02c.11-.2.23-.4.38-.58.15-.06.3-.13.46-.16-.11.15-.21.33-.31.49-.15.18-.29.23-.52.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m8.28,33.43c-.15-.22.15-.27.15-.08-.03.06-.08.07-.15.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m10.45,33.33c.07-.14.15-.27.23-.41.15-.15.13-.15.35-.19.11,0,.23,0,.35.02v.02c-.15,0-.4.35-.52.44-.1.04-.19.08-.29.13-.04,0-.08,0-.12,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m11.19,33.32c-.06-.03-.23-.1-.19-.19.1-.11.38-.47.58-.34,0,.09-.07.23-.1.32-.02.05-.02.11-.03.16-.09,0-.18.02-.27.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m8.88,33.2c-.04-.06-.07-.09-.03-.18.04,0,.08-.02.12-.02.05.05.07.13.02.19-.04,0-.07,0-.11.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m3.97,33c0-.06,0-.11-.02-.15,0,0,.02,0,.04,0,.05.05.02.13-.02.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m9.35,32.98s-.03-.02-.04-.02c-.04-.13-.02-.18.12-.18.05.04.06.11.04.16-.04,0-.08.02-.12.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m8.48,32.92c-.05-.08-.07-.15.02-.2.11,0,.15.07.1.18-.04,0-.08.02-.12.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m9.89,32.78s-.06-.05-.09-.07c0-.11.08-.2.18-.11,0,.11.02.15-.09.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m8.96,32.75s-.06-.05-.08-.07c.02-.25.25-.14.16.04-.03,0-.06.02-.08.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m8.11,32.68c-.09,0-.11-.1-.11-.16.11-.11.22-.08.22.08-.02.05-.06.06-.1.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m8.64,32.55s-.08-.08-.08-.15c.06-.06.06-.09.15-.09.06.06.08.12.04.2-.04,0-.08.02-.11.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m10.34,32.55s-.03-.07-.04-.12c.04-.05.1-.08.15-.02,0,.13,0,.12-.11.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m9.53,32.54c-.08-.06-.06-.11-.03-.19.15-.07.18.05.15.16-.04,0-.08.02-.11.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m11.26,32.43s-.08-.1-.02-.16h.09s.02.09.02.13c-.03,0-.06.02-.08.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m10.78,32.41c-.11-.11,0-.23.09-.13,0,.03,0,.06,0,.11-.03,0-.06.02-.08.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m3.28,32.4s-.04-.03-.06-.05c0-.05,0-.1,0-.14.04.05.09.1.14.15-.02,0-.05.02-.07.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m9.97,32.4c-.06-.06-.05-.04-.07-.12.04-.04.08-.06.15-.03,0,.08,0,.12-.08.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m9.12,32.39c-.08-.08-.11-.23.06-.23.02.02.05.04.08.06v.11s-.09.05-.15.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m3.58,32.33c-.09-.05-.24-.13-.24-.24.17-.08.27.08.27.23,0,0-.02,0-.02.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m10.57,32.32c-.06-.02-.1-.08-.06-.15.03,0,.06-.02.11-.02.03.03.02.08.02.12-.02,0-.05.02-.06.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m11.5,32.29s-.04-.03-.06-.04c0-.1.04-.15.14-.11v.12s-.06.02-.08.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m11.02,32.25s-.02-.02-.03-.02c0-.03,0-.06,0-.09.03-.03.06-.03.13-.03,0,.03,0,.07.02.11-.04,0-.07.02-.11.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m9.61,32.24s-.03-.08-.03-.13c.11-.11.18.02.13.12-.03,0-.06,0-.1,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m10.23,32.2s-.05-.03-.06-.04v-.1s.06-.03.13-.03c0,.03.02.07.03.11-.03.02-.06.03-.1.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m10.72,32.15s-.04-.03-.06-.04c0-.11,0-.12.12-.12.06.09,0,.13-.06.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m11.22,32.12s-.03-.07-.04-.13c.11-.06.12-.02.15.09-.03.03-.06.03-.11.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m3.14,32.08v-.02s.03,0,.05,0c-.02,0-.03,0-.05.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m7.62,32.07v-.03s.02,0,.04,0c-.02,0-.03.02-.04.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m3.02,31.95c.04-.06.1-.15.19-.11,0,.02.02.05.02.07-.1,0-.14,0-.22.04"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0.23,
    y: 14.08,
    width: 3.26,
    height: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0.18,
    y: 14.19,
    width: 0.22,
    height: 1.44
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 0.67,
    y: 0.2,
    width: 19.26,
    height: 13.95
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("image", {
    width: 18,
    height: 18,
    transform: "translate(8.09 8.02) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAPCAYAAAACsSQRAAAACXBIWXMAAC4jAAAuIwF4pT92AAABVklEQVQ4jZWSzUoCURzFfzp+myIlMhIJhkXBQNDKRYE7l+WuHsBl79ALtGjdO+Tancv2DiEhBS5yGArGyVBpcFrE5HzcMTqry7nnnvs//E/Etm0bH8ZqB33Y89MAHJ3fBriI28TUVLRBl5kxEhoAlGoNykrLw8Wcw1PvZu1jB/qwR7a4R15WViampvLycPfnYze0QddjIl2cxK/DxIlUnmRmC3tpsVxav7w1n2Bbc3KlQwCi6UJFaJBMFdg5vmT39Ipt5QxJSgRimZr6YyIfNMVTZDfJFveR4hkyxRqxZE4YCyCalxVKtUZAsPh8Z6o/8jU3mOoDrIUZ0MyMEWO1s1qxaDvxRBYpsYE1N7CshXDiar29Mvnvltx98ZRtXVMdpAsV5IOmtyduQVlp8fH2HFo6UVsBon5CtK10oUK13hYagC+OA3essN89sEPw2r+3J+N+2LUH390wzX0vS/EMAAAAAElFTkSuQmCC"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("image", {
    width: 18,
    height: 18,
    transform: "translate(11.93 8.02) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAPCAYAAAACsSQRAAAACXBIWXMAAC4jAAAuIwF4pT92AAABPklEQVQ4jY2TMUvDUBSFz01SYyTaqCjJEhoUcYi4qjh0c7U/QgdXf4eDc/+Dzm4dO5sMItJChyaIlqYVIzX0OZTA872E9Nty3+Hce17uI8YYA8dr5w7peAARw3Jx0LyV6kREWv4RhY94f+tIopx0PMAkDrFh+7JREgUsfnkq7F7E8eW9NInS77aXNgAWcUWUMvHq2jaMdRuqUvtXz2NVmphbHhpn19g7v8GOdyqd97vtZUwa0E0bql6H6fjQtBVJw8dSDMuVBF+fPfwkA/ymI0yHz8iymaThY1ESBUwcDwB0YxOk1jD7HmE+z6Rzw3JhH16g7hwRMcZY1Y6I7O434fitxRT5sjl+C9OPXuWvzruLC0f52k/iULp1Hu/kqnhbiYj4t1MUq+zN8CYaXxBjlXWXYAJJFLBh8CCWSwGAP+jVv0J/V6GmAAAAAElFTkSuQmCC"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("image", {
    width: 2,
    height: 3,
    transform: "translate(16.25 3.94) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAABCAYAAAD0In+KAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAC0lEQVQImWNggAIAAAkAAeNZIR4AAAAASUVORK5CYII="
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-104"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-109"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-103"
  }, /*#__PURE__*/React.createElement("image", {
    width: 8,
    height: 9,
    transform: "translate(11.93 3.46) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAYAAAA1BOUGAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAmUlEQVQImV2OoQrCUBiFvztuWRFBEJMoiBgEo8Ylsy/hE2jzKcw+hNlmtO8GgzAweMeCeIciivAb3K6wL53Dx4GjnI0lOWwACOtt+tECAKWUCkoB8LydsWbre1AGrUMAstOePDV/2eiMGUxXfpEed78BgLsYXnlGFQ3weT+4XxMAupM5tdYQWBI0e5F/OpqtC1EgIuJsLFUAvjVRPfEwkaG5AAAAAElFTkSuQmCC"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-102"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-101"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-105"
  }, /*#__PURE__*/React.createElement("image", {
    width: 9,
    height: 9,
    transform: "translate(12.41 3.46) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAhklEQVQImWO8sD7vPwMDAwOngByDmkMxAwMDAwMTAxR8//CI4fmV9QwMDAwMLMxMLAyMTKwMf/58Z3h15wADt4gqA5O4ujuDsl0uTAPDixs7GVhe3z/K8OnFVQZkwPL7xweG3z8+MDAwMDCIqTgwSOoEMrDAbJbQcGfgk9CBKH12ed1/dAAAUB0zVQta0p4AAAAASUVORK5CYII="
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-107"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-106"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-110"
  }, /*#__PURE__*/React.createElement("image", {
    width: 9,
    height: 9,
    transform: "translate(13.13 3.46) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAACXBIWXMAAC4jAAAuIwF4pT92AAAArklEQVQYlV2OPQrCQBhE3yZC/AERsUgsBBubBGwtvYCih/AEnsQ6d9DaztLeLSxEIYUuYhFjsU3gs0rQvG6YYWaUiEhmNOa8x6YJBePFBgB1P23leTlQpdEZMJqucX5Nr9nFa/UAsGlCZjROozMoA0E4ox/OS307xqj34yS3YwyA69ZRSpHntpxRIiIPvaP6YzhZ0fYjagBBtOTzumLTpDxXoEREADKjAWj70V/TF+5FQTAIXzKbAAAAAElFTkSuQmCC"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-108"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    height: 12,
    transform: "translate(13.37 7.06) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAJCAYAAADkZNYtAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAu0lEQVQYlWP8/////08vrjC8uLGT4fuHRwzogFNAjkHNoZiBgYGBgfHZ5XX/X905gKEIGYipODBI6gQyMH1+cw9NipFBVNGagUdADi7y6s4Bhk8vrjAwwayAATZ2PgZJvWAGUVUHFPEXN3YyMMLcfP/EbIQ7+aUZ/nz/wPD711cUp7AwMDAw8EnoMHAKyME9+P3jUxQPSmi4M/BJ6EBMhklc3JCP1WNw3yArhjkH2TQU8B8NPLu8Dl0IDgDyLnPv2oTxfQAAAABJRU5ErkJggg=="
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    height: 11,
    transform: "translate(13.85 6.58) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAKCAYAAABmBXS+AAAACXBIWXMAAC4jAAAuIwF4pT92AAAA00lEQVQYlW2QsUrDUBSGv7SxENDQqY1LQSiokKGjow7i3IfoQ3TzBRw79R10dgu4uCeDqCBkMMEluR28gd5wOmguvdBvOpzzH87/H09EBGBTZny9rgE4u1oQRjEdPsB78oCuc9ss354dUX8+q+5No9jHNAoxDSejSwB6+8Oe17f1z2fCpsxc0dHgmPPbJePpjXPWEYm0GF3Rbn+tSNc5Rfb0ZxzAbDUfLyvH22h6zWk8x1NFKl30jmA4Ibq4swn9MIoJhhP7gm7bQf75Th9FFakcYgcuR2h0P5WV+wAAAABJRU5ErkJggg=="
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-52"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    height: 11,
    transform: "translate(14.33 6.1) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAICAYAAAAvOAWIAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAwElEQVQYlXWOMQsBcRjGf3TilnOTTupKJOpkNclmJZ/BbPA5FLPvIKtNJpvEIIW6xC04otv8DfKvO3m293l+Pe8Tup2WwlmP8VybfyrV+wCEg6CiqCQyFSJRTXqbSfcD56odX0tMT5EsNokbBel5rs3dWREGSJdbMnied2ynPa6H+c8cBUAzLFTdxHNthHjxuOwloOom3+8hIYT4BotR29eUyFZJWg15++C7s2I/G6DqJka+hmZY/h0ioONyGLSk3kkQaCWj0TZUAAAAAElFTkSuQmCC"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-51"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    height: 11,
    transform: "translate(14.57 5.38) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAKCAYAAACJxx+AAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAoElEQVQYlWO8sD7vPwMaULRIZeCT0GFgYGBgYEKXZGBgYLh/YjacDVfALSjHwMrOC5e4daAXoYCVjZtB2a6QQUYvCK7g+4dHDJ9eXGFgYWBgYPj96yvDo1PzGX58eYli1dc3tyEKGBgYGD48v4TVoSwMaEBMxYFBUicQzmf8+Pzy//snZjNwCsgxSGi4w70HB///////7PK6/7gAtmBAAQBjbEWd+wkDiwAAAABJRU5ErkJggg=="
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-63"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-59"
  }, /*#__PURE__*/React.createElement("image", {
    width: 10,
    height: 10,
    transform: "translate(15.05 4.66) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAKCAYAAABmBXS+AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAwElEQVQYlZWQvQ7BYBSGn08MmiCdqKUWEUMTG6vNyhVwD27DYnYRBpOJ0e6TEELSpV/EUBXpeAyi8bd4tvfkfc+fEhEBiIzGbGbEoY9lu1RbA56kAQI94bRfJMU49ImMJu94AKjtfChx6POLemcEQOrVkMkWsXJOogM9eZhek+VGj3Kzn+jTfkFkNGnLdnl2M+spoN5G3s471CVYyXE5/trHsl2cWpu846FERD6vK1RalLzu+wtKXpfr+QCQpP/mDuBnSEG/Oy1YAAAAAElFTkSuQmCC"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-56"
  }, /*#__PURE__*/React.createElement("image", {
    width: 10,
    height: 10,
    transform: "translate(15.05 3.94) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAHCAYAAADam2dgAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAk0lEQVQYlWO8sD7vPwMUCMuZMrBzizI8u74NJsSgaJHKwMSABPgkdRkEFCwYmJlY4WL3T8xmYOEUkGP4/uERAwMDA8OjM0sYGJlZGf7++w1XxCkgx8D4/////7cO9MIVIgNFi1QGPgkdiHUSGu4okpwCcgz6ARMZ+CR0IAL/oeDZ5XX/L6zP+//x+eX/6ADDCmwAAN8lQEX016wjAAAAAElFTkSuQmCC"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-57"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-62"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("image", {
    width: 10,
    height: 11,
    transform: "translate(14.81 2.98) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAmElEQVQYlWO8sD7vPwMa4BSQY1BzKGZgYGBgYEKXZGBgYPj+4RHD8yvrURVIqrowqDkUMjAzszIwMDAwvLpzgOHTiysIBf/+/mT4++cHikkvbuxkYIFxXt47zPDy3mEUd0houDOwcArIMXz/8AhFp5iKA4OkTiADAwMDA+PH55f/3z8xG8P1cPD/////zy6v+//x+eX/2AAANBxIDIYtV2gAAAAASUVORK5CYII="
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    height: 10,
    transform: "translate(14.09 2.5) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAJCAYAAAALpr0TAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAz0lEQVQYlW2QsU7CYBRGT1sp+cE0ZWlgoNFAjEMHR936Cn2IrjL4Ar6AT+BDwOrm6Kixg2HRdGknbUlIDZFcBsJv03K2e+433O8aIiIAqzzh8+WRA8r1uQjv9GyIiCyfH6iKlCbeNGQURABY0dXP/d9v2QoBrL+/6LljuqceZn3RsftMbmIc71K7/OMJAFO5vpZWR6EGZ9i9gXZVkZIl8/2Nb4vZf9iy2W43rVKGiEiz8YHz6xhnGABwAuAMA5Tr6+bN1wAgNV7nt1Jm73KMHYahZEK8eIzWAAAAAElFTkSuQmCC"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("image", {
    width: 12,
    height: 12,
    transform: "translate(13.13 1.78) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAMCAYAAAC0qUeeAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA40lEQVQokWP8////fwY08OnFFQYGBgYGPgkdFHEWdIW3DvQyfP/wiIFTQA5DMSPM5E8vrjDcPzEbRVJMxYFBUicQ1WSYaejg1Z0DDNwiqnAbmC5uyMeqEAZe3NgJZzOhS7JyCDCIyJsyMDNBvPP9wyOG51fWQxRzCsihKBZXdWSQNoxhYOcRQ3HOpxdXGJgkNNxRFL+8uYvh3tEpDN8+PcNwEuP/////P7+ynuHVnQNY3cwpIMeg5lDMwMAADQ1JnUCGz2/uYXhU0SIVJazhHkR2DqeAHIN+wETckcLAgDuaYQAARD9UkIGU854AAAAASUVORK5CYII="
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    height: 11,
    transform: "translate(12.41 1.78) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAALCAYAAACzkJeoAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAqElEQVQYlWP4/////4/PL/9/dnndf3TAcutAL8P3D48YGBgYGLhFVBn4JHQYYIAJJsHAwMBw/8RsBmTAxIAGnl9ZjyrJzi0CF3h15wDDpxdXIJK8oqoMGq61DILSBnAFL27shEj++PSS4f2jEwzf3j+GS37/8Ijh+ZX1DCy/f35ieHRuOVyCU0COQULDnYFPQoeBBdkxYioODJI6gXA+C7pqFIAtZGAAAD21YpSp6JbcAAAAAElFTkSuQmCC"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-75"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-76"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    height: 11,
    transform: "translate(11.45 1.78) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAALCAYAAABCm8wlAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAq0lEQVQYlWP4/////4/PL/9/dnndf3TAwMDAwPL8ynqGV3cOMDAwMDBwi6gy8EnoMCADJpgkAwMDw/0TsxnQARO6wK0DvZgKuARkGVjZeRkYGBgYvn94xPDpxRWEAjZ2XgYV+yIGGb1AFKtgilh+/fzM8PTcEoZvH59i2M/AwMDAwsDAwPD28Vm4AKeAHIOEhjvcNyzIqsVUHBgkdQKRhSAK0HWhAGwhiBySANKsXPN0QlUqAAAAAElFTkSuQmCC"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-77"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-73"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-74"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    height: 11,
    transform: "translate(10.49 1.78) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAALCAYAAABCm8wlAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAqklEQVQYlX2OoQrCUBhGD/PCWNHBQLawpTEMa9pdEbNPYvA5LFabT+AjGAWTaLIIt2iclovMMYM676Z44s/5vu+neHE57Yo6AALgsJqiUollB0TJBB1juxyjUgmASiXX874qUOO4nv8X3pMVwfF7eNGgPOpTBkDL7+KEfRoN82tKAMjNAkOY5PmtFNphAsyewj1TkCkALDvA7QxpuvGnQU958ajysPiV0nkA5xlIOEf5UgUAAAAASUVORK5CYII="
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-78"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-79"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-80"
  }, /*#__PURE__*/React.createElement("image", {
    width: 9,
    height: 8,
    transform: "translate(11.21 9.46) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAHCAYAAADam2dgAAAACXBIWXMAAC4jAAAuIwF4pT92AAAArUlEQVQYlWWOsQqCYBRGzxWFJCiJCF0kISLIB7DNrS3oIXyC5h6hJ/Ahmtsa222ICAKHlCarwaX6mxSkO937fYfLkUeWqPy0oyxSqvGCiI7tAyAiol0PcQMAuB7ixq1Vi9Hq0h/O6uK83/xD7Z6LM12gGyYAZZHyzI8A6KblUhYpxS3hla/5fN8AmJZbe2n2ZF6/rQAviBiHqzoXpZTKjlvulz2DUYjjLxvSIiI/YmI0+IhFIo0AAAAASUVORK5CYII="
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-81"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-89"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("image", {
    width: 9,
    height: 8,
    transform: "translate(14.81 9.46) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAYAAADEUlfTAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAkklEQVQImU3NMQrCQBSE4V95gWyhbiWJRYhgobBgq52d2JlDeI2cwMaTpBQrPUQQBas0hlRBhNhpEVx22m+Y6dzP+29TF/wznKwITQJA1wWA6nHhVeYtAogoRrMN4ikAytvJQb+Hjpd4/gCApi545hkC8HlXXI+pnVY6IjQJonSE+zte7OgHpp0Npmvbnm8PFgB+sJcj4qjn6E8AAAAASUVORK5CYII="
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-83"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-85"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-91"
  }, /*#__PURE__*/React.createElement("image", {
    width: 10,
    height: 10,
    transform: "translate(16.25 8.98) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAHCAYAAAAxrNxjAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAnklEQVQYlWO8sD7vPwMWwCkgx6DmUMzAwMDAwMjIyMiELMnFL83Ays7LwMDAwPD9wyOGTy+uwOXgCllZuRhU7AsZpPWC4ZL3T8yGs1lgjN+/vzE8Pb+M4cenlyhOgJnK+PH55f/IOpHdKKHhzsAnocPAyMjIyMInocPAKSDH8P3DI7giMRUHBkmdQFSd/6Hgwvq8/zf39/zHBhgYGBgAV4FFtSNQiOQAAAAASUVORK5CYII="
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-84"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-90"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-92"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    height: 11,
    transform: "translate(16.97 7.54) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAzElEQVQYlW2QvQ4BcRDEf3uHROGjEDkNiYgoTpRKOi2v4AVIvAaF2ktoVZRaQYJGonElIpGIWNX9c5yp9mN2MrOiqgpw8zYclxN81NpjU4uIyPW8Vm8343E5EUQ8nafcHBiidVxOQiSAx+XEzduY3goubTuGbUdNH7RiiCIWpUafQr37pXxYjACI+APVN/fzltfzHrIAIPv5UP959AM5lRapXFVEVXU17YVI2VKTnNsxqUVVNfhDXyXpuOZIRCQCkHRc4uk8iUzRqPziA99fSWbDeAMVAAAAAElFTkSuQmCC"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-87"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-86"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("image", {
    width: 10,
    height: 11,
    transform: "translate(17.69 7.06) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAnklEQVQYlV2OMQrCQBAAZ2OCXCNXSWyuUrAIWNlrZasf8AlWfsPCl/iF9IIIWsUuCIqIREFTiMbKi+dUy+4MrKwXk4I/OsM5ACIiHoAfKKpKWyGJZ3b2AEx3TKs/peIFAORZyu24BcAHyNIlj1PC6/205f28K4XLfuX8UG/2aESjUviitCFsD6iFkd35ShvyLHWqX+R62BSAU9mjiHwA1x8lVa47DBwAAAAASUVORK5CYII="
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-93"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-97"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-95"
  }, /*#__PURE__*/React.createElement("image", {
    width: 10,
    height: 10,
    transform: "translate(18.17 6.58) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAJCAYAAAALpr0TAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAwUlEQVQYlXWPsQsBcRzFP9/rFiUJiUUukuHKyqBus/JH2JW/4wazP8K/cKPJdJOu1CmklG65Rb4GXL9L3vh6fd57oqrKR/vAJ73HAAymq6+NiIioqiaXkMN2jalCuUXPW2ZB26SYSu8xySWk1HABsMyQbRcoVh1AAHItlkmpOSM64wXFSjvz9oH/htS7HtcoAOB23KHPB2ly+pkiqqr/dta7Hk13hoiIBdDoT34eO8M5TXeWJwKcww3XKMgouVoReQELi0lEeSmLLAAAAABJRU5ErkJggg=="
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-88"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-99"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-94"
  }, /*#__PURE__*/React.createElement("image", {
    width: 13,
    height: 13,
    transform: "translate(18.41 5.62) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAANCAYAAAB7AEQGAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA0UlEQVQYlWP8/////+dX1jO8unOAgYGBgYFTQI5BzaGYARkwRznwNnx8dhEu8OfHR4b/f34w8IppwsWYvn94xIAOXt05wPDpxRWEIgwVUPDixk7Cir5/eMTw/Mp6hCJ+CS0GWb1gBmYmVqzWMjEwMDDwCCkx8MuaMDCzcmC1loWBgYHh+Y3tDK9u72f4/fsrhiIJDXeIon///jL8+4eqADm8WNB1cgrIMUhouDPwSejAxVAUiak4MEjqBGJ69ePzy/9v7u/5//H55f+4AKYuLAAARu5g8pNOLUUAAAAASUVORK5CYII="
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-100"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-98"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-96"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    height: 11,
    transform: "translate(18.89 5.38) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAKCAYAAABmBXS+AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAwklEQVQYlXWQvw7BYBTFf5VPUgu1UIYmEhFDYzbWZOUhPIHX8AYeorOJUaztQCLBZ2gjISWikZDPQhP/ftPJPSf35lxtMR6oOJJ8Umn2yJo2AKlfAYBwPkp06iXSeo5itYUQOgBxJAl89z2ULzcw7Q56rpRs2C0nnEIf8Rrs5YxLtOV82HydFhnDIo4k99uV82GdGBnDoub0AdCOgadW0+GbadbbSTMATSmlAt9lt5xQqDqU7O53VfXkGHjqHz9/9MkDN7Ne5+RXoDQAAAAASUVORK5CYII="
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-82"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    height: 11,
    transform: "translate(18.89 4.66) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAALCAYAAACtWacbAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAw0lEQVQYlXWQvQqCcBTFj6KBFSKBYQ3WINHg0Nrm1tzWe/QcLq29Q72C0NKukyiBQ0oRmBQu1W1J8W/12+695577wRERZYmHw36NAknRMbKWZSz4jo08jVAlTyNkiQdZMwEAfF1QUHXmS0tRgjqcQmy0yqLv2Kyo2RmgP1mgrRpfY4UicT8HCHerr/0AQJAUHXka4fl64HYJmQu18QyyZoK7xi5VlwSArmGhZ87LmCMiir0tToHDdDPQh6O7oX/8/FGdNxTXaOaqQ6U0AAAAAElFTkSuQmCC"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("image", {
    width: 12,
    height: 12,
    transform: "translate(18.65 3.7) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAMCAYAAACwXJejAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA1ElEQVQYlW2PsWrCUBSGP5NLoAhWUUpCQSikIpjB0dHSwdmHcNWhr9E+SYe4OjWPkEIGW6RDOhjEIaRDIBCuU6652m86h/P9/Bxkja+PVxn6S3mJAZAlEZ/rFXkaA7CPfOqI7+BNHSsOu4Bm75GW7QFgXAoVyXajZuNfA8jTWNUq6dYe4Qyer2qzJDpLnfsxXfcJ07SuakW1/IbvGMKiLAtNsoezs1SWhSbctPsMpi8AiDt3ymEXaOmHyUK9DyAcb87f8Yc8jbV0nYaUUmZJBKCl65wAtk9m22ZavN8AAAAASUVORK5CYII="
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("image", {
    width: 12,
    height: 12,
    transform: "translate(18.17 2.98) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAJCAYAAAAGuM1UAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAyUlEQVQYlXWQPQ4BARCFv1kEichGQlaCikSxHQegUruAKziJE7gDatWWWtltiJAo7EYUi2LLUflZ1uvmzXvzZkZUVX1vznnnkIRKs0fVHgIgImJsnclfMfDTM6LwGCMyOZNSrYMhqRe3dSZvQ6XZixmsVp96d0S2UH5xUXjkFngApKv2kPtlzzMp2CwJfZfoHiSuKKqqt8DjsJomCvJmA6s9oGjZiIikAYqWTd5s8H3P54diCc9ivRj/TI2JRQT9wNV39eTO9B8AHtvAbGDGhMkqAAAAAElFTkSuQmCC"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-70"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    height: 10,
    transform: "translate(17.69 2.74) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAKCAYAAABmBXS+AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAo0lEQVQYlWP4DwU39/f8v7A+7z86YGBgYGD8+Pzy//snZjPAAKeAHIOaQzGcz8jIyMiErICBgYHh+4dHDJ9eXEERY2LAAtA1MjEwMDAwMTEzSKg4MHDwisMlbh3oRVXEyiHIIK4TyCCiYIXVWhYGBgaGn9/eMNza18Hw+9sHbLZDFDEwMDB8//Qcpw9ZGNCAokUqA5+EDooYPJzQdcMVMDIyAgANX0xCCgkGngAAAABJRU5ErkJggg=="
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-68"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-71"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-66"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    height: 11,
    transform: "translate(15.29 2.5) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAKCAYAAABi8KSDAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAvklEQVQYlXWQsQ7BUBiFv1YNTRMxqJShiQQh6QMYu7F6CLPBc3gCL2ETW0erkBCRSAw0JiwG4Zpu3dtytvvnu+c//zGEEIKUdtGYx/VIuR5SCfrJ3FKhe7zmsJgk78s+wik1KHiBDku3tOLtPIGN23klVLdfknEs+UtVtd0DDE6bmRbHBKh1BhrsuA0ct56JY8g21Mw5Mw/A6/0EwC76eK3uFwZYTod/8wI6rFYn3dSbtJ4LXoBd9AFohqPMlg/j/Um3v26LiAAAAABJRU5ErkJggg=="
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-67"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-64"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-69"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    height: 11,
    transform: "translate(16.25 2.5) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAKCAYAAABi8KSDAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA0UlEQVQYlW2RsQrCMBRF75MOVkQ7lYogCAodCq6OuuiqH+Hs5l90cPYj9BM6uoqdiqh0aZGCVcEiIs+pMZHe7YSTm5eEmJkB4B77OG1XyNPuz1CzHMFERMTMHHgusjTEf3qTpSKXdpt5oQgAgecqXJJB03RU6k3BWRriHvvFsmWP0B0uUK6aYk2+h6YbLTFGct7i83rg/bwqx+ftdIv2LO+WoxstWPYYNcv5vUbkr3E5eIpodgZoOFPBREQaADScKR7JEVkaKm3/IflTABRKefMXO8BRtaazMzMAAAAASUVORK5CYII="
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-72"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-65"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    height: 12,
    transform: "translate(16.97 2.26) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAvElEQVQYlWP8/////+dX1jO8unOAAQY4BeQY1ByK4XxGRkZGplsHelEUMTAwMHz/8Ijh+ZX1KGJM3z88YsAGXt05wPDpxRWEQmRJHkE5BmYWdjj/xY2dmAp5hBQYlO2LGcSUbLE6Aa7wx6eXDK+vb2N4+/gsihM+v7kH8dCF9Xn/sTqSgYFB0SKVgU9Ch4GRkZGR8ePzy//vn5iNogBb8LDwSegwcArIMcB8DzMFA/yHgmeX1/3HBRgYGBgAONRiuZY8/IQAAAAASUVORK5CYII="
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-162"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-168"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-163"
  }, /*#__PURE__*/React.createElement("image", {
    width: 15,
    height: 15,
    transform: "translate(7.85 1.06) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAMCAYAAAC5tzfZAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA+0lEQVQokYWRsU7CYBSFvzZNTNMEa1BSHBpNEBwaR+PIYOLMIzj4BD4HT+BDuDt1ZIfBIBHCgtFqIKhNU9rLBPZvJT3b+e9/7rk5RxMRGfpdwvmUXTi9uqPieFuulwkAxr0Hhetlgg2GfvdPlB/u11qcXN5ycHyhvIfzKbPBIwCGYqsbHLWusapN9qwq3x8j4vh3O38f+ViHZ6pTmq4IP8fE0YLwa0KSRIUzf4IX1Qng7fmJYNJjFS1J00SZmbZL3eugLWZ9yafzH7Kx6xXHo9Zo7/xs2m6hJwOg7nVYBq+Fvkzbpdm+LyzSREQ2JFt0fnsWSnrO+U2pAGANqHdeyUmJ+M8AAAAASUVORK5CYII="
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-164"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-167"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-161"
  }, /*#__PURE__*/React.createElement("image", {
    width: 16,
    height: 15,
    transform: "translate(9.05 1.06) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAMCAYAAAC9QufkAAAACXBIWXMAAC4jAAAuIwF4pT92AAABIElEQVQokYWSsU7CUBiFvxYEMQQ6aFNjrDFRZCAxcTAODsSY4KibL+AT+AK+gINzH8KZzbEP0IGoSQ2LHQhpm1SqoNcBWyy96NnOf+75/3v+exUhhOAHjw+3jPw+i7B/fpfhihBChJ6D1+v+aQSoaCaN9nXK1dBzcG3rXyPAyO/z6tynvHB5vHSTP6awunWI3jhlEgd8jPxUiYYvrGiblKs6akUzc9bycp21vTPqGwfouyc53bUtQs9B/Z0hwWQcEQ9dxu8Bb4NnaYRo8DRbmGtbGbFQKFEsVRnHAV/iM6NtH11RM1pTM4CsgQyJEaCYFGtGi4pmLtz6/DMBs8kJZB9F32mz3rrINVTnC0azk7umzCidDNP8Xq+L0eyk+WT4Bk7WeJ6C5J2sAAAAAElFTkSuQmCC"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-170"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-165"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-169"
  }, /*#__PURE__*/React.createElement("image", {
    width: 24,
    height: 24,
    transform: "translate(7.37 .1) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAVCAYAAABc6S4mAAAACXBIWXMAAC4jAAAuIwF4pT92AAACBElEQVQ4jaWVPW/TYBSFH3+2dprgplFxBTFQNahDEANCYqzK0BV+BHN/CzM/Il2zMbJWstRIVEVKhWKqSAlJE5PYjhmKaRx/JIGz+erec3xe3/dYCMMwZAk6doNh9wq3387s2T04Yq/+PlEX8gQ6doOby8/L9P/i5buPiZq8WBg4Nk6rmfu2WRg4NiWzni7wP8QRnFYzKTBwbL59+fTPpPNw++2EC3HU/boygSRtoCg6kqRm9jitZuxZLlRqsORDiqKM/uARuvEYSdHwJ7eM+9e4A4dZGCRcxGZLZh3NsHLoBQrbVcpPXrNTO2an9pbK82PK1VdoJTN1omM37gUAzMOTTHpF2aSwbbFlvkDVK0iKjlp4yNZeHd2oph7X/GqLALkuRBl5o4isbsXKslpE3iwiikquCzEqFCv76QKzgMAbM/PdWNn3XILpmDD0U8eG3au4QNo1B/B9l1HvmtsfFwTTIeHMx/vVZ3RzgfvzO74/SZ2LVjYWFVnRIEkqhfJTdKOKrP7Zol6bUa9NMEt3AKAZVjKLzs9OU5sFQUCWNQRRvnPhucDSnLw/ogi7B0epjWEY4nljppMBnjdeSq4ZFs/efEiG3SoXLw+LsZ0QiFZ23dBb63+wagBqhoV5eJJI0HkkHAC5A6sS5wrAneXFlc06hjzk/jLPz07RDItiZX9t4gi/AbyQ3IAZ9t19AAAAAElFTkSuQmCC"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-166"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-154"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-153"
  }, /*#__PURE__*/React.createElement("image", {
    width: 12,
    height: 10,
    transform: "translate(8.81 2.98) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAHCAYAAAAxrNxjAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAyUlEQVQYlY3Ou2rCYACG4Tf580dMtKIR1EG3urQgXbyKDr0S78Ub0dsQXMTD5BIEbcFD0CbGPyc7WGxH3/n54NMmw95V6AaV5hulVheZd4jPWzx3hLeZkmUpnY8+BoC0yhQbHWynDYBpOaTKx9+7qNDj9DVHBxDCxMgV+J/IFdGEBCDYLW8wvpwIDy5ZogDIEkW4d0mj4D40ACL1zWE1JonOmLZD5G85fi6If6Fdfb5BgOC4RpgFdGmh6ZLayztP9de/L5vZ4PpIP7CcbMFFpWvJAAAAAElFTkSuQmCC"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-152"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-151"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-156"
  }, /*#__PURE__*/React.createElement("image", {
    width: 9,
    height: 9,
    transform: "translate(6.65 3.46) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAYAAADaxo44AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAhElEQVQImW3OsQpBAQBG4Y9uZLhYlEkpKeUBjFYPYrV4A4/gQZhtygsoBgMDAzclQomFgZCc6a9Tpz827rfuXhRrTel8FcR9Ec0G7x2HRDIDLoeVzbT/FIlkqNLoCHMlsJ0PHaOp4HY9WYy6Lvvld1UA590CpLIF5Xr7I34fgfWkd//HA0rNNm+hfqoAAAAAAElFTkSuQmCC"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-155"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-157"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-158"
  }, /*#__PURE__*/React.createElement("image", {
    width: 9,
    height: 10,
    transform: "translate(5.93 3.22) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAoElEQVQYlWN8dnnd/1d3DjDAAKeAHIOaQzEDAwMDAyMjIyMTsiQDAwPD9w+PGD69uALnM8EYLKxccMH7J2ajKmBmYmHQdG9gEJIxgkvcOtAL0cjAwMDw998fhoen5zF8f/+YAR3Arfj08gbD719fGRgYGBjEVBzgDmXhFJBj+P7hEdwHEhruDHwSOggj/v/////C+rz/zy6v+48OGBgYGABQQkIstTvoUgAAAABJRU5ErkJggg=="
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-159"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-160"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-198"
  }, /*#__PURE__*/React.createElement("image", {
    width: 9,
    height: 10,
    transform: "translate(5.21 3.22) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAICAYAAAArzdW1AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAtElEQVQYlW2OMQsBcRiHn1ekS8cNEsUVSQarzXCb2QfwGQw+h7L7DtxqO5tVbpCUMnCZZLlBeg34Rzzbr/f59f5EVXUbjIgvB95YjkvDGwIgIpJY+YMvASC+HDiFM5MTn8dMrkwqbQNw3gVco/BXqrT75Ksdk6PNHICk5bjm3W4xRu83I9n52nOXqurKH3xtshyXYrNLtthCRERUVa9RyH45AaBQ9yi1eqYgIoK+OK6n+g+AB5huVcdbbCMOAAAAAElFTkSuQmCC"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-199"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-195"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-200"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    height: 12,
    transform: "translate(4.49 7.06) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAJCAYAAAAPU20uAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAnElEQVQYlWO8sD7vPwMa0A+YyMDAwMDAyMjIyIQuycDAwHDrQC+czcTAwMAgIKnDICxjBBf8/uERw6cXVxgYGBgYWBgYGBjE1F0ZmNm4Gd4+Oc/AwACx8f6J2QgFD08uYGBkZoVLMjAwMHAKyCEU/Pz+HsUNihapDHwSOgwMDCUQBci61ByKURSzYOpCBYwfn1/+z8DAgF2SkZERAGouIPJHe0PAAAAAAElFTkSuQmCC"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-201"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-197"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-196"
  }, /*#__PURE__*/React.createElement("image", {
    width: 10,
    height: 11,
    transform: "translate(4.25 6.58) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAACXBIWXMAAC4jAAAuIwF4pT92AAAA1ElEQVQYlW2QoW7CcBDGf/enISkCqpZiqmBBlLAnWHCzYPYYIHgOBJp3YLNzlVjSCrKQLEHQBkUxkEwcAtpSwk/dXb58992Jqio34uiL/SbAdjxe+5NsjIiIBXBMIpL1D6fDFoDTYcsxiai7fiHehQvdbwKe0RvMckfzKBIxef0bTPPa3Iu8t0/a7yOMsUoRAKx74f85pVKtQXEff8v5dVMah5o1j9iOh9v5oNHsilV3fWzHyy/OeGn1afrDInv2x9X3uORSeo2IoDfSONRduNBnAFwAj/5nAO2IJiIAAAAASUVORK5CYII="
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-202"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-203"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-194"
  }, /*#__PURE__*/React.createElement("image", {
    width: 10,
    height: 11,
    transform: "translate(3.77 6.1) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAm0lEQVQYlWO8sD7vPwMWIKbiwCCpE8jABBPg4BZhEFWwYGBiZGZgYGBgeHXnAMOnF1cQCkRVHBmkDCIZ2LiF4Ka8uLGTgQXGeX59G8O7RycZfnx5jWIVXMGfX18Z/vz6CpdQtEhl4JPQYWASU3FA0cEpIAeXZGBgYGCR1Alk+PzmHsP3D4/gLkcGjP//////6cUVBgYGBrguZAAA8DksS+tawJsAAAAASUVORK5CYII="
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-189"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-193"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-187"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    height: 11,
    transform: "translate(3.29 5.38) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAKCAYAAABi8KSDAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAwUlEQVQYlaWQLQvCUBSGn/kBDuYYgnItQ0HEsGYxrpntJv+AwZ/jj5jVZrQKN4gIwsouWsYMizPInZuz+bRzzss573uMLMsygERJ1HlPGocUMR2Xsb8BoAEQyYD79cAv0jgkURJbeNQSJSvCltXFbIu8vh23ANRs4WE6bknsTpcMZqtSL5IBhvZ82q3zgdUZYtSbPB+XknejGFCf+6Y38ul7i3dAAG2n+A3TcRGTObbwAD6bNdqO3lakIk6UzC/9xQtqNUlnKtDA4wAAAABJRU5ErkJggg=="
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-190"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-191"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-186"
  }, /*#__PURE__*/React.createElement("image", {
    width: 10,
    height: 10,
    transform: "translate(3.29 4.66) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAwklEQVQYlWP8////fwYo+PTiCsP9E7MZGBgYGMRUHBgkdQJhUgwsMMatA70M3z88gku8unOAgVtElYFPQgeiENkUdPDixk64QiZ0RdwCsgxsHPwMDAwMDN8/PGL49OIKRCGngBxcESsbN4OyXQGDjEEoXAxmEJOaQzFc8PevrwxPzy9jeHl9B4otn15cYWD8////f1zu5BSQY5DQcGfgk9CB+JpPQoeBU0AOxdfowcPwHwlcWJ/3/+b+nv/YANZgwQYA8Vdld8K1BrYAAAAASUVORK5CYII="
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-184"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-188"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-185"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    height: 10,
    transform: "translate(3.05 3.94) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAHCAYAAAAxrNxjAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAq0lEQVQYlY3Ovw7BYBSG8afUnyZNGUQqpFMjho4uwGYUN1KDy3EPuAwbUptB0oRKLG0jIUKPhY/B4Dee8543R1vNfOElr5doegPi/ZL0tAXAqDq0e2NyfCkUTSqtLmbNVbNLHJIeN2hJFMhuMVGLYrnC/XYmyx6q0e700S3bw6g6XOIQgNs1UUd1t0fDGwKgiYgArOcjFXi3WLb3+UtekiiQ1cyXQzCVX/jXE2eRUQJef87IAAAAAElFTkSuQmCC"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-192"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-124"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-119"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    height: 11,
    transform: "translate(3.29 2.98) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAICAYAAAAvOAWIAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAuElEQVQYlXWPoQrCYBSFv63IigwE0aAwEDHYLMYFwexD7AlMPoRP4Du4vGa07w9DBGHB/Zh0QYNu1zAcbMwTz/nu4VxDRCTVCh0FvO4xdVn2kLG7BsBMteJy3DWCAK97TKpVAbd700rYsmwmiw2dwaz0dBQUMIAz98ogzzPy9xPJPpX2RPkYIiIAp8P275TfbvNn9CbLRtCZe+WDZTNAonxu5wMA3ZFLf7qqXkpN13AvjySs2yIi8gW1G24+b7vXZAAAAABJRU5ErkJggg=="
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-117"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-121"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-111"
  }, /*#__PURE__*/React.createElement("image", {
    width: 10,
    height: 10,
    transform: "translate(4.01 2.5) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJCAYAAADgkQYQAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAsklEQVQYlW2QsQqCUBSGv3szogiRKHCqXKLBuRrbeoymnqBX6C16iJaWmhrdNTAIBCGUJm2xwbIp6WLfdg7f4ZzzizRyi9g/kCUhX6zZCt20ARBCCBk4W0UAiP2DUkv+kCUhkberSt3BlOFkSU3WAbhfTzxiT5Ua7R6tjoWQtcraUrqd91yOG/L8WUrmeAGA9nvL650D0DT6jObrsi/SyC0CZ/v3/W8Emm7aNI0+gDL9ywc5uzRynSuylwAAAABJRU5ErkJggg=="
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-120"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-116"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    height: 12,
    transform: "translate(4.73 1.78) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAMCAYAAACwXJejAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAzUlEQVQYlW2RPQ/BYBSFn8hL0hCRoMHQGBBDB5u1m9nqb/gdVov/wGwziV0HRBADTQfxFSI+apBWX/Vs996Te5JzcHxsxl3nFwABcLRMlqMOLlm9jh8xG7S47tfewp4PiKaKxDO6twv5BS7WpC/NoYACuO7XbM2eLBJhhXS+SjgSk2yPlvkVRZN5cpUGMbX011YAnO05i2Gby271z/3z6fm6c7KnPB8376AWDEpG8/vJj5LQyJRrUgRCSWheTmrBCAQJgFvHYTsOVOLW8gbjDXadKhos5AAAAABJRU5ErkJggg=="
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-118"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-123"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-130"
  }, /*#__PURE__*/React.createElement("image", {
    width: 10,
    height: 11,
    transform: "translate(5.69 1.78) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAALCAYAAABCm8wlAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAwElEQVQYlW2Qvw7BUBSHv9tWqCBiKBaJRMLgAYwGYvYQ3sJTWL1DzTaj/RpEhKSDNhJJW0MHwzXgqj/fds7vO/klB/XkJF0V+VKlARCRL1WwXZKEHgDN3oRSrQuAEEIYx/VchwDBdkkagy+S0MPfLD4F07DI5it6ed6viIPNW6i2B7SHU3IF56fKAried5iZIrck/qh6C5cD18tBh3a5Qa0zAmYPIY3T6lPvjvVs2eUGSejpq9cPNJEv1Um66h8Ad1Q+apuiU+g4AAAAAElFTkSuQmCC"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-125"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-126"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-112"
  }, /*#__PURE__*/React.createElement("image", {
    width: 10,
    height: 11,
    transform: "translate(6.65 1.78) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAALCAYAAACzkJeoAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAt0lEQVQYlV3PoQ6CYBSG4VdEJ3M4g0MszGDQzWgwGGxmm8HqfXhFmgw27wHm2HQEgjA1gAYIbL8BQfCp79nZPsTXzdyJ0DNFkfzyLXz7SBS4KE+Hlj4mU13NatskDgFI4hCRxKjaCACJP/friZdv/WKj2UFRu/mBbx9/0Zis6U83eYwCF8/aIwN45wNStV56/346aXw/LqWgDeb0xss0ZpS2gT5c5HNkpW0QBW5+XVQJPVMApfGZDxYIUBDnBlnRAAAAAElFTkSuQmCC"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-114"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-128"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-127"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    height: 11,
    transform: "translate(7.37 1.78) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAYAAACprHcmAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA5UlEQVQYlXWQv2rCYBTFf41VGqQqEiSCCBYtghFXl4Kba/MQPoHP4eDsO+jsltG9GaSVFhw0hAwSKRZFvg4hn37+Odu958fh3oO4o9XH+Gr3yIVCz8WbT9ltlgAULVt6Crx2J/gLR87+wiFt1MiY1gm+TDuXN59KWAs9l5/Z6CYIsNssWbuTCP4NvhQzkUhRato8G1XlHACtaNnoubI0knqW/MsbWbOhhHw6Ax6EECI+JdZT2uDwF3I87uWuUO1E8K0mYum5Mq+d/qkNiPrcBt/Ko5V2TzYBoJ2nmPWuTGu9DxUQ4B+KToBB1F98dQAAAABJRU5ErkJggg=="
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-113"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-115"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-129"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    height: 11,
    transform: "translate(9.05 3.46) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAv0lEQVQYlW2PsQqCQACGP8UKG8QlqaAgEIkQWhtdoqWhHqIn6DkcmnuIXuHG1sBJgqChRCikoWiyJa+z+ra7/+O/+7U8z3Pe3JKIw3YNwHC2QkUrxFiEPLKjDEy7ixcs5dlQW1Qe2ZFbEmE1fQD0f1KBmulqUKlZtL0xRrUu72IR/oqW49EYTKnbnZ8vGI4bkO4FANlpx/N+4X4tj5KrvxcXOG5Ay59/nm72JyXBtLv0RgspyUaAc7Qh3YtSi8oLGZZOMSw9mcUAAAAASUVORK5CYII="
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-172"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-171"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-207"
  }, /*#__PURE__*/React.createElement("image", {
    width: 12,
    height: 12,
    transform: "translate(8.81 4.18) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAt0lEQVQYlXWPPwqCABjFf4YSDolTfyCEIGrxAG11hbpDJ+gcQXt3qCs4NqdTRJGDRgRpEdL0NRSiab/p473Hx3tK4K7ksncoozOYYjRtACr/QgDHzTK9K1lDq9ZodIeomp5qO2deDBr1Pk17gm62Uy2JfO5nD1U3LZLIByAKtryeC563U6GGEoeuZLtk0U2L3mj2CYqIhN6a31HZxQAqQMse87geSCI/9yWHfIlDVwJ3Jf8o7VbGGyT/Xy4F3xA0AAAAAElFTkSuQmCC"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-208"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-204"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-205"
  }, /*#__PURE__*/React.createElement("image", {
    width: 12,
    height: 12,
    transform: "translate(8.81 4.9) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAJCAYAAAALpr0TAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAqUlEQVQYlX2QsQ7BUABFT6VEDW0HoUI6SXRo4hds2PgRvsRg9hF8gtGG6GSRlERNqonU9kyeNlVnPLm5ubnKbjkR/KE7mgNQSMpi2aDpDFBLFemO61k2aNQ7VJ0hmtGSLg59osBD1UybOPQBuF+2vKIbz/Asg5ppA6AIIcR+Nf25r9bu0XDH32AUeJw2i1SL5fTRLVc6FUC3XD4Tki0pRILH9SDyyHkvyxuSq1W/fuDvJgAAAABJRU5ErkJggg=="
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-173"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-206"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-209"
  }, /*#__PURE__*/React.createElement("image", {
    width: 10,
    height: 10,
    transform: "translate(9.05 5.86) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAGCAYAAAARx7TFAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAm0lEQVQImV3OMQqCABjF8b9WpFAqFCINghFOHqApHLpKqw0dp0PYCaKx0XAVghbBKYMQivpaxLLf+HgPnpLEkVDraSb2dEGR7Xk+7gDYsxCVH4ORx9hfopmTJiuyA0qZp3I+bgFQlQ79oU11y5uSbrl0DSdAt1yq64W3vFoFb77CcAIUERGA027dWvvh5vtDamWeShJHUuap/PsAlfpJWCfLZPMAAAAASUVORK5CYII="
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-210"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-179"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-174"
  }, /*#__PURE__*/React.createElement("image", {
    width: 10,
    height: 10,
    transform: "translate(9.05 6.58) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJCAYAAADgkQYQAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAzklEQVQYlWP8////fwYGBoZPL64w3D8xmwEGFC1SGfgkdBgYGBgYGP//////1oFehu8fHjGgA/2AiQwMDAwMzIEG7xv+/PiIoQBi+jUGYQUrBiZkQVYOfgYpDU8GFlZOBgYGBobvHx4xfHpxBVURn5gqg6iGBwMHnyRc7P6J2QyMH59f/g9zMDMTCwM7rzjDt49P4Yo4BeQYWPgkdBg4BeQYvn94xPD33x8UBTAfMsKC4OKGfBTdag7FCHf8h4KPzy//v7A+7//H55f/owMABdFh1WJJ8F4AAAAASUVORK5CYII="
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-175"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-183"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-177"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    height: 10,
    transform: "translate(9.05 7.3) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAICAYAAADA+m62AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAtUlEQVQYlW2PsQqCYBRGj1aGSFYU1BBCBE21N/oKPURrDT2OD1FrW2NjoYNDELj80qQ1uFS3JSSzM33c7/DB1VLlSxzuyJKIX4azBXZ/AoB+OXh/JYA43OVZ/y4Ms81gOqdmWABkSYQKNmWx2RvTGbnUG738dj3vucUBWqp8uRw8ACp6FcPqkt3jXDRbDmN3TdXuTzBbDlkS8Xw9CtL3M5qICMBpuyqtFJAPqfLluFlKqnz5xxv1/175lRT8JwAAAABJRU5ErkJggg=="
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-182"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-181"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-180"
  }, /*#__PURE__*/React.createElement("image", {
    width: 10,
    height: 10,
    transform: "translate(7.13 9.22) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAICAYAAAArzdW1AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAtElEQVQYlW2PvQqCABRGjz9JOkQ1hC1CBE1Cq2NPEPUQPkHP0dDsO9Tc1uhuQ0QkOGREg9bQJLeh0IrOdj/OvdxPydNIzrs1jyzhl+FkAYAah8FfAWC/mb+kz1DT6nT6I/SaCcAjS7idt6hm0yklw2phu2MMq11mcRig5GkkcRhU1xSNQopy7nk+iohIul1xOWy+/jGbDoPRDAAdoOtOuV+PZYGe59Ow3WpD3uRpJKdoKf94AiKcWGAjHBDqAAAAAElFTkSuQmCC"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-176"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-178"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-133"
  }, /*#__PURE__*/React.createElement("image", {
    width: 10,
    height: 10,
    transform: "translate(3.53 9.22) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAYAAAA1BOUGAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAfklEQVQImWO8sD7vPwMUcArIMag5FDMwMDAwMDIyMjIxIIHvHx4xPL+yHs5nYuUUZBBXtoMLvLpzgOHTiysQSS5+CQZhFScGZmY2uIIXN3ZCjEa2E2avhIY7A7+kLiMLsoSYigODpE4gnM+CrJpPQocBBTy7vO4/NsDAwMAAABxDL7Cqe5iWAAAAAElFTkSuQmCC"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-131"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-149"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-145"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    height: 11,
    transform: "translate(1.85 8.98) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAICAYAAAArzdW1AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAkUlEQVQYlWO8sD7vPwMOoB8wkYGBgYGBCVmQnUuIgZ1LCM6/daAXU5GCeSKDgnkSnP/9wyOGTy+uMLAgK3pxbRsDAwMjipVf39xmYHx2ed3/V3cOYHWTokUqA5+EDgOLpE4gw+c39xi+f3gEl+QUkGNQcyiG85kYGBgYJDTcUXQjK2BgYGBg+A8FH59f/o8LAADUkkZj43CcSAAAAABJRU5ErkJggg=="
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-144"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-150"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-146"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    height: 11,
    transform: "translate(.89 7.54) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAKCAYAAABmBXS+AAAACXBIWXMAAC4jAAAuIwF4pT92AAAArklEQVQYlXWQsQqCYBSFP3//AhdxdEloaXJsaIxeo7knCHqKfIKeoifIsV2XXAIbdGhQESQI/5YUTfu2e+6Bc8/VlFIKIPI9qiwGwLAcFus9DbJIQ+7XE12qLKZIQ0zbBUD8Ghq6uugudH2KLibtHPle3ySEZLE5MFtuB7GyEer6TZkGvMrnIFZ2hUdw7hmallqeBGrs+Plq17aTpu1iWM7fHwGgvtwuR5UngRrjA+KlXuBNGbXlAAAAAElFTkSuQmCC"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-147"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-132"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-148"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    height: 11,
    transform: "translate(.41 7.06) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAYAAAA1BOUGAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAjElEQVQImWO8sD7vPwMSEFNxYJDUCWRgYGBgYGJgYGDg4BZhYGZmY2BgYGB4decAw6cXVyCS7NzCDGouVQySml5w3S9u7GRgYGBgYPnz4xPD2zv7GD49vwqX/P7hEcOnF1cYWP7+/c3w9OoWuASngByDhIY7A5+EDgMLLscwMDBAJJFVo4CPzy//xwUAsEE/PhzUvq8AAAAASUVORK5CYII="
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-137"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-136"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-139"
  }, /*#__PURE__*/React.createElement("image", {
    width: 10,
    height: 10,
    transform: "translate(-.07 6.58) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJCAYAAADgkQYQAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAxUlEQVQYlWWPsWrCYBRGz5/YQRApiCUuHWotBQM+QcGta/sidehr6NDZd2hcncyYsRIHGwpSh2pBMBGp49dB/CHxTPdyz3CPkSSAJBxwSJcAdJ7eOGGMMSZbxVrPx1YAKF9ec9d9tZKziIY5AeCQLtmtZ3Z3ToPrXlCp3eA4JQAW0fBcqnptmg89KvWWPSbhIC/tN1/8zgL+tt8UMZ+Tvoo/AVzddmn4z8c6SZqOerky7/6RqufbOiQpW8X6CF70E7+rCMA/YhdYiF1937AAAAAASUVORK5CYII="
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-143"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-138"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-141"
  }, /*#__PURE__*/React.createElement("image", {
    width: 14,
    height: 13,
    transform: "translate(-1.03 5.62) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAAACXBIWXMAAC4jAAAuIwF4pT92AAAA3ElEQVQokWP8////fwYo+PTiCsP9E7NhXAZFi1QGPgkdBmTAyMjIyAjTdOtAL8P3D48Y0IF+wERMTR+fX/6PbDo64BSQY1BzKEbRxIRPAwMDA8P3D48YPr24giLGhFcHFKAbjKGJlY2bQcEkhoGTTxJF/PmV9bg1sXAKMPBJGzFwCciiiL+6cwDuTMZnl9f9f3XnAJptvAy/f31GERNTcWCQ1AlEBDmu4GZggISehIY7PL7gmtAjFd10ZIASuc+vrGeAORPddHRNDP+RwIX1ef+fXV73Hx/A6gdiAAC2oIR4QN0FbwAAAABJRU5ErkJggg=="
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-140"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-142"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-135"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    height: 11,
    transform: "translate(-.79 5.38) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAKCAYAAABi8KSDAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAx0lEQVQYlX2QsQ7BYBSFv78pQkI6NTWQSBCJPoBRLEbxEGaP4gE8BKvNaEUHg0RCoo2FSqQxXVP/FOWb7rk59+bcq0J/K8FuQXQ78kmtM6LkuAAopZRxWE1TjQDBbvGmjaTI5IqUGz3MbAGA6HbE92bp5qLdxG4PKFgV3bvsl9wDDwAzb1V1jPC84fmYEF1P2py3qrpWIiLr+Tg1s13vUnaH+kAlInIPPA6r6ds2p9XXn4jNJkDJcYnjJLd9IQlCfyu/SJ/+wwvfs2XIml+X+QAAAABJRU5ErkJggg=="
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-134"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-238"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-232"
  }, /*#__PURE__*/React.createElement("image", {
    width: 10,
    height: 11,
    transform: "translate(-.79 4.66) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAALCAYAAABGbhwYAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA3ElEQVQYlW2QP2vCUBRHz42xNCAlg5ZIIVLp0CEgLsWhg5trnTv343To7IdwdikZsyulFKmQJVYcYjpkvB3kPWrMmR7vnXf//ERVFSBbzdmtYwy3oxeugggAERE5ZEvdfi4o85Qqg6c3KzqbZFYrAXzFr/bs/H9oXvq0ew80HBeAMk8ptqtzsdN/5Gb4zEWrY+82yQwA1/ND23q3fqf4+aAsMit6fnic85At1fyqcn03phtNj1urqlaj8fyQ4H5yEo8L0I2m/O6/KfPUVqkiJnCznalyIolI7Wx1/AFgfE83GK2c5QAAAABJRU5ErkJggg=="
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-240"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-241"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-236"
  }, /*#__PURE__*/React.createElement("image", {
    width: 12,
    height: 12,
    transform: "translate(-1.03 3.7) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAMCAYAAAC0qUeeAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA/0lEQVQokWP8////fwYkcOtALwMDAwODmkMxsjADIyMjIyNM8acXVxjun5gNlxRTcWCQ1AlEUcwCM+37h0coJr26c4CBW0SVgU9CBy7GdHFDPoZCGHhxYycKnwmrKij4/uERw/Mr67ErZmZmY5DR9mPg5pdGcc6nF1cYGBgYGFiQFbNx8DEIKdsz/P31jeHrx6cYzmHiFJBDWPv1DcON3c0ML+/uR3GOhIY7RDGMAQO/vn9g+PfvLwMDAwMDp4Acg37ARHiIMP7/////8yvrGV7dOYCiSdEiFSXY4OEsqRPI8PnNPYbvHx4xcArIYcQeXANyDDIwMKCYhqKQkZERAJBfXK6uWMcvAAAAAElFTkSuQmCC"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-235"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-234"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-237"
  }, /*#__PURE__*/React.createElement("image", {
    width: 12,
    height: 12,
    transform: "translate(-.55 2.98) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJCAYAAADgkQYQAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAq0lEQVQYlXWPsQ7BYBRGz9+UpIg0JE0lUouIoZPEbjPbPYOn8RzMNotdooNEY+igDSJF6IIaJL+09Gz3fufemyuW01FMCqPZo2YPABBCCCUtAOzdOZfAkbUCoKoaVatLLl+UQbCeJaVCpUG9M6RktGQQhR6+MwVABbgdXbaLMfeT9+/6R3q+HlwPG9nUdAuz3ads2l8p6zO5SdMtotD7mU5w9lfxbjWJswB4AyGlRUQB6Vt5AAAAAElFTkSuQmCC"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-233"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-231"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-228"
  }, /*#__PURE__*/React.createElement("image", {
    width: 10,
    height: 10,
    transform: "translate(.41 2.74) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAKCAYAAACXDi8zAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAh0lEQVQImWP8+Pzy//snZjNwCsgxqDkUM8AA0/0TsxkYGBgYvn94xPDpxRWEBAMSgCnCkGBgYGC4daAXIsEnpsogIm8Bl4AZyfjpxeX/3EJKDNd21DP8/fsLroDl8dllDMxs3CiCnAJyDCy/f31l+P3rK1xQ0SKVgU9Ch4EFWRWyP1iQVSEDAI6BMOnqTh+RAAAAAElFTkSuQmCC"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-230"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-229"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-223"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    height: 11,
    transform: "translate(2.57 2.5) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAKCAYAAACJxx+AAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAvklEQVQYlW2QqwrCABRAz6ZFBVnQMctEmGAQxCamNas2f8BPsWnwRzQLgvuHLfhKBh1iGAMRFL2G4XyedOEcLtyriIiEvoe/mHIOtpQaPbJGlSfKzh3LYePwTq09imf1WwKsnOEr+LHAOdiy9yavQFUTFOtd8qVmHB02DqHvkQRQlARpvQLIx6bTcR0Ft9uF1ayPyD2WKc0kkytHQRRdY6lbNoVqB4Ckbtk8L0lpJkal9fEHRESW84Hs3LH84wHKtldYYpoLQAAAAABJRU5ErkJggg=="
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-226"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-227"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-225"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    height: 11,
    transform: "translate(1.85 2.5) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAKCAYAAABmBXS+AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAvUlEQVQYlWP8/////08vrjDcPzGbAQbEVBwYJHUC4XyWWwd6Gb5/eMSADF7dOcDALaLKwCehw8DAwMDAhK4ABl7c2AlnMyGEGRm4BWQZmJlYGRgYGBi+f3jE8PzKelRFvKIqDCoOJQwC0voo1qIo+v7xGcPrGzsYPr2+jWLtpxdXGFhgnD+/vjI8u7EdLskpIMcgoeHOwCehw8D48fnl/8jexxoEfBI6DJwCcgzfPzxC0Y0C/kPBs8vr/uMCAONBYJjz8k9zAAAAAElFTkSuQmCC"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-224"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-221"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-222"
  }, /*#__PURE__*/React.createElement("image", {
    width: 12,
    height: 12,
    transform: "translate(.89 2.26) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAw0lEQVQYlW2QMQrCUBBEXyQKUYgpRCKClYpF8AzprPUiFnobDxFbO+1sxV9YBIQ0+YhFTBPBYq3yUeNUO+xjdxhLRCTXCn3ZUWQJpbrDkF4wN95OVcQt3vOrW7yn1Rnh+gEAtX9QKX3Zmbn2uag3WjTbfeOLLCFVURXsTxcMwzUNx/uKkGuF/Qne4wNFlvB65pUY1iM9y/W4+ZvR8Qb4kxmuH2C7foDjDb6qgWo9logIwGm7NFfG4ar6ugRzrQBMb796A/f/R+4FOR/0AAAAAElFTkSuQmCC"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-214"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-218"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-217"
  }, /*#__PURE__*/React.createElement("image", {
    width: 9,
    height: 9,
    transform: "translate(7.37 3.22) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAHCAYAAADam2dgAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAp0lEQVQYlWWOPQrCQBhEX8xGDKJYyQbBSiXFHiKdrbmIjefwBN7BXCGlpZBUIgopjIiFP0XKz0JZQnzlzDAzjojI65pz3m2o4w/GzKIVAOqQrqkeBU2qR8HrmtPXhlbd8NpdRmaB8nwA297S4dyGXM+nN5ziqo7VyjzBEREp84TbMf2bHE4iAhOjAAIT876f7Dd/MEaHc/rafNPy41lmsk+Wcsm20uQD9hJOKqcJpR8AAAAASUVORK5CYII="
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-220"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-219"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-213"
  }, /*#__PURE__*/React.createElement("image", {
    width: 8,
    height: 8,
    transform: "translate(11.21 3.46) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAYAAAA1WQxeAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAmUlEQVQImWP8+Pzy/xc3djJ8//CIAQYULVIZ+CR0GBgZGRmZ7p+YjSLJwMDAcP/EbDibCcZg4xRkkNHxZ2BiYmFgYGBguHWgF10BPwOXiDIDIyMzAwMDA9xUxmeX1/1/decAAzpQtEhl4JfUZWSR1Alk+PzmHlwHp4Acg5pDMULl/////398fvn/hfV5/z8+v/wfGTAwMDAAAASHP8lILmQwAAAAAElFTkSuQmCC"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-211"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-212"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-215"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 18,
    transform: "translate(4.25 8.02) scale(.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAPCAYAAAAGRPQsAAAACXBIWXMAAC4jAAAuIwF4pT92AAABTElEQVQ4jY2TP08CQRDF39wBsoQ/l2jgaM5gzEWTS6xMKCwoTGy1t6WxsfBzUFj7JfwCJpR2xkgsrjEhRqEggUuQCwTOamXZHcBXzs7+8t7OLCVJkkBT2G5hMuzqZQCAcDz4jTujTkSUUgtRr4OP5wcWIjUZdhH1Oii6gQmUzja54XRyeW84o9H3W7LNDSc9LhGRtQlk22mIgotMtmScybiqLOF4LMgiGxX/HLWzG+yfXiObLxs9uhGLmwwA2BmBfOUY6Z0Scrs+csUq2xe2W0sYANTqTaNpPp1g3H/HLB5iPAjxE32xMDVuCgCKbgDheCvTXCRz9MInDD5fsJjFmMYjFiYc729NSF3a18db9sI61erNJYiIVmD/WVrpRn9r4wdwcXWIe3TBbj+gxZTi4pYPG6gGV2vdGjGl1Ljb3KiwFHcg4xb2Dja60fUL9ceERogwWB0AAAAASUVORK5CYII="
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "cls-216"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 9.84,
    y: 16.57,
    width: 0.64,
    height: 0.75
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-239"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 10.98,
    y: 17.49,
    width: 2.86,
    height: 2.78
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGerrbi);
export default __webpack_public_path__ + "static/media/gerrbi.ff23a3353de37c1a160e7b4c0bc4cc89.svg";
export { ForwardRef as ReactComponent };